import React, { useState, useEffect, useCallback, useMemo } from "react";
import { getAuth, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { getFirestore, collection, addDoc,   writeBatch, getDocs, query, where, doc, updateDoc, orderBy, deleteDoc, limit, onSnapshot } from "firebase/firestore";



import { format, parseISO, isToday, isAfter, isBefore, addDays, set, add } from 'date-fns';
import { Badge, List, Avatar, Divider, Typography, Alert } from 'antd';
import { BellOutlined, CalendarOutlined, ExclamationCircleOutlined } from '@ant-design/icons';


import { jsPDF } from "jspdf";

import autoTable from "jspdf-autotable";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


import dayjs from "dayjs";
import './body.css';


import { Eye, Download } from "lucide-react";

const db = getFirestore();

const { Title, Text } = Typography;

const Body = () => {

  const [followupStatus, setFollowupStatus] = useState({});
  const [statusInput, setStatusInput] = useState({});
  const [visitFilter, setVisitFilter] = useState("all");



  
// Settle Invoice States
const [searchInvoiceNo, setSearchInvoiceNo] = useState("");
const [foundInvoice, setFoundInvoice] = useState(null);
const [settleAmount, setSettleAmount] = useState("");
const [balanceAfterSettle, setBalanceAfterSettle] = useState(0);

  const [eyeExams, setEyeExams] = useState([]);

  useEffect(() => {
    // Listen for invoices
    const qInvoices = query(collection(db, "invoices"), orderBy("createdAt", "desc"));
    const unsubInvoices = onSnapshot(qInvoices, (snapshot) => {
      setInvoices(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    // Listen for patients
    const qPatients = query(collection(db, "patients"), orderBy("createdAt", "desc"));
    const unsubPatients = onSnapshot(qPatients, (snapshot) => {
      setPatients(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    // Listen for eye exams
    const qEyeExams = query(collection(db, "eyeExams"), orderBy("createdAt", "desc"));
    const unsubEyeExams = onSnapshot(qEyeExams, (snapshot) => {
      setEyeExams(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    // Clean up all listeners on unmount
    return () => {
      unsubInvoices();
      unsubPatients();
      unsubEyeExams();
    };
  }, []);








  const [selectedOption, setSelectedOption] = useState("addPatient"); // Default to "home"
  const [userDetails, setUserDetails] = useState(null); // Define userDetails state
  const auth = getAuth(); // Initialize Firebase Auth
  const navigate = useNavigate(); // Initialize navigate
  const db = getFirestore(); // Initialize Firestore



//fetch all the eye exam report
const [eyeExamRecords, setEyeExamRecords] = useState([]);
const [selectedRecord, setSelectedRecord] = useState(null);


//search function in view eye report
const [filterOption, setFilterOption] = useState('all');


const [settleDate, setSettleDate] = useState("");


// Add Patient 
  const [formData, setFormData] = useState({
    name: '',
    dateOfBirth: '',
    sex: '',
    telephoneNo: '',
    mobileNo: '', 
    email: '',
    address: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, 'patients'), formData);
      alert('Patient added successfully!');
      // Reset form
      setFormData({
        name: '',
        dateOfBirth: '',
        sex: '',
        telephoneNo: '',
        mobileNo: '', 
        email: '',
        address: ''
      });
    } catch (error) {
      console.error('Error adding patient: ', error);
      alert('Error adding patient');
    }
  };



//Fetch all patients

const [patients, setPatients] = useState([]);
const [loading, setLoading] = useState(true);

useEffect(() => {
  const unsubscribe = onSnapshot(collection(db, "patients"), (snapshot) => {
    const patientsData = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));
    setPatients(patientsData);
    setLoading(false);
  }, (error) => {
    console.error("Error fetching patients:", error);
    setLoading(false);
  });

  return () => unsubscribe();
}, []);


// State variables
const [searchTerm, setSearchTerm] = useState("");
const [editingPatient, setEditingPatient] = useState(null);
const [filteredPatients, setFilteredPatients] = useState([]);

// Filter patients based on search term
// Filter patients based on search term
useEffect(() => {
  const term = searchTerm.trim().toLowerCase();

  // If search is empty → show all patients
  if (!term) {
    setFilteredPatients(patients);
    return;
  }

  const filtered = patients.filter((patient) => {
    const name = patient.name?.toString().toLowerCase() || "";
    const tel = patient.telephoneNo?.toString() || "";
    const mobile = patient.mobileNo?.toString() || "";

    return (
      name.includes(term) ||
      tel.includes(term) ||
      mobile.includes(term)
    );
  });

  setFilteredPatients(filtered);
}, [searchTerm, patients]);

// Handle patient update
const handleUpdatePatient = async (e) => {
  e.preventDefault();
  try {
    const patientRef = doc(db, "patients", editingPatient.id);
    await updateDoc(patientRef, editingPatient);
    setPatients(patients.map(p => p.id === editingPatient.id ? editingPatient : p));
    setEditingPatient(null);
    alert("Patient updated successfully!");
  } catch (error) {
    console.error("Error updating patient: ", error);
    alert("Error updating patient. Please try again.");
  }
};



// Add this function to delete a patient
const handleDeletePatient = async (patientId) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this patient record?");
  if (!confirmDelete) return;

  try {
    await deleteDoc(doc(db, "patients", patientId));
    setPatients(patients.filter(patient => patient.id !== patientId));
    alert("Patient deleted successfully!");
  } catch (error) {
    console.error("Error deleting patient: ", error);
    alert("Failed to delete patient.");
  }
};




// Export to Excel
const handleDownloadPatients = () => {
  if (filteredPatients.length === 0) {
    alert("No patient data to download.");
    return;
  }
  
  const worksheet = XLSX.utils.json_to_sheet(filteredPatients);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Patients");
  XLSX.writeFile(workbook, "patient_records.xlsx");
};







// to create invoice
// ------------------ STATE ------------------
const [to, setTo] = useState(""); // Patient name
const [patientPhoneNo, setPatientPhoneNo] = useState(""); 
const [paymentMethod, setPaymentMethod] = useState("Cash");
const [date, setDate] = useState(""); 
const [frame, setFrame] = useState("");
const [lens, setLens] = useState("");
const [brand, setBrand] = useState("");
const [rightLens, setRightLens] = useState("");
const [leftLens, setLeftLens] = useState("");
const [addPower, setAddPower] = useState(""); 
const [pd, setPd] = useState("");
const [seg, setSeg] = useState("");
const [amount, setAmount] = useState(""); 
const [deductAmount, setDeductAmount] = useState(""); 
const [totalAmount, setTotalAmount] = useState(0); 

const [invoiceNumber, setInvoiceNumber] = useState("2001");
const [nextInvoiceNumber, setNextInvoiceNumber] = useState(2002);

const [patientSearch, setPatientSearch] = useState("");
const [filteredPatientList, setFilteredPatientList] = useState([]);

// ------------------ PATIENT SEARCH ------------------
useEffect(() => {
  if (!patientSearch) {
    setFilteredPatientList([]);
    return;
  }
  const term = patientSearch.toLowerCase();
  const results = patients.filter((p) =>
    p.name?.toLowerCase().includes(term) ||
    p.telephoneNo?.includes(term)
  );
  setFilteredPatientList(results.slice(0, 8));
}, [patientSearch, patients]);

const handlePatientClick = (patient) => {
  setTo(patient.name);
  setPatientPhoneNo(patient.telephoneNo);
  setPatientSearch(patient.name);
  setFilteredPatientList([]);
};

// ------------------ FETCH LATEST INVOICE NUMBER ------------------
useEffect(() => {
  const fetchLatestInvoiceNumber = async () => {
    try {
      const invoicesRef = collection(db, "invoices");
      const q = query(invoicesRef, orderBy("invoiceNo", "desc"), limit(1));
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        const latestNumber = parseInt(querySnapshot.docs[0].data().invoiceNo);
        if (!isNaN(latestNumber) && latestNumber >= 2001) {
          setInvoiceNumber((latestNumber + 1).toString());
          setNextInvoiceNumber(latestNumber + 2);
        }
      } else {
        // If no invoices exist, start from 2001
        setInvoiceNumber("2001");
        setNextInvoiceNumber(2002);
      }
    } catch (error) {
      console.error("Error fetching invoice number:", error);
    }
  };
  fetchLatestInvoiceNumber();
}, []);

// // ------------------ PDF GENERATION FUNCTION ------------------
// const generateinvoicePDF = (invoiceData) => {
// const doc = new jsPDF({
//   orientation: "portrait",
//   unit: "mm",
//   format: [80, 160]   // 80mm receipt
// });

// const pageWidth = doc.internal.pageSize.getWidth();
// let y = 10;

// // Logo
// doc.addImage("/invoice logo.png", "PNG", 30, y, 20, 20);
// y += 25;

// // Title
// doc.setFont("helvetica", "bold");
// doc.setFontSize(12);
// doc.text("INVOICE", pageWidth/2, y, {align:"center"});
// y += 8;

// // Details
// doc.setFontSize(9);
// doc.setFont("helvetica","normal");

// doc.text(`Invoice: ${invoiceData.invoiceNo}`, 5, y);
// y += 5;
// doc.text(`Date: ${invoiceData.date}`, 5, y);
// y += 5;
// doc.text(`Patient: ${invoiceData.to}`, 5, y);
// y += 8;

// // Divider
// doc.line(5, y, pageWidth-5, y);
// y += 6;

// // Items
// if(invoiceData.frame){
// doc.text(`Frame: ${invoiceData.frame}`,5,y);
// y+=5;
// }

// if(invoiceData.lens){
// doc.text(`Lens: ${invoiceData.lens}`,5,y);
// y+=5;
// }

// if(invoiceData.description){
// const lines = doc.splitTextToSize(invoiceData.description, 70);
// lines.forEach(line=>{
// doc.text(line,5,y);
// y+=4;
// });
// }

// y+=4;
// doc.line(5, y, pageWidth-5, y);
// y+=6;

// // Amounts
// doc.text(`Amount`,5,y);
// doc.text(`Rs ${invoiceData.amount.toFixed(2)}`,pageWidth-5,y,{align:"right"});
// y+=6;

// doc.text(`Advance`,5,y);
// doc.text(`Rs ${invoiceData.deductAmount.toFixed(2)}`,pageWidth-5,y,{align:"right"});
// y+=6;

// doc.setFont("helvetica","bold");
// doc.text(`BALANCE`,5,y);
// doc.text(`Rs ${invoiceData.totalAmount.toFixed(2)}`,pageWidth-5,y,{align:"right"});
// y+=20;

// // TERMS AND CONDITIONS
// doc.setFont("helvetica", "bold");
// doc.setFontSize(7);
// doc.setTextColor(0, 0, 0);

// const terms1 = "*THIS RECEIPT VALID ONLY 14 DAYS FROM DATE OF ORDER. ITEMS ONCE SOLD CANNOT BE RETURNED. ADVANCE PAID WOULD NOT BE REFUNDED.";
// const terms2 = "*THANK YOU VERY MUCH FOR GETTING THE SERVICE FROM OUR COMPANY.";
// const terms3 = "/ STYLE THAT MAKES SENSE THAT'S EKANAYAKE OPTICIAN FASHIONABLE EYEWEAR FOR YOU.";

// const termsLines1 = doc.splitTextToSize(terms1, 70);
// termsLines1.forEach(line => {
//   doc.text(line, pageWidth/2, y, {align:"center"});
//   y += 3.5;
// });

// y += 1;

// const termsLines2 = doc.splitTextToSize(terms2, 70);
// termsLines2.forEach(line => {
//   doc.text(line, pageWidth/2, y, {align:"center"});
//   y += 3.5;
// });

// y += 1;

// const termsLines3 = doc.splitTextToSize(terms3, 70);
// termsLines3.forEach(line => {
//   doc.text(line, pageWidth/2, y, {align:"center"});
//   y += 3.5;
// });

// y += 2;

// // Footer
// doc.setFont("helvetica","normal");
// doc.setFontSize(8);
// doc.setTextColor(0, 0, 0);
// doc.text("Ekanayake Optical", pageWidth/2, y, {align:"center"});
// y+=4;

// doc.text("Nawalapitiya Road, Gampola", pageWidth/2, y, {align:"center"});
// y+=4;

// doc.text("076 5541048 / 0713760878", pageWidth/2, y, {align:"center"});

// doc.save(`Invoice_${invoiceData.invoiceNo}.pdf`);

// };




const generateinvoicePDF = (invoiceData) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a5"
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  let y = 6;

  // ------------------------------
  // HEADER LOGO
  // ------------------------------
  doc.addImage("/new logo.png", "PNG", 10, y, 38, 38);

  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(11);
  doc.text("Ekanayake Optical", pageWidth - 10, 20, { align: "right" });

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
  doc.text("Nawalapitiya Road, Gampola", pageWidth - 10, 27, { align: "right" });
  doc.text("Phone: 076 5541048 / 0713760878", pageWidth - 10, 33, { align: "right" });
  doc.text("Email: ekanayakeopticians@gmail.com", pageWidth - 10, 39, { align: "right" });

  y = 53;

  // ------------------------------
  // WATERMARK
  // ------------------------------
  // const imgProps = doc.getImageProperties("/watermark.png");
  // const watermarkWidth = 180;
  // const watermarkHeight = (imgProps.height * watermarkWidth) / imgProps.width;
  // const centerX = pageWidth / 2 - watermarkWidth / 2;

  // doc.setGState(new doc.GState({ opacity: 0.05 }));
  // doc.addImage("/watermark.png", "PNG", centerX, 90, watermarkWidth, watermarkHeight);
  // doc.setGState(new doc.GState({ opacity: 1 }));

  // Divider
  doc.setLineWidth(0.3);
  doc.line(10, y, pageWidth - 10, y);
  y += 6;

  // ------------------------------
  // INVOICE TITLE
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(16);
  doc.text("INVOICE", pageWidth / 2, y, { align: "center" });
  y += 12;

  // ------------------------------
  // CUSTOMER DETAILS
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(9);
  doc.text(`Patient: ${invoiceData.to}`, 10, y);
  y += 7;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(10);
  doc.text(`Date: ${invoiceData.date}`, 10, y);
      y += 5;
  //  doc.text(`Job No: ${invoiceData.jobNo}`, 10, y);

  doc.text(`Invoice No: ${invoiceData.invoiceNo}`, pageWidth - 10, y, { align: "right" });
  y += 12;

  // ------------------------------
  // TABLE HEADER (BLUE)
  // ------------------------------
  doc.setFillColor(32, 30, 244);
  doc.setTextColor(255, 255, 255);
  doc.rect(10, y, pageWidth - 20, 7, "F");

  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);
  doc.text("Description", 12, y + 5);
  doc.text("Amount (Rs)", pageWidth - 12, y + 5, { align: "right" });
  y += 15;

  doc.setTextColor(0, 0, 0);

  // ------------------------------
  // TABLE BODY
  // ------------------------------
  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(10);

  if (invoiceData.frame) {
    doc.text(`Frame: ${invoiceData.frame}`, 12, y);
    y += 6;
  }

  if (invoiceData.lens) {
    doc.text(`Lens: ${invoiceData.lens}`, 12, y);
    y += 6;
  }

  if (invoiceData.description) {
    const lines = doc.splitTextToSize(invoiceData.description, pageWidth - 30);
    lines.forEach((line) => {
      doc.text(line, 12, y);
      y += 5;
    });
  }

  y += 5;
  doc.line(10, y, pageWidth - 10, y);
  y += 5;

  // ------------------------------
  // PAYMENT SUMMARY
  // ------------------------------
  doc.text("Subtotal:", pageWidth - 55, y);
  doc.text(`Rs ${invoiceData.amount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 7;

  doc.text("Advance:", pageWidth - 55, y);
  doc.text(`Rs ${invoiceData.deductAmount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 7;

  doc.text("Balance:", pageWidth - 55, y);
  doc.text(`Rs ${invoiceData.totalAmount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 8;

  // ------------------------------
  // TERMS
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(9);
  doc.text("Terms & Conditions:", 10, y);
  y += 6;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(8);
  doc.text("* THIS RECEIPT VALID ONLY 14 DAYS FROM DATE OF ORDER.", 12, y); y += 5;
  doc.text("* ITEMS ONCE SOLD CANNOT BE RETURNED.", 12, y); y += 5;
  doc.text("* THANK YOU VERY MUCH FOR GETTING THE SERVICE FROM US.", 12, y); y += 5;
  doc.text("*  STYLE THAT MAKES SENSE THAT'S EKANAYAKE OPTICIAN FASHIONABLE EYEWEAR FOR YOU.", 12, y); y += 8;
  y += 5;


//   const footerHeight = 35;
//   const footerY = pageHeight - footerHeight - 5;



//   // QR (Left)
//   doc.addImage("/qr-kingdom.png", "PNG", 10, footerY + 10, 25, 25);

//   // "SCAN ME" text (Center)
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(11);
//   doc.setTextColor(0, 0, 0);
  

// doc.setFont("Times New Roman", "Bold");
// doc.setFontSize(12);
// // Move "SCAN ME" to start at x = 50
// doc.text("SCAN ME", 37, footerY + 19);

// doc.setFontSize(10);
// doc.setTextColor(32, 30, 244);
// doc.setFont("Times New Roman", "normal");
// // Move the other texts to start at x = 50 as well
// doc.text("Please Give Us a Review", 37, footerY + 25);
// doc.text("If you are Satisfied with Our Service", 37, footerY + 28);
//   // 25 YEARS LOGO (Right)
//   doc.addImage("/25years.png", "PNG", pageWidth - 55, footerY + 5, 55, 45);


  // ------------------------------
  // SAVE PDF
  // ------------------------------
  doc.save(`Invoice_${invoiceData.invoiceNo}.pdf`);
};











// ------------------ RESET FORM FUNCTION ------------------
const resetInvoiceForm = () => {
  setTo("");
  setPatientPhoneNo("");
  setPaymentMethod("Cash");
  setDate("");
  setFrame("");
  setLens("");
  setBrand("");
  setRightLens("");
  setLeftLens("");
  setAddPower("");
  setPd("");
  setSeg("");
  setAmount("");
  setDeductAmount("");
  setTotalAmount(0);
  setPatientSearch("");
};

// ------------------ CREATE INVOICE ------------------
const handleCreateInvoice = async () => {
  // Validation
  if (!to.trim()) return alert("Please select patient name");
  if (!patientPhoneNo.trim()) return alert("Please enter phone number");
  if (!date) return alert("Please select date");
  if (!amount) return alert("Please enter amount");

  const amt = parseFloat(amount);
  const ded = parseFloat(deductAmount) || 0;
  const total = amt - ded;

  // Check if invoice number is already used (prevent duplicates)
  try {
    const invoicesRef = collection(db, "invoices");
    const q = query(invoicesRef, where("invoiceNo", "==", invoiceNumber));
    const querySnapshot = await getDocs(q);
    
    if (!querySnapshot.empty) {
      // Invoice number already exists, fetch a new one
      const latestQuery = query(invoicesRef, orderBy("invoiceNo", "desc"), limit(1));
      const latestSnapshot = await getDocs(latestQuery);
      if (!latestSnapshot.empty) {
        const latestNumber = parseInt(latestSnapshot.docs[0].data().invoiceNo);
        setInvoiceNumber((latestNumber + 1).toString());
        setNextInvoiceNumber(latestNumber + 2);
        return alert("Invoice number was taken. Please try again.");
      }
    }
  } catch (error) {
    console.error("Error checking invoice number:", error);
  }

  const invoiceData = {
    to: to.trim(),
    patientPhoneNo: patientPhoneNo.trim(),
    paymentMethod,
    date,
    frame: frame.trim(),
    lens: lens.trim(),
    brand: brand.trim(),
    rightLens,
    leftLens,
    addPower,
    pd,
    seg,
    amount: amt,
    deductAmount: ded,
    totalAmount: total,
    invoiceNo: invoiceNumber,
    createdAt: new Date()
  };

  try {
    // SAVE TO FIRESTORE
    await addDoc(collection(db, "invoices"), invoiceData);

    // DOWNLOAD PDF
    generateinvoicePDF(invoiceData);

    // UPDATE INVOICE NUMBER FOR NEXT INVOICE
    setInvoiceNumber(nextInvoiceNumber.toString());
    setNextInvoiceNumber(prev => prev + 1);

    // RESET FORM
    resetInvoiceForm();

    alert("Invoice Created Successfully");

  } catch (error) {
    console.error("Error creating invoice:", error);
    alert("Failed to create invoice");
  }
};






  
/////////////////////////////////////////////////////  View all invoices  ////////////////////////////////////////////////////////
// Filters
const [statusFilter, setStatusFilter] = useState("");
const [monthFilter, setMonthFilter] = useState("");
const [startDate, setStartDate] = useState("");
const [endDate, setEndDate] = useState("");



const [invoices, setInvoices] = useState([]); // State to store invoices


const handleDownload = () => {
  if (invoices.length === 0) {
    alert("No invoices to download.");
    return;
  }

  // Define the column order you want
  const headers = [
    "invoiceNo",
    "patientPhoneNo",
    "to",
    "date",
    "brand",
    "right Lens",
    "left Lens",
    "add Power",
    "pd",
    "seg",
    "paymentMethod",
    "amount",
    "deductAmount",
    "totalAmount",
    "status",
    "frame",
    "lens"
  ];

  // Format invoices before exporting
  const formattedInvoices = invoices.map((inv) => {
    return {
      invoiceNo: inv.invoiceNo || "",
      patientPhoneNo: inv.patientPhoneNo || "",
      to: inv.to || "",
      date: inv.date || "",
      description: inv.description || "",
      brand: inv.brand || "",
      rightLens: inv.rightLens || "",
      leftLens: inv.leftLens || "",
      addPower: inv.addPower || "", 
      pd: inv.pd || "",
      seg: inv.seg || "",
      paymentMethod: inv.paymentMethod || "",
      amount: Number(inv.amount) || 0,
      deductAmount: Number(inv.deductAmount) || 0,
      totalAmount: Number(inv.totalAmount) || 0,

      status: inv.status || "",
      frame: inv.frame || "",
      lens: inv.lens || ""
    };
  });

  // Convert to worksheet (with headers in right order)
  const worksheet = XLSX.utils.json_to_sheet(formattedInvoices, { header: headers });

  // Set column headers explicitly
  XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });

  // Create workbook and append
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Invoices");

  // Trigger download
  XLSX.writeFile(workbook, "invoices.xlsx");
};







// Add these state variables at the top with your other states
const [filteredInvoices, setFilteredInvoices] = useState([]);

// Update the useEffect to include filtering
useEffect(() => {
  const fetchInvoices = async () => {
    try {
      const invoicesCollection = collection(db, "invoices");
      const invoiceSnapshot = await getDocs(invoicesCollection);
      const invoiceList = invoiceSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      
      setInvoices(invoiceList);
      setFilteredInvoices(invoiceList); // Initialize filtered invoices
    } catch (error) {
      console.error("Error fetching invoices: ", error);
    }
  };

  fetchInvoices();
}, []);


useEffect(() => {
  let data = invoices;

  // Search filter
  if (searchTerm.trim() !== "") {
    data = data.filter((invoice) =>
      invoice.to.toLowerCase().includes(searchTerm.toLowerCase()) ||
      invoice.invoiceNo.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  // Status filter
  if (statusFilter !== "") {
    data = data.filter((invoice) => (invoice.status || "") === statusFilter);
  }

  // Month filter (date must be YYYY-MM-DD format)
  if (monthFilter !== "") {
    data = data.filter((invoice) => {
      if (!invoice.date) return false;
      const month = invoice.date.split("-")[1];
      return month === monthFilter;
    });
  }



  // Date range filter (SAFE)
if (startDate !== "" || endDate !== "") {
  data = data.filter((inv) => {
    if (!inv.date) return false;

    // Convert invoice date to JS Date
    const invoiceDate = new Date(inv.date);
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;

    if (start && invoiceDate < start) return false;
    if (end && invoiceDate > end) return false;

    return true;
  });
}

  setFilteredInvoices(data);
}, [searchTerm, statusFilter, monthFilter, startDate, endDate, invoices]);



const handleInvoiceStatusChange = async (invoiceId, newStatus) => {
  try {
    // Update Firestore
    await updateDoc(doc(db, "invoices", invoiceId), {
      status: newStatus
    });

    // Update invoices state instantly
    setInvoices((prev) =>
      prev.map((inv) =>
        inv.id === invoiceId ? { ...inv, status: newStatus } : inv
      )
    );

    // Update filteredInvoices state instantly
    setFilteredInvoices((prev) =>
      prev.map((inv) =>
        inv.id === invoiceId ? { ...inv, status: newStatus } : inv
      )
    );

    console.log("Status updated successfully");
  } catch (error) {
    console.error("Error updating status:", error);
    alert("Failed to update status");
  }
};



// Replace your existing handleDeleteInvoice function with this updated one

const handleDeleteInvoice = async (invoiceId) => {
  const confirmDelete = window.confirm(
    "Are you sure you want to delete this invoice?"
  );

  if (!confirmDelete) return;

  // Ask password
  const enteredPassword = window.prompt(
    "Enter password to delete invoice:"
  );

  if (enteredPassword === null) return; // user pressed cancel

  if (enteredPassword !== "naveen000") {
    alert("Incorrect password! Deletion cancelled.");
    return;
  }

  try {
    await deleteDoc(doc(db, "invoices", invoiceId));

    // Update states
    setInvoices((prev) =>
      prev.filter((invoice) => invoice.id !== invoiceId)
    );

    setFilteredInvoices((prev) =>
      prev.filter((invoice) => invoice.id !== invoiceId)
    );

    alert("Invoice deleted successfully!");
  } catch (error) {
    console.error("Error deleting invoice: ", error);
    alert("Failed to delete invoice.");
  }
};

















// const generatePDF = (invoiceData) => {

// const doc = new jsPDF({
//   orientation: "portrait",
//   unit: "mm",
//   format: [80, 160]   // 80mm receipt
// });

// const pageWidth = doc.internal.pageSize.getWidth();
// let y = 10;

// // Logo
// doc.addImage("/invoice logo.png", "PNG", 30, y, 20, 20);
// y += 25;

// // Title
// doc.setFont("helvetica", "bold");
// doc.setFontSize(12);
// doc.text("INVOICE", pageWidth/2, y, {align:"center"});
// y += 8;

// // Details
// doc.setFontSize(9);
// doc.setFont("helvetica","normal");

// doc.text(`Invoice: ${invoiceData.invoiceNo}`, 5, y);
// y += 5;
// doc.text(`Date: ${invoiceData.date}`, 5, y);
// y += 5;
// doc.text(`Patient: ${invoiceData.to}`, 5, y);
// y += 8;

// // Divider
// doc.line(5, y, pageWidth-5, y);
// y += 6;

// // Items
// if(invoiceData.frame){
// doc.text(`Frame: ${invoiceData.frame}`,5,y);
// y+=5;
// }

// if(invoiceData.lens){
// doc.text(`Lens: ${invoiceData.lens}`,5,y);
// y+=5;
// }

// if(invoiceData.description){
// const lines = doc.splitTextToSize(invoiceData.description, 70);
// lines.forEach(line=>{
// doc.text(line,5,y);
// y+=4;
// });
// }

// y+=4;
// doc.line(5, y, pageWidth-5, y);
// y+=6;

// // Amounts
// doc.text(`Amount`,5,y);
// doc.text(`Rs ${invoiceData.amount.toFixed(2)}`,pageWidth-5,y,{align:"right"});
// y+=6;

// doc.text(`Advance`,5,y);
// doc.text(`Rs ${invoiceData.deductAmount.toFixed(2)}`,pageWidth-5,y,{align:"right"});
// y+=6;

// doc.setFont("helvetica","bold");
// doc.text(`BALANCE`,5,y);
// doc.text(`Rs ${invoiceData.totalAmount.toFixed(2)}`,pageWidth-5,y,{align:"right"});
// y+=20;

// // TERMS AND CONDITIONS
// doc.setFont("helvetica", "bold");
// doc.setFontSize(7);
// doc.setTextColor(0, 0, 0);

// const terms1 = "*THIS RECEIPT VALID ONLY 14 DAYS FROM DATE OF ORDER. ITEMS ONCE SOLD CANNOT BE RETURNED. ADVANCE PAID WOULD NOT BE REFUNDED.";
// const terms2 = "*THANK YOU VERY MUCH FOR GETTING THE SERVICE FROM OUR COMPANY.";
// const terms3 = "/ STYLE THAT MAKES SENSE THAT'S EKANAYAKE OPTICIAN FASHIONABLE EYEWEAR FOR YOU.";

// const termsLines1 = doc.splitTextToSize(terms1, 70);
// termsLines1.forEach(line => {
//   doc.text(line, pageWidth/2, y, {align:"center"});
//   y += 3.5;
// });

// y += 1;

// const termsLines2 = doc.splitTextToSize(terms2, 70);
// termsLines2.forEach(line => {
//   doc.text(line, pageWidth/2, y, {align:"center"});
//   y += 3.5;
// });

// y += 1;

// const termsLines3 = doc.splitTextToSize(terms3, 70);
// termsLines3.forEach(line => {
//   doc.text(line, pageWidth/2, y, {align:"center"});
//   y += 3.5;
// });

// y += 2;

// // Footer
// doc.setFont("helvetica","normal");
// doc.setFontSize(8);
// doc.setTextColor(0, 0, 0);
// doc.text("Ekanayake Optical", pageWidth/2, y, {align:"center"});
// y+=4;

// doc.text("Nawalapitiya Road, Gampola", pageWidth/2, y, {align:"center"});
// y+=4;

// doc.text("076 5541048 / 0713760878", pageWidth/2, y, {align:"center"});

// doc.save(`Invoice_${invoiceData.invoiceNo}.pdf`);

// };





const generatePDF = (invoiceData) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a5"
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  let y = 6;

  // ------------------------------
  // HEADER LOGO
  // ------------------------------
 doc.addImage("/new logo.png", "PNG", 10, y, 38, 38);

  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(11);
  doc.text("Ekanayake Optical", pageWidth - 10, 20, { align: "right" });

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
  doc.text("Nawalapitiya Road, Gampola", pageWidth - 10, 27, { align: "right" });
  doc.text("Phone: 076 5541048 / 0713760878", pageWidth - 10, 33, { align: "right" });
  doc.text("Email: ekanayakeopticians@gmail.com", pageWidth - 10, 39, { align: "right" });



  y = 58;

  // ------------------------------
  // WATERMARK
  // ------------------------------
  // const imgProps = doc.getImageProperties("/watermark.png");
  // const watermarkWidth = 180;
  // const watermarkHeight = (imgProps.height * watermarkWidth) / imgProps.width;
  // const centerX = pageWidth / 2 - watermarkWidth / 2;

  // doc.setGState(new doc.GState({ opacity: 0.05 }));
  // doc.addImage("/watermark.png", "PNG", centerX, 90, watermarkWidth, watermarkHeight);
  // doc.setGState(new doc.GState({ opacity: 1 }));

  // Divider
  doc.setLineWidth(0.3);
  doc.line(10, y, pageWidth - 10, y);
  y += 6;

  // ------------------------------
  // INVOICE TITLE
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(16);
  doc.text("INVOICE", pageWidth / 2, y, { align: "center" });
  y += 12;

  // ------------------------------
  // CUSTOMER DETAILS
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(11);
  doc.text(`Patient: ${invoiceData.to}`, 10, y);
  y += 7;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(10);
  doc.text(`Date: ${invoiceData.date}`, 10, y);
   y += 5;
    // doc.text(`Job No: ${invoiceData.jobNo}`, 10, y);
    
  doc.text(`Invoice No: ${invoiceData.invoiceNo}`, pageWidth - 10, y, { align: "right" });
  y += 7;

  // ------------------------------
  // TABLE HEADER (BLUE)
  // ------------------------------
  doc.setFillColor(32, 30, 244);
  doc.setTextColor(255, 255, 255);
  doc.rect(10, y, pageWidth - 20, 7, "F");

  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);
  doc.text("Description", 12, y + 5);
  doc.text("Amount (Rs)", pageWidth - 12, y + 5, { align: "right" });
  y += 15;

  doc.setTextColor(0, 0, 0);

  // ------------------------------
  // TABLE BODY
  // ------------------------------
  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(10);

  if (invoiceData.frame) {
    doc.text(`Frame: ${invoiceData.frame}`, 12, y);
    y += 6;
  }

  if (invoiceData.lens) {
    doc.text(`Lens: ${invoiceData.lens}`, 12, y);
    y += 6;
  }

  if (invoiceData.description) {
    const lines = doc.splitTextToSize(invoiceData.description, pageWidth - 30);
    lines.forEach((line) => {
      doc.text(line, 12, y);
      y += 5;
    });
  }

  y += 5;
  doc.line(10, y, pageWidth - 10, y);
  y += 5;

  // ------------------------------
  // PAYMENT SUMMARY
  // ------------------------------
  doc.text("Subtotal:", pageWidth - 55, y);
  doc.text(`Rs ${invoiceData.amount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 7;

  doc.text("Advance:", pageWidth - 55, y);
  doc.text(`Rs ${invoiceData.deductAmount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 7;

  doc.text("Balance:", pageWidth - 55, y);
  doc.text(`Rs ${invoiceData.totalAmount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 8;

  // ------------------------------
  // TERMS
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(9);
  doc.text("Terms & Conditions:", 10, y);
  y += 6;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(8);
  doc.text("* THIS RECEIPT VALID ONLY 14 DAYS FROM DATE OF ORDER.", 12, y); y += 5;
  doc.text("* ITEMS ONCE SOLD CANNOT BE RETURNED.", 12, y); y += 5;
  doc.text("* THANK YOU VERY MUCH FOR GETTING THE SERVICE FROM US.", 12, y); y += 5;
  doc.text("*  STYLE THAT MAKES SENSE THAT'S EKANAYAKE OPTICIAN FASHIONABLE EYEWEAR FOR YOU.", 12, y); y += 8;




  y += 40;


//   const footerHeight = 35;
//   const footerY = pageHeight - footerHeight - 5;



//   // QR (Left)
//   doc.addImage("/qr-kingdom.png", "PNG", 10, footerY + 10, 25, 25);

//   // "SCAN ME" text (Center)
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(11);
//   doc.setTextColor(0, 0, 0);
  

// doc.setFont("Times New Roman", "Bold");
// doc.setFontSize(12);
// // Move "SCAN ME" to start at x = 50
// doc.text("SCAN ME", 37, footerY + 19);

// doc.setFontSize(10);
// doc.setTextColor(32, 30, 244);
// doc.setFont("Times New Roman", "normal");
// // Move the other texts to start at x = 50 as well
// doc.text("Please Give Us a Review", 37, footerY + 25);
// doc.text("If you are Satisfied with Our Service", 37, footerY + 28);
//   // 25 YEARS LOGO (Right)
//   doc.addImage("/25years.png", "PNG", pageWidth - 55, footerY + 5, 55, 45);


  // ------------------------------
  // SAVE PDF
  // ------------------------------
  doc.save(`Invoice_${invoiceData.invoiceNo}.pdf`);
};










  // Handle Logout
  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/"); // Redirect to login page after logout
    } catch (error) {
      console.error("Error during logout: ", error);
    }
  };
  

  // Example: Fetch user details (you might want to update this based on your logic)
  useEffect(() => {
    // Logic to fetch user details from Firestore or Firebase Auth
    const fetchUserDetails = async () => {
      const user = auth.currentUser;
      if (user) {
        // If the user is logged in, set userDetails (you can fetch more details from Firestore if needed)
        setUserDetails({
          name: user.displayName,
          email: user.email,
        });
      }
    };

    fetchUserDetails();
  }, [auth]);






// //create consultation invoive

// // Create consultation invoice
// const handleCreateConsultationInvoice = async () => {
//   if (!to || !date || !description || !amount || !invoiceNumber) {
//     window.alert("Please fill in all required fields before proceeding!");
//     return;
//   }

//   const totalAmount = parseFloat(amount) - parseFloat(deductAmount);

//   const consultationData = {
//     patientName: String(to).trim(),
//     date: String(date).trim(),
//     description: String(description).trim(),
//     amount: parseFloat(amount) || 0,
//     totalAmount: totalAmount || 0,
//     invoiceNo: invoiceNumber,
//     type: "consultation", // Add type to distinguish
//     createdAt: new Date(),
//   };

//   try {
//     // Save to "consultation" collection in Firestore
//     await addDoc(collection(db, "consultation"), consultationData);

//     // Create PDF with A5 landscape size
//     const doc = new jsPDF({
//       orientation: "landscape",
//       unit: "mm",
//       format: [210, 148], // A5 landscape
//     });

//     // --- Professional Font Setup ---
//     doc.setFont("helvetica", "normal");
    
//     // --- Header ---
//   doc.setFillColor(255, 140, 0); // header fill color
//   doc.rect(0, 0, doc.internal.pageSize.getWidth(), 25, "F");
  
//   // Logo and Clinic Info
// const headerHeight = 25;
// const logoHeight = 20;
// const logoY = (headerHeight - logoHeight) / 2; // vertical center

// doc.addImage("/round-logo.png", "PNG", 10, logoY, 20, logoHeight);

//     doc.setFontSize(14);
//     doc.setTextColor(255, 255, 255);
//     doc.setFont("helvetica", "bold");
//     doc.text("Ranathunga Optical", 35, 12);
//     doc.setFontSize(9);
//     doc.text("No. 80/A, Kurunegala road, Dambulla", 35, 17);
//     doc.text("Tel: 071 249 5447", 35, 22);

//     // --- CONSULTATION INVOICE Title ---
//     doc.setFontSize(16);
//     doc.setTextColor(0, 0, 0);
//     doc.text("CONSULTATION INVOICE", doc.internal.pageSize.getWidth() / 2, 35, { align: "center" });

//     // --- Invoice Details ---
//     doc.setFontSize(10);
//     const detailsY = 45;
    
//     // Patient Info
//     doc.text(`Patient: ${consultationData.patientName}`, 10, detailsY);
    
//     // Invoice Number and Date (right aligned)
//     doc.text(`Invoice No: ${consultationData.invoiceNo}`, doc.internal.pageSize.getWidth() - 10, detailsY, { align: "right" });
//     doc.text(`Date: ${consultationData.date}`, doc.internal.pageSize.getWidth() - 10, detailsY + 7, { align: "right" });

//     // --- Table Section ---
//     let currentY = 60;
    
//     // Table Header
//     doc.setDrawColor(0);
//     doc.setFillColor(230, 230, 230);
//     doc.rect(10, currentY, doc.internal.pageSize.getWidth() - 20, 8, "F");
//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(10);
//     doc.text("DESCRIPTION", 12, currentY + 6);
//     doc.text("AMOUNT (Rs.)", doc.internal.pageSize.getWidth() - 12, currentY + 6, { align: "right" });
    
//     currentY += 12;

//     // Description with automatic line breaks
//     const descriptionLines = doc.splitTextToSize(consultationData.description, doc.internal.pageSize.getWidth() - 50);
//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(10);
    
//     // Print each line of description
//     descriptionLines.forEach(line => {
//       doc.text(line, 12, currentY);
//       currentY += 5; // Line spacing
//     });

//     // Amount aligned to the right
//     doc.text(`Rs. ${consultationData.amount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 12, 72, { align: "right" });

//     // Deduction and Total
//     currentY = Math.max(currentY, 85); // Ensure minimum space
    
  
    
//     // Total
//     currentY += 10;
//     doc.setFont("helvetica", "bold");
//     doc.text("Total Amount", 12, currentY);
//     doc.text(`Rs. ${consultationData.amount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 12, currentY, { align: "right" });

//     // Horizontal line above footer
//     doc.line(10, currentY + 5, doc.internal.pageSize.getWidth() - 10, currentY + 5);

//     // --- Footer ---
//     doc.setFillColor(0, 0, 0); //footer color
//     doc.rect(0, doc.internal.pageSize.getHeight() - 10, doc.internal.pageSize.getWidth(), 10, "F");
//     doc.setFontSize(8);
//     doc.setTextColor(255, 255, 255);
//     doc.text("All kinds of Eye wear, Sunglasses, Color Lenses, Contact Lenses, and All Eyeware accessories", 
//              doc.internal.pageSize.getWidth() / 2, doc.internal.pageSize.getHeight() - 5, 
//              { align: "center" });

//     // Save PDF
//     doc.save(`Consultation_Invoice_${invoiceNumber}.pdf`);

//     // Reset form
//     setInvoiceNumber("");
//     setTo("");
//     setDate("");
//     setDescription("");
//     setAmount("");
//     setDeductAmount(0);
    
//   } catch (error) {
//     console.error("Error creating consultation invoice: ", error);
//     window.alert("Failed to create consultation invoice. Please try again.");
//   }
// };




  







// //fetch all previous consultation invoices


// const [consultationInvoices, setConsultationInvoices] = useState([]);
// const [selectedInvoice, setSelectedInvoice] = useState(null);

// // Fetch consultation invoices from Firestore
// useEffect(() => {
//   const fetchConsultationInvoices = async () => {
//     try {
//       const querySnapshot = await getDocs(collection(db, "consultation"));
//       const invoices = [];
//       querySnapshot.forEach((doc) => {
//         invoices.push({ id: doc.id, ...doc.data() });
//       });
//       setConsultationInvoices(invoices);
//     } catch (error) {
//       console.error("Error fetching consultation invoices: ", error);
//     }
//   };

//   fetchConsultationInvoices();
// }, []);

// const handleViewInvoice = (invoice) => {
//   setSelectedInvoice(invoice);
// };








/////////////////////////////  Create Eye Examination Report ///////////////////////////////////////////////////////////////////////////////////////////////

  // Patient Information
  const [patientName, setPatientName] = useState('');
  const [examDate, setExamDate] = useState('');
  const [patientId, setPatientId] = useState('');
  const [dob, setDob] = useState('');
  const [age, setAge] = useState('');
  const [gender, setGender] = useState('');
  const [contactNo, setContactNo] = useState('');
  const [email, setEmail] = useState('');
  const [fundi, setFundi] = useState('');
  const [addition, setAddition] = useState("");
  const [additionHbRx, setAdditionHbRx] = useState("");

  // History Taking
  const [chiefComplaint, setChiefComplaint] = useState('');
  const [hpc, setHpc] = useState('');
  const [pastOcularHistory, setPastOcularHistory] = useState('');
  const [medicalHistory, setMedicalHistory] = useState('');
  const [familyOcularHistory, setFamilyOcularHistory] = useState('');
  const [socialHistory, setSocialHistory] = useState('');




const [lids, setLids] = useState('');
const [conjunctiva, setConjunctiva] = useState('');
const [cornea, setCornea] = useState('');
const [sclera, setSclera] = useState('');
const [ac, setAc] = useState('');
const [vitreous, setVitreous] = useState('');


// External Examination (Left and Right Eye - separate states)
const [lidsLeft, setLidsLeft] = useState('');
const [lidsRight, setLidsRight] = useState('');

const [conjunctivaLeft, setConjunctivaLeft] = useState('');
const [conjunctivaRight, setConjunctivaRight] = useState('');

const [corneaLeft, setCorneaLeft] = useState('');
const [corneaRight, setCorneaRight] = useState('');

const [scleraLeft, setScleraLeft] = useState('');
const [scleraRight, setScleraRight] = useState('');

const [acLeft, setAcLeft] = useState('');
const [acRight, setAcRight] = useState('');

const [lensLeft, setLensLeft] = useState('');
const [lensRight, setLensRight] = useState('');

const [vitreousLeft, setVitreousLeft] = useState('');
const [vitreousRight, setVitreousRight] = useState('');



  // Family History
  const [familyHistory, setFamilyHistory] = useState({
    poag: false,
    amd: false,
    dm: false,
    other: '',
  });

  // Visual Acuity
  const [visualAcuity, setVisualAcuity] = useState({
    od_cg: '',
    od_sg: '',
    od_ph: '',
    od_pd: '',
    os_cg: '',
    os_sg: '',
    os_ph: '',
    os_pd: '',
    seg_va: '',
    ct: '',
    npc: '',
    om: '',
  });


  //HbRx

  const [hbrx, setHbrx] = useState({
    hb_od_sph: '',
    hb_od_cyl: '',
    hb_od_axis: '',
    hb_od_vision: '',
    rx_os_sph: '',
    rx_os_cyl: '',
    rx_os_axis: '',
    rx_os_vision: '',
  });




  // Refraction
  const [refraction, setRefraction] = useState({
    od_sph: '',
    od_cyl: '',
    od_axis: '',
    od_vision: '',
    os_sph: '',
    os_cyl: '',
    os_axis: '',
    os_vision: '',
  });

  // Follow Up
  const [needsFollowUp, setNeedsFollowUp] = useState(false);
  const [followUpDate, setFollowUpDate] = useState('');
  const [remarks, setRemarks] = useState('');

  const handleFamilyHistoryChange = (e) => {
    const { name, checked, value } = e.target;
    if (name === 'other') {
      setFamilyHistory({ ...familyHistory, other: value });
    } else {
      setFamilyHistory({ ...familyHistory, [name]: checked });
    }
  };

  const handleVisualAcuityChange = (e) => {
    const { name, value } = e.target;
    setVisualAcuity({ ...visualAcuity, [name]: value });
  };

  const handleHbrxChange = (e) => {
    const { name, value } = e.target;
    setHbrx({ ...hbrx, [name]: value });
  };


  const handleRefractionChange = (e) => {
    const { name, value } = e.target;
    setRefraction({ ...refraction, [name]: value });
  };

  const handleEyeExamSubmit = async (e) => {
    e.preventDefault();

    if (!patientName || !examDate) {
      alert('Please fill in patient name and date');
      return;
    }

    const eyeExamData = {
      patientInfo: {
        name: patientName,
        date: examDate,
        id: patientId,
        dob: dob,
        age,
        gender,
        contactNo,
        email,
        fundi,
      },
      history: {
        chiefComplaint,
        hpc,
        pastOcularHistory,
        medicalHistory,
        familyOcularHistory,
        socialHistory,
        addition,
        additionHbRx,
      },

      externalExam: {
        lids,
        conjunctiva,
        cornea,
        sclera,
        ac,
        lens,
        vitreous,
      },


      familyHistory,
      visualAcuity,
      hbrx,
      refraction,
      followUp: {
        needed: needsFollowUp,
        date: followUpDate,
        remarks,
      },
      createdAt: new Date(),
    };

    try {
      // Save to Firestore
      await addDoc(collection(db, 'eyeExams'), eyeExamData);
      
      // Generate PDF
      generateEyeExamPDF(eyeExamData);
      
    // Reset form after everything is done
    resetForm();

      alert('Eye exam report saved successfully!');
    } catch (error) {
      console.error('Error saving eye exam: ', error);
      alert('Failed to save eye exam');
    }
  };


const resetForm = () => {
  setPatientName('');
  setExamDate('');
  setPatientId('');
  setDob('');
  setAge('');
  setGender('');
  setContactNo('');
  setEmail('');
  setFundi('');

  setChiefComplaint('');
  setHpc('');
  setPastOcularHistory('');
  setMedicalHistory('');
  setFamilyOcularHistory('');
  setSocialHistory('');

  setLids('');
  setConjunctiva('');
  setCornea('');
  setSclera('');
  setAc('');
  setLens('');
  setVitreous('');

  setLidsLeft('');
  setLidsRight('');
  setConjunctivaLeft('');
  setConjunctivaRight('');
  setCorneaLeft('');
  setCorneaRight('');
  setScleraLeft('');
  setScleraRight('');
  setAcLeft('');
  setAcRight('');
  setLensLeft('');
  setLensRight('');
  setVitreousLeft('');
  setVitreousRight('');

  setFamilyHistory({
    poag: false,
    amd: false,
    dm: false,
    other: '',
  });

  setVisualAcuity({
    od_cg: '',
    od_sg: '',
    od_ph: '',
    od_pd: '',
    os_cg: '',
    os_sg: '',
    os_ph: '',
    os_pd: '',
    seg_va: '',
    ct: '',
    npc: '',
    om: '',
  });

  setHbrx({
    hb_od_sph: '',
    hb_od_cyl: '',
    hb_od_axis: '',
    hb_od_vision: '',
    rx_os_sph: '',
    rx_os_cyl: '',
    rx_os_axis: '',
    rx_os_vision: '',
  });

  setRefraction({
    od_sph: '',
    od_cyl: '',
    od_axis: '',
    od_vision: '',
    os_sph: '',
    os_cyl: '',
    os_axis: '',
    os_vision: '',

  });

  setNeedsFollowUp(false);
  setFollowUpDate('');
  setRemarks('');
};





  const generateEyeExamPDF = (data) => {
    const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
    });

    // Set default font styles
    doc.setFont('helvetica');
    doc.setTextColor(0, 0, 0); // Black text

    // Constants for layout
    const leftMargin = 15;
    const rightMargin = 15;
    const pageWidth = 210 - leftMargin - rightMargin;
    const column1 = leftMargin;
    const column2 = 100;
    const columnWidth = 80;

    // Header Section
    doc.addImage('/new logo.png', 'PNG', leftMargin, 12, 20, 20); // Larger logo
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('Ekanayake Optical', leftMargin + 55, 18);
    doc.setFontSize(10);
    doc.text('Infront of base hospital, Nawalapitiya Road, Gampola', leftMargin + 55, 23);
    doc.text('Tel: 076 554 1048 / 071 376 0878', leftMargin + 55, 28);
    doc.text(`Date: ${data.patientInfo.date}`, 180, 18, { align: 'right' });
    doc.line(leftMargin, 32, 210 - rightMargin, 32); // Horizontal line

    // Report Title
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text('EYE EXAMINATION REPORT', 105, 42, { align: 'center' });
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');

    // Patient Information (Two Columns)
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('PATIENT INFORMATION', leftMargin, 50);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    
    // Column 1
    doc.text(`Name: ${data.patientInfo.name}`, column1, 56);
    // doc.text(`Patient ID: ${data.patientInfo.id || '-'}`, column1, 62);
    doc.text(`Age: ${data.patientInfo.age || '-'}`, column1, 62);
    doc.text(`Gender: ${data.patientInfo.gender || '-'}`, column1, 68);
    
    // Column 2
    doc.text(`Contact: ${data.patientInfo.contactNo || '-'}`, column2, 56);
    // doc.text(`Email: ${data.patientInfo.email || '-'}`, column2, 62);
    doc.text(`DOB: ${data.patientInfo.dob || '-'}`, column2, 62);
    doc.line(leftMargin, 78, 210 - rightMargin, 78); // Divider line

    // Helper functions
    const addSection = (title, content, y, maxWidth = pageWidth) => {
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.text(title.toUpperCase(), leftMargin, y);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        
        const lines = doc.splitTextToSize(content || '-', maxWidth);
        doc.text(lines, leftMargin + 5, y + 6);
        return y + (lines.length * 5) + 10;
    };

    const addExamTable = (title, data, y, columns) => {
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.text(title.toUpperCase(), leftMargin, y);
        y += 6;
        
        // Table header
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        columns.forEach((col, i) => {
            doc.text(col.label, leftMargin + (i * 40), y);
        });
        y += 6;
        
        // Table data
        doc.setFont('helvetica', 'normal');
        data.forEach(row => {
            columns.forEach((col, i) => {
                doc.text(row[col.key] || '-', leftMargin + (i * 40), y);
            });
            y += 6;
        });
        
        return y + 6;
    };

    let yPos = 82;

// History Sections (inline, label + value)
doc.setFontSize(10);
doc.setFont('helvetica', 'normal');

doc.text(`Chief Complaint : ${data.history.chiefComplaint || '-'}`, leftMargin, yPos);
yPos += 6;
doc.text(`History Of Present Complaint : ${data.history.hpc || '-'}`, leftMargin, yPos);
yPos += 6;
doc.text(`Past Ocular History : ${data.history.pastOcularHistory || '-'}`, leftMargin, yPos);
yPos += 6;
doc.text(`Medical History : ${data.history.medicalHistory || '-'}`, leftMargin, yPos);
yPos += 6;
doc.text(`Family Ocular History : ${data.history.familyOcularHistory || '-'}`, leftMargin, yPos);
yPos += 6;
doc.text(`Social History : ${data.history.socialHistory || '-'}`, leftMargin, yPos);
yPos += 10; // small gap after history section

    // Check for page break
    if (yPos > 250) {
        doc.addPage();
        yPos = 20;
    }

 // External Examination Table
yPos = addExamTable('External Examination', [
  { structure: 'Lids', left: lidsLeft || '-', right: lidsRight || '-' },
  { structure: 'Conjunctiva', left: conjunctivaLeft || '-', right: conjunctivaRight || '-' },
  { structure: 'Cornea', left: corneaLeft || '-', right: corneaRight || '-' },
  { structure: 'Sclera', left: scleraLeft || '-', right: scleraRight || '-' },
  { structure: 'A/C', left: acLeft || '-', right: acRight || '-' },
  { structure: 'Lens', left: lensLeft || '-', right: lensRight || '-' },
  { structure: 'Vitreous', left: vitreousLeft || '-', right: vitreousRight || '-' }
], yPos, [
  { label: 'Structure', key: 'structure' },
  { label: 'Left Eye', key: 'left' },
  { label: 'Right Eye', key: 'right' }
]);





    // Family History
    yPos = addSection('Family History', 
        `POAG: ${data.familyHistory.poag ? 'Yes' : 'No'}, ` +
        `AMD: ${data.familyHistory.amd ? 'Yes' : 'No'}, ` +
        `DM: ${data.familyHistory.dm ? 'Yes' : 'No'}` +
        (data.familyHistory.other ? `, Other: ${data.familyHistory.other}` : ''), 
        yPos);

    // Visual Acuity
    yPos = addExamTable('Visual Acuity', [
        { test: 'C/C', od: data.visualAcuity.od_cg, os: data.visualAcuity.os_cg },
        { test: 'S/C', od: data.visualAcuity.od_sg, os: data.visualAcuity.os_sg },
        { test: 'P/H', od: data.visualAcuity.od_ph, os: data.visualAcuity.os_ph },
        { test: 'PD', od: data.visualAcuity.od_pd, os: data.visualAcuity.os_pd },
       { test: 'SEG', od: data.visualAcuity.seg_va, os: '-' }
    ], yPos, [
        { label: 'Test', key: 'test' },
        { label: 'OD', key: 'od' },
        { label: 'OS', key: 'os' }
    ]);

    // Additional Visual Tests
    // if (data.visualAcuity.ct || data.visualAcuity.npc || data.visualAcuity.om) {
    //     yPos = addSection(' Accessory Tests',
    //         `CT: ${data.visualAcuity.ct || '-'}, ` +
    //         `NPC: ${data.visualAcuity.npc || '-'}, ` +
    //         `OM: ${data.visualAcuity.om || '-'}`, 
    //         yPos,
          
    //       );
          
    // }
// After Visual Acuity + Accessory Tests
if (
  (data.visualAcuity.ct && data.visualAcuity.ct.trim() !== '') ||
  (data.visualAcuity.npc && data.visualAcuity.npc.trim() !== '') ||
  (data.visualAcuity.om && data.visualAcuity.om.trim() !== '')
) {
  yPos = addSection('Accessory Tests',
      `CT: ${data.visualAcuity.ct || '-'}, ` +
      `NPC: ${data.visualAcuity.npc || '-'}, ` +
      `OM: ${data.visualAcuity.om || '-'}`, 
      yPos
  );
}


doc.addPage();
yPos = 20;



      //   // Check for page break
      //   if (yPos > 250) {
      //     doc.addPage();
      //     yPos = 20;
      // }


    // Fundus Examination
    if (data.patientInfo.fundi) {
        yPos = addSection('Fundus Examination', data.patientInfo.fundi, yPos);
    }


      //Hb Rx

      if (data.hbrx) {
       const hbRxData = [
  { eye: 'OD',
    sph: data.hbrx.hb_od_sph,
    cyl: data.hbrx.hb_od_cyl,
    axis: data.hbrx.hb_od_axis,
    vision: data.hbrx.hb_od_vision },
  { eye: 'OS',
    sph: data.hbrx.rx_os_sph,   // ✅ use rx_os_* here
    cyl: data.hbrx.rx_os_cyl,
    axis: data.hbrx.rx_os_axis,
    vision: data.hbrx.rx_os_vision }
];
        yPos = addExamTable('Hb Rx', hbRxData, yPos, [
            { label: 'Eye', key: 'eye' },
            { label: 'Sph', key: 'sph' },
            { label: 'Cyl', key: 'cyl' },
            { label: 'Axis', key: 'axis' },
            { label: 'Vision', key: 'vision' }
        ]);
      }



    // Refraction and Hb Rx
    const refractionData = [
        { eye: 'OD', 
          sph: data.refraction.od_sph, 
          cyl: data.refraction.od_cyl, 
          axis: data.refraction.od_axis, 
          vision: data.refraction.od_vision },
        { eye: 'OS', 
          sph: data.refraction.os_sph, 
          cyl: data.refraction.os_cyl, 
          axis: data.refraction.os_axis, 
          vision: data.refraction.os_vision }
    ];

    yPos = addExamTable('Refraction', refractionData, yPos, [
        { label: 'Eye', key: 'eye' },
        { label: 'Sph', key: 'sph' },
        { label: 'Cyl', key: 'cyl' },
        { label: 'Axis', key: 'axis' },
        { label: 'Vision', key: 'vision' }
    ]);


doc.setFontSize(9);
doc.setFont('helvetica', 'normal');

doc.text(`Near Vision (ADD) : ${data.history.addition || '-'}`, leftMargin, yPos);
yPos += 6;

doc.setFontSize(9);
doc.setFont('helvetica', 'normal');

doc.text(`Near Vision (ADD - Hb Rx) : ${data.history.additionHbRx || '-'}`, leftMargin, yPos);
yPos += 8;

    // Follow Up
    yPos = addSection('Follow Up', 
        `Needed: ${data.followUp.needed ? 'Yes' : 'No'}` +
        (data.followUp.needed ? `, Date: ${data.followUp.date}` : '') +
        (data.followUp.remarks ? `\nRemarks: ${data.followUp.remarks}` : ''), 
        yPos);

    // Footer
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text('"All kinds of Eye wear, Sunglasses, Color Lenses, Contact Lenses, and All Eyeware accessories"', 105, 287, { align: 'center' });
    doc.text('© Ekanayake Optical', 105, 292, { align: 'center' });

    // Save PDF
    doc.save(`EyeExam_${data.patientInfo.name.replace(/\s+/g, '_')}_${data.patientInfo.date.replace(/\//g, '-')}.pdf`);
};













//fetch all the eye exam report

useEffect(() => {
  const fetchEyeExamRecords = async () => {
    if (selectedOption === "viewEyeExam") {
      try {
        const querySnapshot = await getDocs(collection(db, 'eyeExams'));
        const records = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setEyeExamRecords(records);
      } catch (error) {
        console.error("Error fetching eye exam records: ", error);
      }
    }
  };

  fetchEyeExamRecords();
}, [selectedOption]);






const filteredRecords = eyeExamRecords.filter(record => {
  // Search term filtering
  const matchesSearch = 
    record.patientInfo?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    record.patientInfo?.id?.toLowerCase().includes(searchTerm.toLowerCase());
  
  // Date filtering
  const recordDate = new Date(record.patientInfo?.date);
  const today = new Date();
  
  let matchesDate = true;
  if (filterOption === 'today') {
    matchesDate = recordDate.toDateString() === today.toDateString();
  } else if (filterOption === 'week') {
    const weekAgo = new Date();
    weekAgo.setDate(weekAgo.getDate() - 7);
    matchesDate = recordDate >= weekAgo;
  } else if (filterOption === 'month') {
    const monthAgo = new Date();
    monthAgo.setMonth(monthAgo.getMonth() - 1);
    matchesDate = recordDate >= monthAgo;
  }
  
  return matchesSearch && matchesDate;
});








//patient's eye examination report
const generatePatientEyeExam = (data) => {

  const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
    });

    // Set default font styles
    doc.setFont('helvetica');
    doc.setTextColor(0, 0, 0); // Black text

    // Constants for layout
    const leftMargin = 15;
    const rightMargin = 15;
    const pageWidth = 210 - leftMargin - rightMargin;
    const column1 = leftMargin;
    const column2 = 100;
    const columnWidth = 80;

    // Header Section
    doc.addImage('/new logo.png', 'PNG', leftMargin, 12, 20, 20); // Larger logo
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('Ekanayake Optical', leftMargin + 55, 18);
    doc.setFontSize(10);
    doc.text('Infront of base hospital, Nawalapitiya Road, Gampola', leftMargin + 55, 23);
    doc.text('Tel: 076 554 1048 / 071 376 0878', leftMargin + 55, 28);
    doc.text(`Date: ${data.patientInfo.date}`, 180, 18, { align: 'right' });
    doc.line(leftMargin, 32, 210 - rightMargin, 32); // Horizontal line

    // Report Title
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text('EYE EXAMINATION REPORT', 105, 42, { align: 'center' });
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');

    // Patient Information (Two Columns)
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('PATIENT INFORMATION', leftMargin, 50);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    
    // Column 1
    doc.text(`Name: ${data.patientInfo.name}`, column1, 56);
    doc.text(`Age: ${data.patientInfo.age || '-'}`, column1, 62);
    doc.text(`Gender: ${data.patientInfo.gender || '-'}`, column1, 68);
    
    // Column 2
    doc.text(`Contact: ${data.patientInfo.contactNo || '-'}`, column2, 56);
    doc.text(`DOB: ${data.patientInfo.dob || '-'}`, column2, 62);
    doc.line(leftMargin, 78, 210 - rightMargin, 78); // Divider line

    // Helper functions
    const addSection = (title, content, y, maxWidth = pageWidth) => {
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.text(title.toUpperCase(), leftMargin, y);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        
        const lines = doc.splitTextToSize(content || '-', maxWidth);
        doc.text(lines, leftMargin + 5, y + 6);
        return y + (lines.length * 5) + 10;
    };

    const addExamTable = (title, data, y, columns) => {
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.text(title.toUpperCase(), leftMargin, y);
        y += 6;
        
        // Table header
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        columns.forEach((col, i) => {
            doc.text(col.label, leftMargin + (i * 40), y);
        });
        y += 6;
        
        // Table data
        doc.setFont('helvetica', 'normal');
        data.forEach(row => {
            columns.forEach((col, i) => {
                doc.text(row[col.key] || '-', leftMargin + (i * 40), y);
            });
            y += 6;
        });
        
        return y + 6;
    };

    let yPos = 82;

    // History Sections (inline, label + value)
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');

    doc.text(`Chief Complaint : ${data.history?.chiefComplaint || '-'}`, leftMargin, yPos);
    yPos += 6;
    doc.text(`History Of Present Complaint : ${data.history?.hpc || '-'}`, leftMargin, yPos);
    yPos += 6;
    doc.text(`Past Ocular History : ${data.history?.pastOcularHistory || '-'}`, leftMargin, yPos);
    yPos += 6;


    // Visual Acuity
    yPos = addExamTable('Visual Acuity', [
        { test: 'C/C', od: data.visualAcuity?.od_cg || '-', os: data.visualAcuity?.os_cg || '-' },
        { test: 'S/C', od: data.visualAcuity?.od_sg || '-', os: data.visualAcuity?.os_sg || '-' },
        { test: 'P/H', od: data.visualAcuity?.od_ph || '-', os: data.visualAcuity?.os_ph || '-' },
        { test: 'PD', od: data.visualAcuity?.od_pd || '-', os: data.visualAcuity?.os_pd || '-' },
        { test: 'SEG', od: data.visualAcuity?.seg_va || '-', os: '-' }
    ], yPos, [
        { label: 'Test', key: 'test' },
        { label: 'OD', key: 'od' },
        { label: 'OS', key: 'os' }
    ]);

    // Accessory Tests (CT, NPC, OM)
    if (
        (data.visualAcuity?.ct && data.visualAcuity.ct.trim() !== '') ||
        (data.visualAcuity?.npc && data.visualAcuity.npc.trim() !== '') ||
        (data.visualAcuity?.om && data.visualAcuity.om.trim() !== '')
    ) {
        yPos = addSection('Accessory Tests',
            `CT: ${data.visualAcuity.ct || '-'}, ` +
            `NPC: ${data.visualAcuity.npc || '-'}, ` +
            `OM: ${data.visualAcuity.om || '-'}`, 
            yPos
        );
    }

    // Check if we need a new page before Hb Rx and Refraction
    if (yPos > 200) {
        doc.addPage();
        yPos = 20;
    }

    // Hb Rx
    if (data.hbrx) {
        const hbRxData = [
            { 
                eye: 'OD',
                sph: data.hbrx.hb_od_sph || '-',
                cyl: data.hbrx.hb_od_cyl || '-',
                axis: data.hbrx.hb_od_axis || '-',
                vision: data.hbrx.hb_od_vision || '-' 
            },
            { 
                eye: 'OS',
                sph: data.hbrx.rx_os_sph || '-',
                cyl: data.hbrx.rx_os_cyl || '-',
                axis: data.hbrx.rx_os_axis || '-',
                vision: data.hbrx.rx_os_vision || '-' 
            }
        ];
        
        yPos = addExamTable('Hb Rx', hbRxData, yPos, [
            { label: 'Eye', key: 'eye' },
            { label: 'Sph', key: 'sph' },
            { label: 'Cyl', key: 'cyl' },
            { label: 'Axis', key: 'axis' },
            { label: 'Vision', key: 'vision' }
        ]);
    }

    // Refraction
    if (data.refraction) {
        const refractionData = [
            { 
                eye: 'OD', 
                sph: data.refraction.od_sph || '-', 
                cyl: data.refraction.od_cyl || '-', 
                axis: data.refraction.od_axis || '-', 
                vision: data.refraction.od_vision || '-' 
            },
            { 
                eye: 'OS', 
                sph: data.refraction.os_sph || '-', 
                cyl: data.refraction.os_cyl || '-', 
                axis: data.refraction.os_axis || '-', 
                vision: data.refraction.os_vision || '-' 
            }
        ];

        yPos = addExamTable('Refraction', refractionData, yPos, [
            { label: 'Eye', key: 'eye' },
            { label: 'Sph', key: 'sph' },
            { label: 'Cyl', key: 'cyl' },
            { label: 'Axis', key: 'axis' },
            { label: 'Vision', key: 'vision' }
        ]);
    }


doc.setFontSize(9);
doc.setFont('helvetica', 'normal');

doc.text(`Near Vision (ADD) : ${data.history.addition || '-'}`, leftMargin, yPos);
yPos += 6;

doc.text(`Near Vision (ADD - Hb Rx) : ${data.history.additionHbRx || '-'}`, leftMargin, yPos);
yPos += 8;


    // Follow Up
    if (yPos > 260) {
        doc.addPage();
        yPos = 20;
    }

    yPos = addSection('Follow Up', 
        `Needed: ${data.followUp?.needed ? 'Yes' : 'No'}` +
        (data.followUp?.needed ? `, Date: ${data.followUp.date || '-'}` : '') +
        (data.followUp?.remarks ? `\nRemarks: ${data.followUp.remarks}` : ''), 
        yPos);

    // Footer
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text('"All kinds of Eye wear, Sunglasses, Color Lenses, Contact Lenses, and All Eyeware accessories"', 105, 287, { align: 'center' });
    doc.text('© Ekanayake Optical', 105, 292, { align: 'center' });

    // Save PDF
    doc.save(`EyeExam_${data.patientInfo.name.replace(/\s+/g, '_')}_${data.patientInfo.date.replace(/\//g, '-')}.pdf`);
};









//////////////////////////////////// patient follow ups ///////////////////////////////////////////////////




const [notifications, setNotifications] = useState([]);
const [todayCount, setTodayCount] = useState(0);
const [error, setError] = useState(null);


// Helper function to convert date to readable format
const formatDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
};

// Helper function to check if date is today
const isToday = (date) => {
  if (!date) return false;
  const d = new Date(date);
  const today = new Date();
  return (
    d.getDate() === today.getDate() &&
    d.getMonth() === today.getMonth() &&
    d.getFullYear() === today.getFullYear()
  );
};

// Helper function to get days difference
const getDaysDifference = (date) => {
  if (!date) return 0;
  const d = new Date(date);
  const today = new Date();
  const diffTime = d - today;
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

useEffect(() => {
  setLoading(true);

  const patientsRef = collection(db, 'patients');
  const q = query(
    patientsRef,
    where("followUpDate", "!=", null),
    orderBy("followUpDate", "asc")
  );

  // Real-time listener
  const unsubscribe = onSnapshot(
    q,
    (querySnapshot) => {
      const fetchedNotifications = [];
      let todayNotifications = 0;

      querySnapshot.forEach((doc) => {
        const patientData = doc.data();
        const followUpDate = patientData.followUpDate;

        // Handle Firebase Timestamp properly
        const dateValue = followUpDate?.toDate ? followUpDate.toDate() : new Date(followUpDate);

        const notification = {
          ...patientData,
          id: doc.id,
          patientName: patientData.name || 'Unknown Patient',
          followUpDate: dateValue,
          formattedDate: formatDate(dateValue),
          isToday: isToday(dateValue),
          daysDifference: getDaysDifference(dateValue),
          status: patientData.status || 'pending',
          followupStatus: patientData.followupStatus || [], // Make sure this exists
        };

        // REMOVED THE FILTER - include ALL patients with follow-up dates
        fetchedNotifications.push(notification);
        
        // Count today's notifications separately
        if (notification.isToday) todayNotifications++;
      });

      console.log('All notifications:', fetchedNotifications); // Debug log
      console.log('Overdue:', fetchedNotifications.filter(n => n.daysDifference < 0)); // Debug log

      setNotifications(fetchedNotifications);
      setTodayCount(todayNotifications);
      setLoading(false);
    },
    (err) => {
      console.error("Error fetching notifications:", err);
      setError("Failed to load notifications. Please try again later.");
      setLoading(false);
    }
  );

  // Cleanup listener on unmount
  return () => unsubscribe();
}, []);

const getPriorityColor = (date) => {
  if (!date) return '#52c41a';
  const today = new Date();
  const diffInDays = getDaysDifference(date);
  
  if (isToday(date)) return '#ff4d4f'; // Red for today
  if (diffInDays <= 3) return '#faad14'; // Yellow for upcoming 3 days
  return '#52c41a'; // Green for future dates
};

const handleStatusChange = async (invoiceId, newStatus) => {
  try {
    const invoiceRef = doc(db, "patients", invoiceId);
    await updateDoc(invoiceRef, { status: newStatus });
    // Update local state too
    setInvoices((prev) =>
      prev.map((inv) =>
        inv.id === invoiceId ? { ...inv, status: newStatus } : inv
      )
    );
  } catch (err) {
    console.error("Error updating status:", err);
  }
};



/////////////////////////////////////////////////////  sales report  ///////////////////////////////////////////////////////////
 // ---------------- STATE ----------------

const [settlements, setSettlements] = useState([]);

const [filterMode, setFilterMode] = useState("daily"); // daily | monthly | yearly
const [selectedDate, setSelectedDate] = useState(dayjs());

const [totalSale, setTotalSale] = useState(0);
const [totalPaid, setTotalPaid] = useState(0);
const [totalPayable, setTotalPayable] = useState(0);


// ---------------- FETCH INVOICES ----------------
const fetchInvoices = useCallback(async () => {
  try {
    const snapshot = await getDocs(collection(db, "invoices"));
    const list = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setInvoices(list);
  } catch (error) {
    console.error("Error fetching invoices:", error);
  }
}, []);


// ---------------- FETCH SETTLEMENTS ----------------
const fetchSettlements = useCallback(async () => {
  try {
    const snapshot = await getDocs(collection(db, "settlements"));
    const list = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setSettlements(list);
  } catch (error) {
    console.error("Error fetching settlements:", error);
  }
}, []);


// ---------------- LOAD DATA ----------------
useEffect(() => {
  fetchInvoices();
  fetchSettlements();
}, [fetchInvoices, fetchSettlements]);


// ---------------- FILTER INVOICES ----------------
const filteredInvoicesInSale = invoices.filter((inv) => {
  if (!inv.date) return false;

  const invDate = dayjs(inv.date);

  if (filterMode === "daily") {
    return invDate.isSame(selectedDate, "day");
  } else if (filterMode === "monthly") {
    return (
      invDate.month() === selectedDate.month() &&
      invDate.year() === selectedDate.year()
    );
  } else if (filterMode === "yearly") {
    return invDate.year() === selectedDate.year();
  }
  return true;
});


// ---------------- FILTER SETTLEMENTS ----------------
const filteredSettlements = settlements.filter((s) => {
  if (!s.date) return false;

  const sDate = dayjs(s.date.toDate()); // Firestore timestamp

  if (filterMode === "daily") {
    return sDate.isSame(selectedDate, "day");
  } else if (filterMode === "monthly") {
    return (
      sDate.month() === selectedDate.month() &&
      sDate.year() === selectedDate.year()
    );
  } else if (filterMode === "yearly") {
    return sDate.year() === selectedDate.year();
  }
  return true;
});


// ---------------- CALCULATIONS (FINAL CORRECT LOGIC) ----------------
useEffect(() => {
  const totalS = filteredInvoicesInSale.reduce(
    (acc, curr) => acc + (curr.amount || 0),
    0
  );

  const advancePaid = filteredInvoicesInSale.reduce(
    (acc, curr) => acc + (curr.deductAmount || 0),
    0
  );

  const settlementPaid = filteredSettlements.reduce(
    (acc, curr) => acc + (curr.paidAmount || 0),
    0
  );

  const totalP = advancePaid + settlementPaid;
  const totalBal = totalS - totalP;

  setTotalSale(totalS);
  setTotalPaid(totalP);
  setTotalPayable(totalBal);
}, [filteredInvoicesInSale, filteredSettlements]);


// ---------------- DOWNLOAD EXCEL ----------------
const downloadExcel = () => {
  const dataToExport =
    filteredInvoicesInSale.length > 0
      ? filteredInvoicesInSale
      : invoices;

  if (!dataToExport || dataToExport.length === 0) {
    alert("No invoices to export!");
    return;
  }

  const exportData = dataToExport.map((inv) => {
    const payable = inv.totalAmount || 0; // ✅ FIXED

    return {
      Date: inv.date,
      "Invoice No": inv.invoiceNo,
      Customer: inv.to,
      Phone: inv.patientPhoneNo,
      "Payment Method": inv.paymentMethod,
      Frame: inv.frame,
      Lens: inv.lens,
      "Right Lens": inv.rightLens,
      "Left Lens": inv.leftLens,
      PD: inv.pd,
      SEG: inv.seg,
      "Full Price": inv.amount,
      Advanced: inv.deductAmount,
      "Payable Balance": payable,
    };
  });

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sales Report");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });

  saveAs(
    blob,
    `Sales_Report_${dayjs().format("YYYYMMDD_HHmmss")}.xlsx`
  );
};


// ---------------- DOWNLOAD PDF ----------------
const downloadSalesReportPDF = () => {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  let currentY = 20;

  // Header
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("Ekanayake Optical", pageWidth / 2, currentY, {
    align: "center",
  });
  currentY += 6;

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text(
    "Infront of base hospital, Nawalapitiya Road, Gampola",
    pageWidth / 2,
    currentY,
    { align: "center" }
  );
  currentY += 5;

  doc.text(
    "Tel: 076 55 41 048 / 071 37 60 878",
    pageWidth / 2,
    currentY,
    { align: "center" }
  );
  currentY += 5;

  doc.setFont("helvetica", "bold");
  doc.text("Sales Report", pageWidth / 2, currentY, {
    align: "center",
  });
  currentY += 6;

  let periodText = "";
  if (filterMode === "daily")
    periodText = `Date: ${selectedDate.format("YYYY-MM-DD")}`;
  else if (filterMode === "monthly")
    periodText = `Month: ${selectedDate.format("MMMM YYYY")}`;
  else if (filterMode === "yearly")
    periodText = `Year: ${selectedDate.format("YYYY")}`;

  doc.text(periodText, pageWidth / 2, currentY, {
    align: "center",
  });
  currentY += 8;

  const tableColumn = [
    "Date",
    "Invoice No",
    "Customer",
    "Phone",
    "Payment Method",
    "Frame",
    "Lens",
    "Right Lens",
    "Left Lens",
    "PD",
    "SEG",
    "Full Price",
    "Advanced",
    "Payable Balance",
  ];

  const tableRows = filteredInvoicesInSale.map((inv) => {
    const payable = inv.totalAmount || 0; // ✅ FIXED

    return [
      inv.date,
      inv.invoiceNo,
      inv.to,
      inv.patientPhoneNo,
      inv.paymentMethod,
      inv.frame,
      inv.lens,
      inv.rightLens,
      inv.leftLens,
      inv.pd,
      inv.seg,
      `Rs. ${inv.amount}`,
      `Rs. ${inv.deductAmount}`,
      `Rs. ${payable}`,
    ];
  });

  autoTable(doc, {
    startY: currentY,
    head: [tableColumn],
    body: tableRows,
    styles: { fontSize: 8 },
    theme: "grid",
  });

  const finalY = doc.lastAutoTable.finalY + 6;

  doc.setFont("helvetica", "bold");
  doc.text(`Total Sale: Rs. ${totalSale.toLocaleString()}`, 10, finalY);
  doc.text(`Total Paid: Rs. ${totalPaid.toLocaleString()}`, 80, finalY);
  doc.text(`Total Balance: Rs. ${totalPayable.toLocaleString()}`, 160, finalY);

  doc.save(
    `Sales_Report_${filterMode}_${selectedDate.format("YYYYMMDD")}.pdf`
  );
};





//////////////////////////////////////////////////////// create settle invoice //////////////////////////////////////////////////////////////////////


const searchInvoice = async () => {
  try {
    const q = query(
      collection(db, "invoices"),
      where("invoiceNo", "==", searchInvoiceNo)
    );

    const snap = await getDocs(q);

    if (snap.empty) {
      window.alert("Invoice not found!");
      setFoundInvoice(null);
      return;
    }

    const data = snap.docs[0].data();
    setFoundInvoice({ id: snap.docs[0].id, ...data });

    // Remaining balance
    const balance = parseFloat(data.totalAmount);
    setBalanceAfterSettle(balance);

  } catch (e) {
    console.error(e);
  }
};



const handleSettlePayment = async () => {
  if (!foundInvoice) {
    alert("Search invoice first!");
    return;
  }

  if (!settleDate) {
    alert("Please select settlement date.");
    return;
  }

  const balance = parseFloat(foundInvoice.totalAmount);
  const paidNow = parseFloat(settleAmount);

  if (paidNow <= 0 || paidNow > balance) {
    alert("Invalid settle amount.");
    return;
  }

  const newBalance = balance - paidNow;

  try {
    // 1️⃣ Create settlement record
    await addDoc(collection(db, "settlements"), {
      invoiceNo: foundInvoice.invoiceNo,
      paidAmount: paidNow,
      previousBalance: balance,
      newBalance: newBalance,
      date: new Date(settleDate), // ✅ USER DATE
    });

    // 2️⃣ Update invoice balance
    await updateDoc(doc(db, "invoices", foundInvoice.id), {
      totalAmount: newBalance,
    });

    // 3️⃣ Generate PDF
    createSettlementPDF(foundInvoice, paidNow, newBalance, settleDate);

    alert("Settlement completed!");

    setFoundInvoice(null);
    setSearchInvoiceNo("");
    setSettleAmount("");
    setSettleDate("");
  } catch (e) {
    console.error(e);
    alert("Failed to settle!");
  }
};




// const createSettlementPDF = (invoice, paidNow, newBalance, settleDate) => {
//   const doc = new jsPDF({
//     orientation: "portrait",
//     unit: "mm",
//     format: [80, 170], // Increased to 210mm to accommodate terms
//   });

//   const pageWidth = doc.internal.pageSize.getWidth();
//   const pageHeight = doc.internal.pageSize.getHeight();

//   /* -------------------- HEADER -------------------- */
//   const headerHeight = 25;

//   doc.setFillColor(255, 255, 255);
//   doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");

//   // Logo settings
//   const logoHeight = 18;
//   const logoWidth = 25;
//   const logoY = (headerHeight - logoHeight) / 2;
//   const logoX = (pageWidth - logoWidth) / 2;

//   doc.addImage("/invoice logo.png", "PNG", logoX, logoY, logoWidth, logoHeight);

//   /* -------------------- TITLE -------------------- */
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(14);
//   doc.text("SETTLEMENT BILL", pageWidth / 2, headerHeight + 8, {
//     align: "center",
//   });

//   /* -------------------- BASIC DETAILS -------------------- */
//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(9);

//   let y = headerHeight + 18;

//   doc.text(`Invoice No: ${invoice.invoiceNo}`, 5, y);
//   y += 6;

//   doc.text(`Patient: ${invoice.to}`, 5, y);
//   y += 6;

//   doc.text(`Date: ${new Date(settleDate).toLocaleDateString()}`, 5, y);
//   y += 10;

//   /* -------------------- PAYMENT DETAILS -------------------- */
//   const rightX = pageWidth - 5;
  
//   doc.setFont("helvetica", "bold");
//   doc.text("Total Amount:", 5, y);
//   doc.text(`Rs. ${invoice.amount.toFixed(2)}`, rightX, y, { align: "right" });
//   y += 5;

//   doc.text("Advance Payment:", 5, y);
//   doc.text(`Rs. ${invoice.deductAmount.toFixed(2)}`, rightX, y, { align: "right" });
//   y += 5;

//   doc.text("Previous Balance:", 5, y);
//   doc.text(`Rs. ${invoice.totalAmount.toFixed(2)}`, rightX, y, { align: "right" });
//   y += 5;

//   doc.text("Amount Paid Now:", 5, y);
//   doc.text(`Rs. ${paidNow.toFixed(2)}`, rightX, y, { align: "right" });
//   y += 5;

//   doc.text("New Remaining Balance:", 5, y);
//   doc.text(`Rs. ${newBalance.toFixed(2)}`, rightX, y, { align: "right" });
//   y += 20;

//   /* -------------------- TERMS AND CONDITIONS -------------------- */
//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(7);
//   doc.setTextColor(80, 80, 80);

//   const terms1 = "*THIS RECEIPT VALID ONLY 14 DAYS FROM DATE OF ORDER. ITEMS ONCE SOLD CANNOT BE RETURNED. ADVANCE PAID WOULD NOT BE REFUNDED.";
//   const terms2 = "*THANK YOU VERY MUCH FOR GETTING THE SERVICE FROM OUR COMPANY.";
//   const terms3 = "/ STYLE THAT MAKES SENSE THAT'S EKANAYAKE OPTICIAN FASHIONABLE EYEWEAR FOR YOU.";

//   const termsLines1 = doc.splitTextToSize(terms1, 70);
//   termsLines1.forEach(line => {
//     doc.text(line, pageWidth/2, y, { align: "center" });
//     y += 3.5;
//   });

//   y += 1;

//   const termsLines2 = doc.splitTextToSize(terms2, 70);
//   termsLines2.forEach(line => {
//     doc.text(line, pageWidth/2, y, { align: "center" });
//     y += 3.5;
//   });

//   y += 1;

//   const termsLines3 = doc.splitTextToSize(terms3, 70);
//   termsLines3.forEach(line => {
//     doc.text(line, pageWidth/2, y, { align: "center" });
//     y += 3.5;
//   });

//   y += 7;

//   /* -------------------- FOOTER DETAILS -------------------- */
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(10);
//   doc.setTextColor(0, 0, 0);
//   doc.text("Ekanayake Optical", pageWidth / 2, y, { align: "center" });
//   y += 5;

//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(8);

//   doc.text("Infront of base hospital,", pageWidth / 2, y, { align: "center" });
//   y += 4;
  
//   doc.text("Nawalapitiya Road, Gampola", pageWidth / 2, y, { align: "center" });
//   y += 4;

//   doc.text("Tel: 076 55 41 048 / 071 37 60 878", pageWidth / 2, y, { align: "center" });
//   y += 6;

//   /* -------------------- BLACK FOOTER STRIP -------------------- */
//   doc.setFillColor(0, 0, 128);
//   doc.rect(0, pageHeight - 10, pageWidth, 10, "F");

//   doc.setFontSize(6);
//   doc.setTextColor(255, 255, 255);
  
//   doc.text(
//     "All kinds of Eye wear, Sunglasses, Color Lenses,",
//     pageWidth / 2,
//     pageHeight - 6,
//     { align: "center" }
//   );
  
//   doc.text(
//     "Contact Lenses, and All Eyeware accessories",
//     pageWidth / 2,
//     pageHeight - 3,
//     { align: "center" }
//   );

//   /* -------------------- SAVE PDF -------------------- */
//   doc.save(`Settlement_${invoice.invoiceNo}.pdf`);
// };




const createSettlementPDF = (invoice, paidNow, newBalance, settleDate) => {
    const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a5"
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  let y = 6;

  // ------------------------------
  // HEADER LOGO
  // ------------------------------
 doc.addImage("/new logo.png", "PNG", 10, y, 38, 38);

  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(11);
  doc.text("Ekanayake Optical", pageWidth - 10, 20, { align: "right" });

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
  doc.text("Nawalapitiya Road, Gampola", pageWidth - 10, 27, { align: "right" });
  doc.text("Phone: 076 5541048 / 0713760878", pageWidth - 10, 33, { align: "right" });
  doc.text("Email: ekanayakeopticians@gmail.com", pageWidth - 10, 39, { align: "right" });

  y = 50;

  // ------------------------------
  // WATERMARK
  // ------------------------------
  // const imgProps = doc.getImageProperties("/watermark.png");
  // const watermarkWidth = 120;
  // const watermarkHeight = (imgProps.height * watermarkWidth) / imgProps.width;
  // const centerX = pageWidth / 2 - watermarkWidth / 2;

  // doc.setGState(new doc.GState({ opacity: 0.05 }));
  // doc.addImage("/watermark.png", "PNG", centerX, 90, watermarkWidth, watermarkHeight);
  // doc.setGState(new doc.GState({ opacity: 1 }));

  // Divider
  doc.setLineWidth(0.3);
  doc.line(10, y, pageWidth - 10, y);
  y += 6;

  // ------------------------------
  // INVOICE TITLE
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(14);
  doc.text("SETTLEMENT INVOICE", pageWidth / 2, y, { align: "center" });
  y += 5;

  // ------------------------------
  // CUSTOMER DETAILS
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);
  
  // Patient name with word wrap
  const patientLines = doc.splitTextToSize(`Patient: ${invoice.to}`, 70);
  doc.text(patientLines, 10, y);
  y += patientLines.length * 5 + 3;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
  doc.text(`Invoice No: ${invoice.invoiceNo}`, 10, y);
  y += 7;
  
  // Check if jobNo exists, if not, show N/A or use invoice number
  // const jobNumber = invoice.jobNo || "N/A";
  // doc.text(`Job No: ${jobNumber}`, 10, y);
  // doc.text(`Date: ${invoice.date}`, pageWidth - 10, y, { align: "right" });
  // y += 10;

  // ------------------------------
  // TABLE HEADER (BLUE)
  // ------------------------------
  doc.setFillColor(32, 30, 244);
  doc.setTextColor(255, 255, 255);
  doc.rect(10, y, pageWidth - 20, 7, "F");

  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(9);
  doc.text("Description", 12, y + 5);
  doc.text("Amount (Rs)", pageWidth - 12, y + 5, { align: "right" });
  y += 12;
  doc.setTextColor(0, 0, 0);

  // ------------------------------
  // TABLE BODY
  // ------------------------------
  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);

  if (invoice.frame) {
    doc.text("Frame:", 12, y);
    const frameLines = doc.splitTextToSize(invoice.frame, 45);
    doc.text(frameLines, 35, y);
    y += frameLines.length * 4.5 + 3;
  }

  if (invoice.lens) {
    doc.text("Lens:", 12, y);
    const lensLines = doc.splitTextToSize(invoice.lens, 45);
    doc.text(lensLines, 35, y);
    y += lensLines.length * 4.5 + 3;
  }

  if (invoice.description) {
    const lines = doc.splitTextToSize(invoice.description, pageWidth - 30);
    lines.forEach((line) => {
      doc.text(line, 12, y);
      y += 4.5;
    });
    y += 3;
  }

  doc.line(10, y, pageWidth - 10, y);
  y += 8;

  // ------------------------------
  // TOTALS
  // ------------------------------
  doc.text("Total Amount:", pageWidth - 55, y);
  doc.text(`Rs ${invoice.amount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 6;

  doc.text("Advance Paid:", pageWidth - 55, y);
  doc.text(`Rs ${invoice.deductAmount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 6;

  doc.setFont("Times New Roman", "bold");
  doc.text("Total Payable:", pageWidth - 55, y);
  doc.text(`Rs ${invoice.totalAmount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 10;
  doc.setFont("Times New Roman", "normal");

  // ------------------------------
  // SETTLEMENTS SECTION (SINGLE LINE FORMAT)
  // ------------------------------
  /* -------------------- PAYMENT DETAILS -------------------- */
  const rightX = pageWidth - 5;
  
  doc.setFont("helvetica", "normal");


/* -------------------- PAYMENT DETAILS -------------------- */

doc.setFont("helvetica", "normal");

const labelX = 10;
const valueX = pageWidth - 10;
const lineGap = 5;

// Row 1 — Previous Balance
doc.text("Previous Balance:", labelX, y);
doc.text(`Rs. ${invoice.totalAmount.toFixed(2)}`, valueX, y, { align: "right" });
y += lineGap;

// Row 2 — Amount Paid Now
doc.text("Amount Paid Now:", labelX, y);
doc.text(`Rs. ${paidNow.toFixed(2)}`, valueX, y, { align: "right" });
y += lineGap;

// Row 3 — New Remaining Balance
doc.text("New Remaining Balance:", labelX, y);
doc.text(`Rs. ${newBalance.toFixed(2)}`, valueX, y, { align: "right" });
y += 15;




  // ------------------------------
  // TERMS & CONDITIONS
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(8);
  doc.text("Terms & Conditions:", 10, y);
  y += 5;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(8);
  doc.setTextColor(80, 80, 80);
  
  const terms = [
    "* THIS RECEIPT VALID ONLY 14 DAYS FROM DATE OF ORDER.",
    "* ITEMS ONCE SOLD CANNOT BE RETURNED.",
    "* THANK YOU VERY MUCH FOR GETTING THE SERVICE FROM US.",
    "* STYLE THAT MAKES SENSE THAT'S EKANAYAKE OPTICIAN FASHIONABLE EYEWEAR FOR YOU."
  ];

  terms.forEach(term => {
    const lines = doc.splitTextToSize(term, pageWidth - 20);
    lines.forEach(line => {
      doc.text(line, 12, y);
      y += 4;
    });
  });

  y += 5;

  // ------------------------------
  // FOOTER WITH QR AND 25 YEARS LOGO
  // ------------------------------
  // const footerHeight = 30;
  // const footerY = pageHeight - footerHeight - 3;

  // // QR (Left)
  // doc.addImage("/qr-kingdom.png", "PNG", 8, footerY + 5, 22, 22);

  // // "SCAN ME" text
  // doc.setFont("Times New Roman", "Bold");
  // doc.setFontSize(10);
  // doc.setTextColor(0, 0, 0);
  // doc.text("SCAN ME", 35, footerY + 12);

  // doc.setFontSize(8);
  // doc.setTextColor(32, 30, 244);
  // doc.setFont("Times New Roman", "normal");
  // doc.text("Please Give Us a Review", 35, footerY + 18);
  // doc.text("If you are Satisfied", 35, footerY + 23);

  // // 25 YEARS LOGO (Right)
  // doc.addImage("/25years.png", "PNG", pageWidth - 48, footerY + 2, 42, 32);

  // ------------------------------
  // SAVE PDF
  // ------------------------------
  doc.save(`Settlement_Invoice_${invoice.invoiceNo}.pdf`);
};















///////////////////////////////////////////// view all settle invoices////////////////////////////////////////////////////////
const [settledInvoices, setSettledInvoices] = useState([]);
const [loadingInvoices, setLoadingInvoices] = useState(false);

// ---------------- FILTER STATES ----------------
const [filterYear, setFilterYear] = useState("");
const [filterMonth, setFilterMonth] = useState("");
const [filterDate, setFilterDate] = useState("");
const [filterInvoiceNo, setFilterInvoiceNo] = useState("");
const [filterPatient, setFilterPatient] = useState("");

// ---------------- SAFE DATE ----------------
const getSafeDate = (date) => {
  if (!date) return null;

  if (date?.toDate && typeof date.toDate === "function") {
    return date.toDate();
  }

  const parsed = new Date(date);
  return isNaN(parsed.getTime()) ? null : parsed;
};

// ---------------- FETCH DATA ----------------
const fetchSettledInvoices = async () => {
  setLoadingInvoices(true);

  try {
    const invoiceSnapshot = await getDocs(collection(db, "invoices"));
    const settleSnapshot = await getDocs(collection(db, "settlements"));

    const invoiceData = invoiceSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    const settleData = settleSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // Merge settlements into invoices
    const merged = invoiceData
      .map((inv) => {
        const relatedSettlements = settleData.filter(
          (s) =>
            String(s.invoiceNo || "").trim() ===
            String(inv.invoiceNo || "").trim()
        );

        return {
          ...inv,
          settlements: relatedSettlements,
        };
      })
      .filter((inv) => inv.settlements.length > 0);

    setSettledInvoices(merged);
  } catch (error) {
    console.error("Fetch error:", error);
  } finally {
    setLoadingInvoices(false);
  }
};

// ---------------- FETCH ONLY WHEN TAB OPEN ----------------
useEffect(() => {
  if (selectedOption === "viewallsettleInvoice") {
    fetchSettledInvoices();
  }
}, [selectedOption]);

// ---------------- FILTERED DATA ----------------
const filteredSettleInvoices = useMemo(() => {
  return settledInvoices.filter((inv) => {
    let matches = true;

    const settlementDate = getSafeDate(inv.settlements?.[0]?.date);

    // Year
    if (filterYear && settlementDate) {
      matches =
        matches &&
        settlementDate.getFullYear().toString() === filterYear;
    }

    // Month
    if (filterMonth && settlementDate) {
      matches =
        matches &&
        String(settlementDate.getMonth() + 1).padStart(2, "0") ===
          filterMonth;
    }

    // Date
    if (filterDate && settlementDate) {
      matches =
        matches &&
        String(settlementDate.getDate()).padStart(2, "0") ===
          filterDate;
    }

    // Invoice Number
    if (filterInvoiceNo) {
      matches =
        matches &&
        String(inv.invoiceNo || "")
          .toLowerCase()
          .includes(filterInvoiceNo.toLowerCase());
    }

    // Patient
    if (filterPatient) {
      const searchText = `${inv.to || ""} ${inv.patientPhoneNo || ""}`.toLowerCase();

      matches =
        matches &&
        searchText.includes(filterPatient.toLowerCase());
    }

    return matches;
  });
}, [
  settledInvoices,
  filterYear,
  filterMonth,
  filterDate,
  filterInvoiceNo,
  filterPatient,
]);






// Replace your existing handleDeleteSettleInvoice function with this one

const handleDeleteSettleInvoice = async (invoice) => {
  const confirmDelete = window.confirm(
    `Delete invoice ${invoice.invoiceNo} and all its settlements?`
  );

  if (!confirmDelete) return;

  // Ask password
  const enteredPassword = window.prompt(
    "Enter password to delete invoice:"
  );

  if (enteredPassword === null) return; // Cancel pressed

  if (enteredPassword !== "naveen000") {
    alert("Incorrect password! Deletion cancelled.");
    return;
  }

  try {
    const batch = writeBatch(db);

    // Delete invoice
    batch.delete(doc(db, "invoices", invoice.id));

    // Delete related settlements
    invoice.settlements?.forEach((s) => {
      batch.delete(doc(db, "settlements", s.id));
    });

    await batch.commit();

    // Remove from UI
    setInvoices((prev) =>
      prev.filter((inv) => inv.id !== invoice.id)
    );

    alert("Deleted successfully");
  } catch (error) {
    console.error("Delete failed:", error);
    alert("Failed to delete invoice");
  }
};






// const downloadSettlementInvoice = (invoice) => {
//   const doc = new jsPDF({ 
//     orientation: "portrait", 
//     unit: "mm", 
//     format: [80, 230] // Increased length to 210mm to accommodate terms
//   });

//   // --- Header ---
//   const headerHeight = 30;
//   const pageWidth = doc.internal.pageSize.getWidth();
//   const pageHeight = doc.internal.pageSize.getHeight();

//   doc.setFillColor(255, 255, 255);
//   doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");

//   // Logo settings
//   const logoHeight = 25;
//   const logoWidth = 70;
//   const logoY = (headerHeight - logoHeight) / 2;
//   const logoX = (pageWidth - logoWidth) / 2;

//   // Add logo
//   doc.addImage("/invoice logo.png", "PNG", logoX, logoY, logoWidth, logoHeight);

//   doc.setFontSize(14);
//   doc.setTextColor(0, 0, 0);
//   doc.text("INVOICE (Settlement)", doc.internal.pageSize.getWidth() / 2, 35, { align: "center" });

//   const detailsY = 45;
//   doc.setFontSize(9);
  
//   // Patient name with line break if needed
//   const patientLines = doc.splitTextToSize(`Patient: ${invoice.to}`, 60);
//   doc.text(patientLines, 10, detailsY);
// doc.text(`Invoice No: ${invoice.invoiceNo}`, 10, currentY);
  

//   doc.text(`Date: ${invoice.date}`, doc.internal.pageSize.getWidth() - 10, detailsY + 5, { align: "right" });

//   // Calculate Y position after patient name (if it wrapped)
//   let currentY = detailsY + (patientLines.length * 5) + 10;

//   doc.setDrawColor(0);
//   doc.setFillColor(173, 216, 230);
//   doc.rect(10, currentY, doc.internal.pageSize.getWidth() - 20, 8, "F");
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(9);
//   doc.text("DESCRIPTION", 12, currentY + 6);
//   doc.text("AMOUNT", doc.internal.pageSize.getWidth() - 12, currentY + 6, { align: "right" });
//   currentY += 12;

//   if (invoice.frame) {
//     doc.setFont("helvetica", "bold");
//     doc.text("Frame:", 12, currentY);
//     doc.setFont("helvetica", "normal");
    
//     const frameLines = doc.splitTextToSize(invoice.frame, 45);
//     doc.text(frameLines, 35, currentY);
//     currentY += (frameLines.length * 5) + 3;
//   }

//   if (invoice.lens) {
//     doc.setFont("helvetica", "bold");
//     doc.text("Lens:", 12, currentY);
//     doc.setFont("helvetica", "normal");
    
//     const lensLines = doc.splitTextToSize(invoice.lens, 45);
//     doc.text(lensLines, 35, currentY);
//     currentY += (lensLines.length * 5) + 3;
//   }

//   doc.setFont("helvetica", "bold");
//   doc.text("Total Amount:", 12, currentY);
//   doc.setFont("helvetica", "normal");
//   doc.text(`Rs. ${invoice.amount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 12, currentY, { align: "right" });
//   currentY += 5;

//   doc.setFont("helvetica", "bold");
//   doc.text("Advance Paid:", 12, currentY);
//   doc.setFont("helvetica", "normal");
//   doc.text(`Rs. ${invoice.deductAmount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 12, currentY, { align: "right" });
//   currentY += 5;

//   doc.setFont("helvetica", "bold");
//   doc.text("Total Payable:", 12, currentY);
//   doc.setFont("helvetica", "normal");
//   doc.text(`Rs. ${invoice.totalAmount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 12, currentY, { align: "right" });
//   currentY += 10;

//   if (invoice.settlements && invoice.settlements.length > 0) {
//     doc.setFont("helvetica", "bold");
//     doc.text("SETTLEMENTS:", 12, currentY);
//     currentY += 8;

//     invoice.settlements.forEach((s, index) => {
//       doc.setFontSize(8);
      
//       const dateStr = getSafeDate(s.date)?.toLocaleDateString() || 'N/A';
      
//       doc.text(`${index + 1}. Date: ${dateStr}`, 12, currentY);
//       currentY += 4;
      
//       doc.text(`Paid: Rs. ${s.paidAmount.toFixed(2)}`, 15, currentY);
//       currentY += 4;
      
//       doc.text(`Balance: Rs. ${s.newBalance.toFixed(2)}`, 15, currentY);
//       currentY += 6;
      
//       doc.setFontSize(9);
//     });
//   } else {
//     doc.setFont("helvetica", "normal");
//     doc.text("No settlements recorded.", 12, currentY);
//     currentY += 6;
//   }

//   currentY += 25;

//   // TERMS AND CONDITIONS
//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(7);
//   doc.setTextColor(80, 80, 80);

//   const terms1 = "*THIS RECEIPT VALID ONLY 14 DAYS FROM DATE OF ORDER. ITEMS ONCE SOLD CANNOT BE RETURNED. ADVANCE PAID WOULD NOT BE REFUNDED.";
//   const terms2 = "*THANK YOU VERY MUCH FOR GETTING THE SERVICE FROM OUR COMPANY.";
//   const terms3 = "/ STYLE THAT MAKES SENSE THAT'S EKANAYAKE OPTICIAN FASHIONABLE EYEWEAR FOR YOU.";

//   const termsLines1 = doc.splitTextToSize(terms1, 70);
//   termsLines1.forEach(line => {
//     doc.text(line, pageWidth/2, currentY, {align:"center"});
//     currentY += 3.5;
//   });

//   currentY += 1;

//   const termsLines2 = doc.splitTextToSize(terms2, 70);
//   termsLines2.forEach(line => {
//     doc.text(line, pageWidth/2, currentY, {align:"center"});
//     currentY += 3.5;
//   });

//   currentY += 1;

//   const termsLines3 = doc.splitTextToSize(terms3, 70);
//   termsLines3.forEach(line => {
//     doc.text(line, pageWidth/2, currentY, {align:"center"});
//     currentY += 3.5;
//   });

//   currentY += 8;

//   // Footer
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(10);
//   doc.setTextColor(0, 0, 0);
//   doc.text("Ekanayake Optical", pageWidth / 2, currentY, { align: "center" });
//   currentY += 5;

//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(8);
  
//   const addressLines = doc.splitTextToSize("Infront of base hospital, Nawalapitiya Road, Gampola", 70);
//   addressLines.forEach(line => {
//     doc.text(line, pageWidth / 2, currentY, { align: "center" });
//     currentY += 4;
//   });

//   doc.text("Tel: 076 554 1048 / 071 376 0878", pageWidth / 2, currentY, { align: "center" });
//   currentY += 6;

//   doc.setFillColor(0, 0, 128);
//   doc.rect(0, pageHeight - 12, pageWidth, 12, "F");
//   doc.setFontSize(6);
//   doc.setTextColor(255, 255, 255);
  
//   const footerLines = doc.splitTextToSize(
//     "All kinds of Eye wear, Sunglasses, Color Lenses, Contact Lenses, and All Eyeware accessories",
//     75
//   );
  
//   let footerY = pageHeight - 8;
//   footerLines.forEach(line => {
//     doc.text(line, pageWidth / 2, footerY, { align: "center" });
//     footerY += 3;
//   });

//   doc.save(`Settlement_Invoice_${invoice.invoiceNo}.pdf`);
// };

// const downloadSettlementInvoice = (invoice) => {
//   const doc = new jsPDF({
//     orientation: "portrait",
//     unit: "mm",
//     format: [80, 230]
//   });

//   const pageWidth = doc.internal.pageSize.getWidth();
//   const pageHeight = doc.internal.pageSize.getHeight();

//   // ===============================
//   // HEADER
//   // ===============================
//   const headerHeight = 30;

//   doc.setFillColor(255, 255, 255);
//   doc.rect(0, 0, pageWidth, headerHeight, "F");

//   const logoWidth = 30;
//   const logoHeight = 25;
//   const logoX = (pageWidth - logoWidth) / 2;
//   const logoY = (headerHeight - logoHeight) / 2;

//   doc.addImage("/invoice logo.png", "PNG", logoX, logoY, logoWidth, logoHeight);

//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(13);
//   doc.setTextColor(0, 0, 0);
//   doc.text("INVOICE (Settlement)", pageWidth / 2, 35, { align: "center" });

//   // ===============================
//   // CUSTOMER DETAILS
//   // ===============================
//   const detailsY = 45;

//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(9);

//   const patientLines = doc.splitTextToSize(
//     `Patient: ${invoice.to || "-"}`,
//     60
//   );

//   doc.text(patientLines, 10, detailsY);

//   // FIXED ERROR HERE
//   let currentY = detailsY + (patientLines.length * 5) + 5;

//   doc.text(`Invoice No: ${invoice.invoiceNo || "-"}`, 10, currentY);

//   doc.text(
//     `Date: ${invoice.date || "-"}`,
//     pageWidth - 10,
//     detailsY + 5,
//     { align: "right" }
//   );

//   currentY += 8;

//   // ===============================
//   // TABLE HEADER
//   // ===============================
//   doc.setFillColor(173, 216, 230);
//   doc.rect(10, currentY, pageWidth - 20, 8, "F");

//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(9);
//   doc.text("DESCRIPTION", 12, currentY + 6);
//   doc.text("AMOUNT", pageWidth - 12, currentY + 6, { align: "right" });

//   currentY += 12;

//   // ===============================
//   // FRAME
//   // ===============================
//   if (invoice.frame) {
//     doc.setFont("helvetica", "bold");
//     doc.text("Frame:", 12, currentY);

//     doc.setFont("helvetica", "normal");
//     const frameLines = doc.splitTextToSize(invoice.frame, 42);
//     doc.text(frameLines, 30, currentY);

//     currentY += (frameLines.length * 5) + 3;
//   }

//   // ===============================
//   // LENS
//   // ===============================
//   if (invoice.lens) {
//     doc.setFont("helvetica", "bold");
//     doc.text("Lens:", 12, currentY);

//     doc.setFont("helvetica", "normal");
//     const lensLines = doc.splitTextToSize(invoice.lens, 42);
//     doc.text(lensLines, 30, currentY);

//     currentY += (lensLines.length * 5) + 3;
//   }

//   // ===============================
//   // TOTALS
//   // ===============================
//   const amount = Number(invoice.amount || 0);
//   const advance = Number(invoice.deductAmount || 0);
//   const balance = Number(invoice.totalAmount || 0);

//   doc.setFont("helvetica", "bold");
//   doc.text("Total Amount:", 12, currentY);
//   doc.setFont("helvetica", "normal");
//   doc.text(`Rs. ${amount.toFixed(2)}`, pageWidth - 12, currentY, {
//     align: "right"
//   });

//   currentY += 5;

//   doc.setFont("helvetica", "bold");
//   doc.text("Advance Paid:", 12, currentY);
//   doc.setFont("helvetica", "normal");
//   doc.text(`Rs. ${advance.toFixed(2)}`, pageWidth - 12, currentY, {
//     align: "right"
//   });

//   currentY += 5;

//   doc.setFont("helvetica", "bold");
//   doc.text("Total Payable:", 12, currentY);
//   doc.setFont("helvetica", "normal");
//   doc.text(`Rs. ${balance.toFixed(2)}`, pageWidth - 12, currentY, {
//     align: "right"
//   });

//   currentY += 10;

//   // ===============================
//   // SETTLEMENTS
//   // ===============================
//   if (invoice.settlements && invoice.settlements.length > 0) {
//     doc.setFont("helvetica", "bold");
//     doc.text("SETTLEMENTS:", 12, currentY);
//     currentY += 8;

//     invoice.settlements.forEach((s, index) => {
//       doc.setFontSize(8);

//       const dateStr =
//         getSafeDate(s.date)?.toLocaleDateString() || "N/A";

//       const paid = Number(s.paidAmount || 0);
//       const bal = Number(s.newBalance || 0);

//       doc.text(`${index + 1}. Date: ${dateStr}`, 12, currentY);
//       currentY += 4;

//       doc.text(`Paid: Rs. ${paid.toFixed(2)}`, 15, currentY);
//       currentY += 4;

//       doc.text(`Balance: Rs. ${bal.toFixed(2)}`, 15, currentY);
//       currentY += 6;

//       doc.setFontSize(9);
//     });
//   } else {
//     doc.setFont("helvetica", "normal");
//     doc.text("No settlements recorded.", 12, currentY);
//     currentY += 6;
//   }

//   currentY += 10;

//   // ===============================
//   // TERMS
//   // ===============================
//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(7);
//   doc.setTextColor(80, 80, 80);

//   const terms = [
//     "*THIS RECEIPT VALID ONLY 14 DAYS FROM DATE OF ORDER.",
//     "ITEMS ONCE SOLD CANNOT BE RETURNED.",
//     "ADVANCE PAID WOULD NOT BE REFUNDED.",
//     "*THANK YOU VERY MUCH FOR GETTING THE SERVICE.",
//     "STYLE THAT MAKES SENSE THAT'S EKANAYAKE OPTICIAN."
//   ];

//   terms.forEach((text) => {
//     const lines = doc.splitTextToSize(text, 70);
//     lines.forEach((line) => {
//       doc.text(line, pageWidth / 2, currentY, { align: "center" });
//       currentY += 3.5;
//     });
//     currentY += 1;
//   });

//   currentY += 5;

//   // ===============================
//   // FOOTER SHOP DETAILS
//   // ===============================
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(10);
//   doc.setTextColor(0, 0, 0);
//   doc.text("Ekanayake Optical", pageWidth / 2, currentY, {
//     align: "center"
//   });

//   currentY += 5;

//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(8);

//   const addressLines = doc.splitTextToSize(
//     "Infront of base hospital, Nawalapitiya Road, Gampola",
//     70
//   );

//   addressLines.forEach((line) => {
//     doc.text(line, pageWidth / 2, currentY, { align: "center" });
//     currentY += 4;
//   });

//   doc.text(
//     "Tel: 076 554 1048 / 071 376 0878",
//     pageWidth / 2,
//     currentY,
//     { align: "center" }
//   );

//   // ===============================
//   // BLUE BOTTOM BAR
//   // ===============================
//   doc.setFillColor(0, 0, 128);
//   doc.rect(0, pageHeight - 12, pageWidth, 12, "F");

//   doc.setFontSize(6);
//   doc.setTextColor(255, 255, 255);

//   const footerLines = doc.splitTextToSize(
//     "All kinds of Eye wear, Sunglasses, Color Lenses, Contact Lenses & Accessories",
//     75
//   );

//   let footerY = pageHeight - 8;

//   footerLines.forEach((line) => {
//     doc.text(line, pageWidth / 2, footerY, { align: "center" });
//     footerY += 3;
//   });

//   // ===============================
//   // SAVE
//   // ===============================
//   doc.save(`Settlement_Invoice_${invoice.invoiceNo}.pdf`);
// };




const downloadSettlementInvoice = (invoice) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a5"
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  let y = 3;

  // ------------------------------
  // HEADER LOGO
  // ------------------------------
  doc.addImage("/new logo.png", "PNG", 10, y, 38, 38);

  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(11);
  doc.text("Ekanayake Optical", pageWidth - 10, 20, { align: "right" });

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
  doc.text("Nawalapitiya Road, Gampola", pageWidth - 10, 27, { align: "right" });
  doc.text("Phone: 076 5541048 / 0713760878", pageWidth - 10, 33, { align: "right" });
  doc.text("Email: ekanayakeopticians@gmail.com", pageWidth - 10, 39, { align: "right" });

  y = 58;

  // ------------------------------
  // WATERMARK
  // ------------------------------
  // const imgProps = doc.getImageProperties("/watermark.png");
  // const watermarkWidth = 120;
  // const watermarkHeight = (imgProps.height * watermarkWidth) / imgProps.width;
  // const centerX = pageWidth / 2 - watermarkWidth / 2;

  // doc.setGState(new doc.GState({ opacity: 0.05 }));
  // doc.addImage("/watermark.png", "PNG", centerX, 90, watermarkWidth, watermarkHeight);
  // doc.setGState(new doc.GState({ opacity: 1 }));

  // Divider
  doc.setLineWidth(0.3);
  doc.line(10, y, pageWidth - 10, y);
  y += 6;

  // ------------------------------
  // INVOICE TITLE
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(14);
  doc.text("SETTLEMENT INVOICE", pageWidth / 2, y, { align: "center" });
  y += 5;

  // ------------------------------
  // CUSTOMER DETAILS
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);
  
  // Patient name with word wrap
  const patientLines = doc.splitTextToSize(`Patient: ${invoice.to}`, 70);
  doc.text(patientLines, 10, y);
  y += patientLines.length * 5 + 3;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
doc.text(`Invoice No: ${invoice.invoiceNo}`, 10, y);
y += 8;
// Check if jobNo exists, if not, show N/A or use invoice number
// const jobNumber = invoice.jobNo || "N/A";
// doc.text(`Job No: ${jobNumber}`, 10, y);
doc.text(`Date: ${invoice.date}`, pageWidth - 10, y, { align: "right" });
y += 2;

  // ------------------------------
  // TABLE HEADER (BLUE)
  // ------------------------------
  doc.setFillColor(32, 30, 244);
  doc.setTextColor(255, 255, 255);
  doc.rect(10, y, pageWidth - 20, 7, "F");

  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(9);
  doc.text("Description", 12, y + 5);
  doc.text("Amount (Rs)", pageWidth - 12, y + 5, { align: "right" });
  y += 12;
  doc.setTextColor(0, 0, 0);

  // ------------------------------
  // TABLE BODY
  // ------------------------------
  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);

  if (invoice.frame) {
    doc.text("Frame:", 12, y);
    const frameLines = doc.splitTextToSize(invoice.frame, 45);
    doc.text(frameLines, 35, y);
    y += frameLines.length * 4.5 + 3;
  }

  if (invoice.lens) {
    doc.text("Lens:", 12, y);
    const lensLines = doc.splitTextToSize(invoice.lens, 45);
    doc.text(lensLines, 35, y);
    y += lensLines.length * 4.5 + 3;
  }

  if (invoice.description) {
    const lines = doc.splitTextToSize(invoice.description, pageWidth - 30);
    lines.forEach((line) => {
      doc.text(line, 12, y);
      y += 4.5;
    });
    y += 3;
  }

  doc.line(10, y, pageWidth - 10, y);
  y += 8;

  // ------------------------------
  // TOTALS
  // ------------------------------
  doc.text("Total Amount:", pageWidth - 55, y);
  doc.text(`Rs ${invoice.amount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 6;

  doc.text("Advance Paid:", pageWidth - 55, y);
  doc.text(`Rs ${invoice.deductAmount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 6;

  doc.setFont("Times New Roman", "bold");
  doc.text("Total Payable:", pageWidth - 55, y);
  doc.text(`Rs ${invoice.totalAmount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 5;
  doc.setFont("Times New Roman", "normal");

 // ------------------------------
// SETTLEMENTS SECTION
// ------------------------------
if (invoice.settlements?.length > 0) {
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(9);
  doc.text("SETTLEMENT HISTORY:", 10, y);
  y += 6;
  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(8);

  invoice.settlements.forEach((s, index) => {
    // Handle Firebase Timestamp
    const getSafeDate = (date) => {
      if (!date) return null;
      if (date.toDate && typeof date.toDate === 'function') {
        return date.toDate();
      }
      const parsedDate = new Date(date);
      return isNaN(parsedDate.getTime()) ? null : parsedDate;
    };
    
    const dateObj = getSafeDate(s.date);
    const dateStr = dateObj ? dateObj.toLocaleDateString() : "N/A";

    // SINGLE LINE FORMAT: 1. Date: 10/04/2026 | Paid: Rs 5000.00 | Balance: Rs 0.00
    const settlementText = `${index + 1}. Date: ${dateStr} | Paid: Rs ${s.paidAmount.toFixed(2)} | Balance: Rs ${s.newBalance.toFixed(2)}`;
    
    // Split text if too long for page width
    const maxWidth = pageWidth - 20; // Leave margins
    const lines = doc.splitTextToSize(settlementText, maxWidth);
    
    lines.forEach((line, lineIndex) => {
      doc.text(line, 12, y + (lineIndex * 4));
    });
    
    y += lines.length * 4 + 3;
  });
} else {
  doc.text("No settlements recorded.", 12, y);
  y += 6;
}
  // ------------------------------
  // TERMS & CONDITIONS
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(8);
  doc.text("Terms & Conditions:", 10, y);
  y += 5;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(7);
  doc.setTextColor(80, 80, 80);
  
  const terms = [
    "* THIS RECEIPT VALID ONLY 14 DAYS FROM DATE OF ORDER.",
    "* ITEMS ONCE SOLD CANNOT BE RETURNED.",
    "* THANK YOU VERY MUCH FOR GETTING THE SERVICE FROM US.",
    "* STYLE THAT MAKES SENSE THAT'S EKANAYAKE OPTICIAN FASHIONABLE EYEWEAR FOR YOU."
  ];

  terms.forEach(term => {
    const lines = doc.splitTextToSize(term, pageWidth - 20);
    lines.forEach(line => {
      doc.text(line, 12, y);
      y += 4;
    });
  });

  y += 3;
  
  

 


//  const footerHeight = 30;
// const footerY = pageHeight - footerHeight - 3; // Tighter bottom margin

// // QR (Left) - slightly smaller
// doc.addImage("/qr-kingdom.png", "PNG", 8, footerY + 5, 22, 22);

// // "SCAN ME" text - moved closer and compact
// doc.setFont("Times New Roman", "Bold");
// doc.setFontSize(10);
// doc.setTextColor(0, 0, 0);
// doc.text("SCAN ME", 35, footerY + 12);

// doc.setFontSize(8);
// doc.setTextColor(32, 30, 244);
// doc.setFont("Times New Roman", "normal");
// doc.text("Please Give Us a Review", 35, footerY + 18);
// doc.text("If you are Satisfied", 35, footerY + 23);

// // 25 YEARS LOGO (Right) - slightly smaller
// doc.addImage("/25years.png", "PNG", pageWidth - 48, footerY + 2, 42, 32);

  // ------------------------------
  // SAVE PDF
  // ------------------------------
  doc.save(`Settlement_Invoice_${invoice.invoiceNo}.pdf`);
};













// // --- Filter States ---
// const [filterYear, setFilterYear] = useState("");
// const [filterMonth, setFilterMonth] = useState("");
// const [filterDate, setFilterDate] = useState("");
// const [filterInvoiceNo, setFilterInvoiceNo] = useState("");
// const [filterPatient, setFilterPatient] = useState("");

// // --- Filtered invoices ---
// const filteredSettleInvoices = useMemo(() => {
//   return invoices.filter((inv) => {
//     if (!inv.settlements || inv.settlements.length === 0) return false;

//     let matches = true;

//     // Use first settlement date for filtering
//     const settlementDate = getSafeDate(inv.settlements[0]?.date);

//     if (filterYear && settlementDate) {
//       matches &&= settlementDate.getFullYear().toString() === filterYear;
//     }

//     if (filterMonth && settlementDate) {
//       matches &&=
//         String(settlementDate.getMonth() + 1).padStart(2, "0") === filterMonth;
//     }

//     if (filterDate && settlementDate) {
//       matches &&=
//         String(settlementDate.getDate()).padStart(2, "0") === filterDate;
//     }

//     if (filterInvoiceNo) {
//       matches &&= String(inv.invoiceNo)
//         .toLowerCase()
//         .includes(filterInvoiceNo.toLowerCase());
//     }

//     if (filterPatient) {
//       const patientData = `${inv.to || ""}${inv.patientPhoneNo || ""}`.toLowerCase();
//       matches &&= patientData.includes(filterPatient.toLowerCase());
//     }

//     return matches;
//   });
// }, [invoices, filterYear, filterMonth, filterDate, filterInvoiceNo, filterPatient]);



/////////////////////////////////////////////////////// birthday wish ////////////////////////////////////////////

const [birthdayPatients, setBirthdayPatients] = useState([]);
const [loadingBirthdays, setLoadingBirthdays] = useState(true);


const loadBirthdays = async () => {
  try {
    setLoadingBirthdays(true);

    const snapshot = await getDocs(
      collection(db, "eyeExams")
    );

    const patients = snapshot.docs
      .map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      .filter(
        (patient) =>
          patient.patientInfo?.dob
      );

    setBirthdayPatients(patients);
  } catch (error) {
    console.error(error);
  } finally {
    setLoadingBirthdays(false);
  }
};

useEffect(() => {
  loadBirthdays();
}, []);







const sendBirthdayWish = (patient) => {
  const patientName =
    patient.patientInfo?.name || "";

  const phone =
    patient.patientInfo?.contactNo || "";

  const cleaned = phone.replace(/\D/g, "");

  const isMobile =
    cleaned.startsWith("07") &&
    cleaned.length === 10;

  if (!isMobile) {
    alert(
      "This number is not WhatsApp enabled. Please make a normal call."
    );
    return;
  }

  const whatsappNo = `94${cleaned.substring(
    1
  )}`;

  const message = `Dear ${patientName},

Happy Birthday!

Wishing you a wonderful day filled with happiness, good health, and success.

Warm wishes from all of us at Ekanayake Optical at Gampola.

Have a fantastic birthday!`;

  window.open(
    `https://wa.me/${whatsappNo}?text=${encodeURIComponent(
      message
    )}`,
    "_blank"
  );
};






const isBirthdayMatch = (
  dob,
  targetDate
) => {
  if (!dob) return false;

  const birthDate = new Date(dob);

  return (
    birthDate.getDate() ===
      targetDate.getDate() &&
    birthDate.getMonth() ===
      targetDate.getMonth()
  );
};

const today = new Date();

const tomorrow = new Date();
tomorrow.setDate(today.getDate() + 1);

const dayAfterTomorrow = new Date();
dayAfterTomorrow.setDate(
  today.getDate() + 2
);

const todayBirthdays =
  birthdayPatients.filter((p) =>
    isBirthdayMatch(
      p.patientInfo?.dob,
      today
    )
  );

const tomorrowBirthdays =
  birthdayPatients.filter((p) =>
    isBirthdayMatch(
      p.patientInfo?.dob,
      tomorrow
    )
  );

const dayAfterTomorrowBirthdays =
  birthdayPatients.filter((p) =>
    isBirthdayMatch(
      p.patientInfo?.dob,
      dayAfterTomorrow
    )
  );



  const BirthdayCard = ({
  patient,
  color,
}) => (
  <div
    style={{
      background: "#fff",
      borderRadius: "14px",
      padding: "14px",
      marginBottom: "10px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      border: "1px solid #e2e8f0",
      boxShadow:
        "0 2px 8px rgba(0,0,0,.05)",
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
      }}
    >
      <div
        style={{
          width: "15px",
          height: "15px",
          borderRadius: "50%",
          background: color,
        }}
      />

      <div>
        <div
          style={{
            fontWeight: 600,
            color: "#0f172a",
          }}
        >
          {patient.patientInfo?.name}
        </div>

        <div
          style={{
            color: "#64748b",
            fontSize: "13px",
          }}
        >
          🎂 {patient.patientInfo?.dob}
        </div>
      </div>
    </div>

    <button
      onClick={() =>
        sendBirthdayWish(patient)
      }
      style={{
        background: "#25D366",
        color: "#fff",
        border: "none",
        borderRadius: "8px",
        padding: "8px 12px",
        cursor: "pointer",
        fontWeight: "600",
      }}
    >
      {patient.patientInfo?.contactNo}
    </button>
  </div>
);







return (

    <div className="hero-dashboard-container">
      {/* Left Sidebar */}
      <div className="lecturer-sidebar">
      <div className="home-content">
              <img
                src="/new logo.png" 
                alt="Ekanayake Optical"
              
              />
              </div>
        <h2 className="lecturer-sidebar-title">Ekanayake Optical</h2>

        <div className="lecturer-sidebar-list">
        <li onClick={() => setSelectedOption("addPatient")}>Add Patient</li>
        <li onClick={() => setSelectedOption("viewPatients")}>View All Patients</li>
        <li onClick={() => setSelectedOption("createInvoice")}>Create Invoice</li>
        <li onClick={() => setSelectedOption("settleInvoice")}>Create Settle Invoice</li>

        <li onClick={() => setSelectedOption("viewInvoice")}>View All Previous Invoice</li>
        <li onClick={() => setSelectedOption("viewallsettleInvoice")}>View All Settlement Invoice</li>
             {/* <li onClick={() => setSelectedOption("previousConsultation")}>View Previous Consultation</li> */}
        <li onClick={() => setSelectedOption("eyeExam")}>Create Eye Exam Report</li>
        <li onClick={() => setSelectedOption("viewEyeExam")}>View All Eye Exam Report</li>
        <li onClick={() => setSelectedOption("patienteyeExam")}>Eye Exam Report For Patient</li>
        <li onClick={() => setSelectedOption("notification")}>Patient Follow-Ups</li>
        <li onClick={() => setSelectedOption("salesReport")}>Sales Report</li>
        <li onClick={() => setSelectedOption("birthdayWishe")}>Send Birthday Wish</li>
        <li className="logout-button" onClick={handleLogout}>Logout</li>
        </div>
      </div>

      {/* Main Panel */}
      <div className="lecturer-panel">





{/******************************************** Birthday Wishes  ***********************************************/}

{/******************************************
      PATIENT BIRTHDAY WISHES
*******************************************/}

{selectedOption === "birthdayWishe" && (
  <div
    style={{
      padding: "16px",
      background: "#f8fafc",
    }}
  >
    {/* Header */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "16px",
        gap: "12px",
        flexWrap: "wrap",
      }}
    >
      <div>
        <h2
          style={{
            margin: 0,
            fontSize: "1.4rem",
            fontWeight: "700",
            color: "#0f172a",
          }}
        >
          Patient Birthday Wishes
        </h2>

        <p
          style={{
            margin: "4px 0 0",
            color: "#64748b",
            fontSize: "0.85rem",
          }}
        >
          Send birthday greetings and manage upcoming patient birthdays
        </p>
      </div>

      <div
        style={{
          background: "#2563eb",
          color: "#fff",
          padding: "10px 18px",
          borderRadius: "12px",
          textAlign: "center",
          minWidth: "120px",
          boxShadow: "0 2px 8px rgba(37,99,235,0.18)",
        }}
      >
        <div
          style={{
            fontSize: "0.65rem",
            opacity: 0.9,
            letterSpacing: "0.5px",
          }}
        >
          TODAY'S BIRTHDAYS
        </div>

        <div
          style={{
            fontSize: "1.2rem",
            fontWeight: "700",
            marginTop: "2px",
          }}
        >
          {todayBirthdays.length}
        </div>
      </div>
    </div>

    {loadingBirthdays ? (
      <div
        style={{
          background: "#fff",
          padding: "20px",
          borderRadius: "14px",
          textAlign: "center",
          boxShadow: "0 1px 8px rgba(0,0,0,0.05)",
        }}
      >
        Loading birthdays...
      </div>
    ) : (
      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit,minmax(300px,1fr))",
          gap: "14px",
        }}
      >
        {/* TODAY */}
        <div
          style={{
            background: "#fff",
            borderRadius: "14px",
            padding: "14px",
            boxShadow: "0 1px 8px rgba(0,0,0,0.06)",
            borderTop: "4px solid #ef4444",
          }}
        >
          <h3
            style={{
              margin: "0 0 12px",
              color: "#ef4444",
              fontWeight: "700",
              fontSize: "1rem",
            }}
          >
            Today
          </h3>

          {todayBirthdays.length === 0 ? (
            <p
              style={{
                color: "#64748b",
                fontSize: "0.85rem",
                margin: 0,
              }}
            >
              No birthdays scheduled for today.
            </p>
          ) : (
            todayBirthdays.map((patient) => (
              <BirthdayCard
                key={patient.id}
                patient={patient}
                color="#ef4444"
              />
            ))
          )}
        </div>

        {/* TOMORROW */}
        <div
          style={{
            background: "#fff",
            borderRadius: "14px",
            padding: "14px",
            boxShadow: "0 1px 8px rgba(0,0,0,0.06)",
            borderTop: "4px solid #f97316",
          }}
        >
          <h3
            style={{
              margin: "0 0 12px",
              color: "#f97316",
              fontWeight: "700",
              fontSize: "1rem",
            }}
          >
            Tomorrow
          </h3>

          {tomorrowBirthdays.length === 0 ? (
            <p
              style={{
                color: "#64748b",
                fontSize: "0.85rem",
                margin: 0,
              }}
            >
              No birthdays scheduled for tomorrow.
            </p>
          ) : (
            tomorrowBirthdays.map((patient) => (
              <BirthdayCard
                key={patient.id}
                patient={patient}
                color="#f97316"
              />
            ))
          )}
        </div>

        {/* DAY AFTER TOMORROW */}
        <div
          style={{
            background: "#fff",
            borderRadius: "14px",
            padding: "14px",
            boxShadow: "0 1px 8px rgba(0,0,0,0.06)",
            borderTop: "4px solid #22c55e",
          }}
        >
          <h3
            style={{
              margin: "0 0 12px",
              color: "#22c55e",
              fontWeight: "700",
              fontSize: "1rem",
            }}
          >
            Day After Tomorrow
          </h3>

          {dayAfterTomorrowBirthdays.length === 0 ? (
            <p
              style={{
                color: "#64748b",
                fontSize: "0.85rem",
                margin: 0,
              }}
            >
              No birthdays scheduled.
            </p>
          ) : (
            dayAfterTomorrowBirthdays.map((patient) => (
              <BirthdayCard
                key={patient.id}
                patient={patient}
                color="#22c55e"
              />
            ))
          )}
        </div>
      </div>
    )}
  </div>
)}




{/***************************************************** view settle invoice *****************************************************************/}

{selectedOption === "viewallsettleInvoice" && (
  <div className="vsi-wrapper">
    <div className="vsi-container">
      
      <div className="vsi-header">
        <h1 className="vsi-title">
          <span className="vsi-title-icon">✅</span>
          Settled Invoices
        </h1>
        <p className="vsi-subtitle">View and manage all completed settlement transactions</p>
      </div>

      {/* Filters Section */}
      <div className="vsi-filters-card">
        <h3 className="vsi-filters-title">
          <span className="vsi-filters-icon">🔍</span>
          Filter Invoices
        </h3>
        
        <div className="vsi-filters-grid">
          <div className="vsi-filter-group">
            <label className="vsi-filter-label">Invoice Number</label>
            <input 
              className="vsi-filter-input"
              placeholder="e.g., INV-001" 
              value={filterInvoiceNo} 
              onChange={(e) => setFilterInvoiceNo(e.target.value)} 
            />
          </div>

          <div className="vsi-filter-group">
            <label className="vsi-filter-label">Patient Name/Phone</label>
            <input 
              className="vsi-filter-input"
              placeholder="Search patient..." 
              value={filterPatient} 
              onChange={(e) => setFilterPatient(e.target.value)} 
            />
          </div>

          <div className="vsi-filter-group">
            <label className="vsi-filter-label">Year</label>
            <input 
              className="vsi-filter-input"
              placeholder="2024" 
              value={filterYear} 
              onChange={(e) => setFilterYear(e.target.value)} 
            />
          </div>

          <div className="vsi-filter-group">
            <label className="vsi-filter-label">Month</label>
            <input 
              className="vsi-filter-input"
              placeholder="01-12" 
              value={filterMonth} 
              onChange={(e) => setFilterMonth(e.target.value)} 
            />
          </div>

          <div className="vsi-filter-group">
            <label className="vsi-filter-label">Day</label>
            <input 
              className="vsi-filter-input"
              placeholder="01-31" 
              value={filterDate} 
              onChange={(e) => setFilterDate(e.target.value)} 
            />
          </div>

          <div className="vsi-filter-group vsi-filter-actions">
            <button 
              className="vsi-btn vsi-btn-clear"
              onClick={() => {
                setFilterYear("");
                setFilterMonth("");
                setFilterDate("");
                setFilterInvoiceNo("");
                setFilterPatient("");
              }}
            >
              <span className="vsi-btn-icon">🗑️</span>
              Clear All Filters
            </button>
          </div>
        </div>
      </div>

      {/* Results Section */}
      <div className="vsi-results-card">
        <div className="vsi-results-header">
          <h3 className="vsi-results-title">
            <span className="vsi-results-icon">📋</span>
            Settlement Records
          </h3>
          <span className="vsi-results-count">
            {filteredSettleInvoices.length} {filteredSettleInvoices.length === 1 ? 'Invoice' : 'Invoices'}
          </span>
        </div>

        {loadingInvoices ? (
          <div className="vsi-loading">
            <div className="vsi-spinner"></div>
            <p>Loading settlement records...</p>
          </div>
        ) : filteredSettleInvoices.length === 0 ? (
          <div className="vsi-empty">
            <div className="vsi-empty-icon">📭</div>
            <h3>No settled invoices found</h3>
            <p>Try adjusting your filters or create new settlements</p>
          </div>
        ) : (
          <div className="vsi-table-wrapper">
            <table className="vsi-table">
              <thead>
                <tr>
                  <th>Invoice No</th>
                  <th>Patient Name</th>
                  <th>Total Amount</th>
                  <th>Settlement History</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredSettleInvoices.map((inv, index) => (
                  <tr key={inv.invoiceNo || index} className="vsi-row">
                    <td className="vsi-cell-invoice">
                      <span className="vsi-invoice-badge">{inv.invoiceNo}</span>
                    </td>
                    
                    <td className="vsi-cell-patient">
                      <strong>{inv.to}</strong>
                    </td>
                    
                    <td className="vsi-cell-amount">
                      <span className="vsi-amount">LKR {inv.totalAmount}</span>
                    </td>
                    
                    <td className="vsi-cell-settlements">
                      {inv.settlements?.length > 0 ? (
                        <div className="vsi-settlement-list">
                          {inv.settlements.map((s, i) => (
                            <div key={i} className="vsi-settlement-item">
                              <div className="vsi-settlement-date">
                                <span className="vsi-settlement-icon">📅</span>
                                {getSafeDate(s.date)?.toLocaleDateString()}
                              </div>
                              <div className="vsi-settlement-details">
                                <span className="vsi-paid">
                                  <span className="vsi-label">Paid:</span> 
                                  <span className="vsi-paid-amount">LKR {s.paidAmount}</span>
                                </span>
                                <span className="vsi-balance">
                                  <span className="vsi-label">Balance:</span> 
                                  <span className="vsi-balance-amount">LKR {s.newBalance}</span>
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <span className="vsi-no-settlements">No settlements recorded</span>
                      )}
                    </td>
                    
                    <td className="vsi-cell-actions">
                      <div className="vsi-action-buttons">
                        <button 
                          className="vsi-btn vsi-btn-download"
                          onClick={() => downloadSettlementInvoice(inv)}
                          title="Download Settlement Invoice"
                        >
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M5 20h14v-2H5v2zm7-18v10l4-4h-3V2h-2v6h-3l4 4V2z"/>
                          </svg>
                          <span>Download</span>
                        </button>

                        <button 
                          className="vsi-btn vsi-btn-delete"
                          onClick={() => handleDeleteSettleInvoice(inv)}
                          title="Delete Settlement Record"
                        >
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
                          </svg>
                          <span>Delete</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  </div>
)}



{/**************************************************** create settle invoice ******************************************************************/}


{selectedOption === "settleInvoice" && (
  <div className="sip-page-wrapper">
    <div className="sip-settle-container">

      <h1 className="sip-page-title"> Balance Payable Invoice</h1>

      {/* Search Section */}
      <div className="sip-card sip-search-card">
        <h2 className="sip-section-title">
          <span className="sip-icon">🔍</span> Search Invoice
        </h2>

        <div className="sip-form-row">
          <div className="sip-form-group">
            <label className="sip-label">Invoice Number</label>
            <input
              type="text"
              className="sip-input"
              placeholder="Enter invoice number (e.g., INV-001)"
              value={searchInvoiceNo}
              onChange={(e) => setSearchInvoiceNo(e.target.value)}
            />
          </div>

          <button className="sip-btn sip-btn-search" onClick={searchInvoice}>
     
            Search Invoice
          </button>
        </div>
      </div>

      {/* Invoice Details After Search */}
      {foundInvoice && (
        <div className="sip-card sip-invoice-card">
          <h2 className="sip-section-title">
            <span className="sip-icon">📋</span> Invoice Details
          </h2>

          <div className="sip-details-grid">
            <div className="sip-detail-item">
              <span className="sip-detail-label">Patient Name:</span>
              <span className="sip-detail-value">{foundInvoice.to}</span>
            </div>
            <div className="sip-detail-item sip-balance-item">
              <span className="sip-detail-label">Remaining Balance:</span>
              <span className="sip-detail-value sip-balance-amount">
                LKR {foundInvoice.totalAmount?.toFixed(2) || '0.00'}
              </span>
            </div>
          </div>

          <div className="sip-form-group sip-mt-4">
            <label className="sip-label">Settlement Date</label>
            <input
              type="date"
              className="sip-input sip-date-input"
              value={settleDate}
              onChange={(e) => setSettleDate(e.target.value)}
            />
          </div>

          <div className="sip-form-group sip-mt-4">
            <label className="sip-label">Amount Paying Now (LKR)</label>
            <input
              type="number"
              className="sip-input sip-amount-input"
              placeholder="Enter amount to pay"
              value={settleAmount}
              onChange={(e) => setSettleAmount(e.target.value)}
              min="0"
              step="0.01"
            />
          </div>

          <button className="sip-btn sip-btn-pay" onClick={handleSettlePayment}>
            <span className="sip-btn-icon">✓</span>
            Settle Now
          </button>
        </div>
      )}
    </div>
  </div>
)}


{/******************************************* sales report *****************************************************/}








{selectedOption === "salesReport" && (
  <div className="sales-container">

    <h2 className="sales-title">Sales Report</h2>

    {/* Filter Controls */}
    <div className="filter-controls">

      <select
        value={filterMode}
        onChange={(e) => setFilterMode(e.target.value)}
        className="filter-select"
      >
        <option value="daily">Daily</option>
        <option value="monthly">Monthly</option>
        <option value="yearly">Yearly</option>
      </select>

      {filterMode === "daily" && (
        <input
          type="date"
          value={selectedDate.format("YYYY-MM-DD")}
          onChange={(e) => setSelectedDate(dayjs(e.target.value))}
          className="filter-input"
        />
      )}

      {filterMode === "monthly" && (
        <input
          type="month"
          value={selectedDate.format("YYYY-MM")}
          onChange={(e) => setSelectedDate(dayjs(e.target.value))}
          className="filter-input"
        />
      )}

      {filterMode === "yearly" && (
        <input
          type="number"
          min="2000"
          max="2100"
          value={selectedDate.format("YYYY")}
          onChange={(e) => setSelectedDate(dayjs(`${e.target.value}-01-01`))}
          className="filter-input"
        />
      )}

      {/* Download Buttons */}
      <div className="download-buttons">
        <button
          onClick={downloadSalesReportPDF}
          className="btn btn-pdf"
        >
          Download PDF
        </button>

        <button
          onClick={downloadExcel}
          className="btn btn-excel"
        >
          Download Excel
        </button>
      </div>

    </div>

    {/* Summary */}
    <div className="summary">

      <div className="summary-card">
        <p>Total {filterMode} Sale</p>
        <span>Rs. {totalSale.toLocaleString()}</span>
      </div>

      <div className="summary-card">
        <p>Total {filterMode} Paid</p>
        <span>Rs. {totalPaid.toLocaleString()}</span>
      </div>

      <div className="summary-card">
        <p>Total {filterMode} Payable Balance</p>
        <span>Rs. {totalPayable.toLocaleString()}</span>
      </div>

    </div>

    {/* Table */}
    <div className="table-wrapper">

      <table className="sales-table">

        <thead>
          <tr>
            <th>Date</th>
            <th>Invoice No</th>
            <th>Customer</th>
            <th>Phone</th>
            <th>Payment</th>
            <th>Frame</th>
            <th>Lens</th>
            <th>Right Lens</th>
            <th>Left Lens</th>
            <th>PD</th>
            <th>SEG</th>
            <th>Full Price</th>
            <th>Advanced</th>
            <th>Payable Balance</th>
          </tr>
        </thead>
<tbody>
  {filteredInvoices.length > 0 ? (
    filteredInvoices.map((inv) => {

      const payable = inv.totalAmount || 0; // ✅ FIXED

      return (
        <tr key={inv.id}>
          <td>{inv.date}</td>
          <td>{inv.invoiceNo}</td>
          <td>{inv.to}</td>
          <td>{inv.patientPhoneNo}</td>
          <td>{inv.paymentMethod}</td>
          <td>{inv.frame}</td>
          <td>{inv.lens}</td>
          <td>{inv.rightLens}</td>
          <td>{inv.leftLens}</td>
          <td>{inv.pd}</td>
          <td>{inv.seg}</td>

          <td>Rs. {inv.amount}</td>
          <td>Rs. {inv.deductAmount}</td>

          <td className="balance">
            Rs. {payable}
          </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="14" className="no-data">
        No records found for this period.
      </td>
    </tr>
  )}
</tbody>

      </table>

    </div>

  </div>
)}















{/**********************************************************************************************************************/}





        {selectedOption === "addPatient" && (
  <div className="apf-wrapper">
    <div className="apf-container">
      
      <div className="apf-header">
        <h1 className="apf-title">
          <span className="apf-title-icon">👤</span>
          Add New Patient
        </h1>
        <p className="apf-subtitle">Enter patient information below</p>
      </div>

      <form onSubmit={handleSubmit} className="apf-form">
        
        <div className="apf-form-row">
          {/* Left Column */}
          <div className="apf-form-col">
            <div className="apf-form-group">
              <label className="apf-label">
          
                Full Name <span className="apf-required">*</span>
              </label>
              <input
                type="text"
                name="name"
                className="apf-input"
                placeholder="Enter patient's full name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="apf-form-group">
              <label className="apf-label">
             
                Date of Birth
              </label>
              <input
                type="date"
                name="dateOfBirth"
                className="apf-input apf-date-input"
                value={formData.dateOfBirth}
                onChange={handleChange}
              />
            </div>

            <div className="apf-form-group">
              <label className="apf-label">
               
                Gender <span className="apf-required">*</span>
              </label>
              <select
                name="sex"
                className="apf-select"
                value={formData.sex}
                onChange={handleChange}
                required
              >
                <option value="" disabled>Select gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div className="apf-form-group">
              <label className="apf-label">
             
                Telephone Number
              </label>
              <input
                type="tel"
                name="telephoneNo"
                className="apf-input"
                placeholder="+94 XX XXX XXXX"
                value={formData.telephoneNo}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Right Column */}
          <div className="apf-form-col">
            <div className="apf-form-group">
              <label className="apf-label">
           
                Mobile Number
              </label>
              <input
                type="tel"
                name="mobileNo"
                className="apf-input"
                placeholder="+94 XX XXX XXXX"
                value={formData.mobileNo}
                onChange={handleChange}
              />
            </div>

            <div className="apf-form-group">
              <label className="apf-label">
         
                Email Address
              </label>
              <input
                type="email"
                name="email"
                className="apf-input"
                placeholder="patient@example.com"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="apf-form-group apf-full-width">
              <label className="apf-label">
               
                Residential Address
              </label>
              <textarea
                name="address"
                className="apf-textarea"
                placeholder="Enter full address"
                value={formData.address}
                onChange={handleChange}
                rows="4"
              />
            </div>
          </div>
        </div>

        <div className="apf-actions">
          <button type="submit" className="apf-btn apf-btn-primary">
            <span className="apf-btn-icon">+</span>
            Add Patient
          </button>
          <button type="button" className="apf-btn apf-btn-secondary" onClick={() => {/* Add reset logic */}}>
            <span className="apf-btn-icon">↺</span>
            Reset Form
          </button>
        </div>

      </form>
    </div>
  </div>
)}







{/****************************************** create invoice *************************************************************************/}


          {selectedOption === "createInvoice" && userDetails && (
  <div className="civ-dashboard-wrapper">
    <div className="civ-panel">
      {selectedOption === "createInvoice" && userDetails && (
        <div className="civ-section">
          
          <div className="civ-header">
            <h1 className="civ-title">
              <span className="civ-title-icon">📄</span>
              Create New Invoice
            </h1>
            <p className="civ-subtitle">Fill in the details to generate a professional invoice</p>
          </div>

          <form className="civ-form">

            {/* Invoice Information */}
            <div className="civ-card">
              <h3 className="civ-card-title">
                <span className="civ-card-icon">🔢</span>
                Invoice Information
              </h3>
              <div className="civ-form-group">
                <label className="civ-label">Invoice Number</label>
                <input
                  type="text"
                  className="civ-input civ-input-disabled"
                  value={invoiceNumber}
                  readOnly
                  disabled
                />
                <span className="civ-input-hint">Auto-generated, cannot be edited</span>
              </div>
            </div>

            {/* Patient Details */}
            <div className="civ-card">
              <h3 className="civ-card-title">
                <span className="civ-card-icon">👤</span>
                Patient Details
              </h3>
              
              <div className="civ-form-row">
                <div className="civ-form-group civ-search-group">
                  <label className="civ-label">Search Patient</label>
                  <input
                    type="text"
                    className="civ-input"
                    placeholder="Type name or phone number..."
                    value={patientSearch}
                    onChange={(e) => setPatientSearch(e.target.value)}
                  />
                  {filteredPatientList.length > 0 && (
                    <div className="civ-search-results">
                      {filteredPatientList.map((patient) => (
                        <div
                          key={patient.id}
                          className="civ-search-item"
                          onClick={() => handlePatientClick(patient)}
                        >
                          <span className="civ-patient-name">{patient.name}</span>
                          <span className="civ-patient-phone">{patient.telephoneNo}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="civ-form-group">
                  <label className="civ-label">Patient's Phone No</label>
                  <input 
                    type="text" 
                    className="civ-input"
                    value={patientPhoneNo} 
                    onChange={(e) => setPatientPhoneNo(e.target.value)} 
                    required 
                  />
                </div>

                <div className="civ-form-group">
                  <label className="civ-label">Date</label>
                  <input 
                    type="date" 
                    className="civ-input civ-date-input"
                    value={date} 
                    onChange={(e) => setDate(e.target.value)} 
                    required 
                  />
                </div>
              </div>
            </div>

            {/* Lens & Frame Details */}
            <div className="civ-card">
              <h3 className="civ-card-title">
                <span className="civ-card-icon">👓</span>
                Lens & Frame Details
              </h3>

              <div className="civ-form-grid">
                <div className="civ-form-group civ-full-width">
                  <label className="civ-label">Frame</label>
                  <input 
                    type="text" 
                    className="civ-input"
                    value={frame} 
                    onChange={(e) => setFrame(e.target.value)} 
                  />
                </div>

                <div className="civ-form-group civ-full-width">
                  <label className="civ-label">Lens</label>
                  <input 
                    type="text" 
                    className="civ-input"
                    value={lens} 
                    onChange={(e) => setLens(e.target.value)} 
                  />
                </div>

                <div className="civ-form-group civ-full-width">
                  <label className="civ-label">Brand / Lens Type</label>
                  <select 
                    className="civ-select"
                    value={brand} 
                    onChange={(e) => setBrand(e.target.value)} 
                    required
                  >
                    <option value="">Select Lens Type</option>
                    <optgroup label="CR.39 LENSES">
                      <option value="CR39_SINGLE_VISION">CR.39 SINGLE VISION</option>
                      <option value="CR39_BIFOCAL">CR.39 BIFOCAL</option>
                      <option value="CR39_PROGRESSIVE">CR.39 PROGRESSIVE</option>
                      <option value="CR39_FLAT_TOP">CR.39 FLAT TOP</option>
                      <option value="CR39_OTHER">CR.39 OTHER LENSES</option>
                      <option value="CR39_HIGH_CYL">CR.39 HIGH CYL LENS</option>
                    </optgroup>

                    <optgroup label="BLUE CUT LENSES">
                      <option value="BLUE_CUT_SINGLE_VISION">BLUE CUT SINGLE VISION</option>
                      <option value="BLUE_CUT_BIFOCAL">BLUE CUT BIFOCAL</option>
                      <option value="BLUE_CUT_PROGRESSIVE">BLUE CUT PROGRESSIVE</option>
                      <option value="BLUE_CUT_FLAT_TOP">BLUE CUT FLAT TOP</option>
                      <option value="BLUE_CUT_OTHER">BLUE CUT OTHER LENSES</option>
                      <option value="BLUE_CUT_HIGH_CYL">BLUE CUT HIGH CYL LENS</option>
                    </optgroup>

                    <optgroup label="BLUE CUT PHOTOCHROMIC">
                      <option value="BLUE_CUT_PHOTO_SINGLE">BLUE CUT PHOTOCHROMIC SINGLE VISION</option>
                      <option value="BLUE_CUT_PHOTO_BIFOCAL">BLUE CUT PHOTOCHROMIC BIFOCAL</option>
                      <option value="BLUE_CUT_PHOTO_PROGRESSIVE">BLUE CUT PHOTOCHROMIC PROGRESSIVE</option>
                      <option value="BLUE_CUT_PHOTO_FLAT_TOP">BLUE CUT PHOTOCHROMIC FLAT TOP</option>
                      <option value="BLUE_CUT_PHOTO_OTHER">BLUE CUT PHOTOCHROMIC OTHER LENSES</option>
                      <option value="BLUE_CUT_PHOTO_HIGH_CYL">BLUE CUT PHOTOCHROMIC HIGH CYL LENS</option>
                    </optgroup>

                    <optgroup label="MULTICODE PHOTOCHROMIC">
                      <option value="MULTICODE_PHOTO_SINGLE">MULTICODE PHOTOCHROMIC SINGLE VISION</option>
                      <option value="MULTICODE_PHOTO_BIFOCAL">MULTICODE PHOTOCHROMIC BIFOCAL</option>
                      <option value="MULTICODE_PHOTO_PROGRESSIVE">MULTICODE PHOTOCHROMIC PROGRESSIVE</option>
                      <option value="MULTICODE_PHOTO_FLAT_TOP">MULTICODE PHOTOCHROMIC FLAT TOP</option>
                      <option value="MULTICODE_PHOTO_OTHER">MULTICODE PHOTOCHROMIC OTHER LENSES</option>
                      <option value="MULTICODE_PHOTO_HIGH_CYL">MULTICODE PHOTOCHROMIC HIGH CYL LENS</option>
                    </optgroup>

                    <optgroup label="MULTICODE LENSES">
                      <option value="MULTICODE_SINGLE">MULTICODE SINGLE VISION</option>
                      <option value="MULTICODE_BIFOCAL">MULTICODE BIFOCAL</option>
                      <option value="MULTICODE_PROGRESSIVE">MULTICODE PROGRESSIVE</option>
                      <option value="MULTICODE_FLAT_TOP">MULTICODE FLAT TOP</option>
                      <option value="MULTICODE_OTHER">MULTICODE OTHER LENSES</option>
                      <option value="MULTICODE_HIGH_CYL">MULTICODE HIGH CYL LENS</option>
                    </optgroup>

                    <optgroup label="ESSILOR">
                      <option value="ESSILOR">ESSILOR</option>
                      <option value="TRANSITIONS">TRANSITIONS</option>
                      <option value="VERYLUX">VERYLUX</option>
                      <option value="CRIZAL_PREVENCIA">ESSILOR CRIZAL PREVENCIA</option>
                      <option value="EYEZEN">ESSILOR EYEZEN</option>
                      <option value="ESSENTIALS">ESSILOR ESSENTIALS</option>
                      <option value="ESSILOR_AR">ESSILOR AR</option>
                    </optgroup>

                    <optgroup label="NOVAR LENSES">
                      <option value="NOVAR_LENSES">NOVAR LENSES</option>
                      <option value="NOVAR_HD_BLUE">NOVAR HD BLUE FILTER</option>
                      <option value="NOVAR_HD_PHOTOGRAY">NOVAR HD BLUE FILTER PHOTOGRAY</option>
                      <option value="NOVAR_MC">NOVAR M.C LENS</option>
                      <option value="NOVAR_MC_PG">NOVAR M.C.P.G LENS</option>
                      <option value="NOVAR_AR">NOVAR AR COATING</option>
                      <option value="NOVAR_GEN3_FIRST">NOVAR GEN 3 FIRST</option>
                      <option value="NOVAR_GEN3_PRECISA">NOVAR GEN 3 PRECISA</option>
                      <option value="NOVAR_GEN3_EVOLUTION">NOVAR GEN 3 EVOLUTION</option>
                      <option value="NOVAR_GEN3_ELIFE">NOVAR GEN 3 eLIFE</option>
                      <option value="NOVAR_GEN3_AI">NOVAR GEN 3 Ai-LENS</option>
                      <option value="NOVAR_MYOFIX">NOVAR MYOFIX</option>
                      <option value="NOVAR_COATGUARD">NOVAR COATGUARD</option>
                      <option value="NOVAR_EYELUX">NOVAR EYELUX</option>
                      <option value="NOVAR_EYELUX_HD">NOVAR EYELUX HD</option>
                      <option value="NOVAR_EYELUX_UV">NOVAR EYELUX UV+</option>
                      <option value="NOVAR_EYELUX_BLUE">NOVAR EYELUX BLUE+</option>
                      <option value="NOVAR_CARE_PLUS">NOVAR CARE +</option>
                    </optgroup>

                    <optgroup label="POLARIZED">
                      <option value="POLARIZED_ORIGINAL">POLARIZED ORIGINAL LENS</option>
                      <option value="POLARIZED">POLARIZED LENSES</option>
                      <option value="POLARIZED_NOVAR">POLARIZED NOVAR LENS</option>
                    </optgroup>

                    <optgroup label="CONTACT LENSES">
                      <option value="CONTACT_ORG">CONTACT LENSES ORG#1</option>
                      <option value="CONTACT_HARD">CONTACT LENSES HARD</option>
                      <option value="CONTACT_SOFT">CONTACT LENSES SOFT</option>
                      <option value="CONTACT_3M">CONTACT LENSES 3M</option>
                      <option value="CONTACT_COLOUR">CONTACT LENSES COLOUR</option>
                    </optgroup>
                  </select>
                </div>

                <div className="civ-form-group">
                  <label className="civ-label">Right Lens Power</label>
                  <input 
                    type="text" 
                    className="civ-input"
                    value={rightLens} 
                    onChange={(e) => setRightLens(e.target.value)} 
                  />
                </div>

                <div className="civ-form-group">
                  <label className="civ-label">Left Lens Power</label>
                  <input 
                    type="text" 
                    className="civ-input"
                    value={leftLens} 
                    onChange={(e) => setLeftLens(e.target.value)} 
                  />
                </div>

                <div className="civ-form-group">
                  <label className="civ-label">Add Power</label>
                  <input 
                    type="text" 
                    className="civ-input"
                    value={addPower} 
                    onChange={(e) => setAddPower(e.target.value)} 
                  />
                </div>

                <div className="civ-form-group">
                  <label className="civ-label">PD</label>
                  <input 
                    type="text" 
                    className="civ-input"
                    value={pd} 
                    onChange={(e) => setPd(e.target.value)} 
                  />
                </div>

                <div className="civ-form-group">
                  <label className="civ-label">SEG</label>
                  <input 
                    type="text" 
                    className="civ-input"
                    value={seg} 
                    onChange={(e) => setSeg(e.target.value)} 
                  />
                </div>
              </div>
            </div>

            {/* Payment Details */}
            <div className="civ-card">
              <h3 className="civ-card-title">
               
                Payment Details
              </h3>

              <div className="civ-form-grid">
                <div className="civ-form-group">
                  <label className="civ-label">Payment Method</label>
                  <select 
                    className="civ-select"
                    value={paymentMethod} 
                    onChange={(e) => setPaymentMethod(e.target.value)} 
                    required
                  >
                    <option value="">Select Payment Method</option>
                    <option value="Cash">Cash</option>
                    <option value="Card">Card</option>
                    <option value="Bank Transfer">Bank Transfer</option>
                    <option value="Direct Deposit">Direct Deposit</option>
                  </select>
                </div>

                <div className="civ-form-group">
                  <label className="civ-label">Total Amount (LKR)</label>
                  <input
                    type="number"
                    className="civ-input"
                    value={amount}
                    onChange={(e) => {
                      const value = e.target.value;
                      setAmount(value);
                      setTotalAmount(parseFloat(value) - parseFloat(deductAmount) || 0);
                    }}
                     onWheel={(e) => e.target.blur()} // Prevent scroll value change
                    required
                  />
                </div>

                <div className="civ-form-group">
                  <label className="civ-label">Advance Payment (LKR)</label>
                  <input
                    type="number"
                    className="civ-input"
                    value={deductAmount}
                     onWheel={(e) => e.target.blur()} // Prevent scroll value change
                    onChange={(e) => {
                      const value = e.target.value;
                      setDeductAmount(value);
                      setTotalAmount(parseFloat(amount) - parseFloat(value));
                    }}
                  />
                </div>

                <div className="civ-form-group">
                  <label className="civ-label">Balance Amount (LKR)</label>
                  <input 
                    type="text" 
                    className="civ-input civ-balance-input" 
                    value={totalAmount} 
                    readOnly 
                  />
                </div>
              </div>
            </div>

            <div className="civ-actions">
              <button type="button" onClick={handleCreateInvoice} className="civ-btn civ-btn-primary">
                <span className="civ-btn-icon">📝</span>
                Create Invoice
              </button>
              <button type="button" className="civ-btn civ-btn-secondary">
                <span className="civ-btn-icon">↺</span>
                Reset Form
              </button>
            </div>

          </form>
        </div>
      )}
    </div>
  </div>
)}

{/*****************************************************************************************************************************/}

{selectedOption === "viewInvoice" && (
  <div className="viv-wrapper">
    <div className="viv-container">
      
      <div className="viv-header">
        <h1 className="viv-title">
          <span className="viv-title-icon">📋</span>
          Invoice Management
        </h1>
        <p className="viv-subtitle">View, filter and manage all invoices</p>
      </div>

      <div className="viv-controls">
        
        {/* Filters Section */}
        <div className="viv-filters">
          <div className="viv-filter-group">
            <label className="viv-filter-label">Status</label>
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="viv-select"
            >
              <option value="">All Status</option>
              <option value="Sent">Sent</option>
              <option value="Not Sent">Not Sent</option>
              <option value="Done">Done</option>
              <option value="Delivered">Delivered</option>
              <option value="Pending">Pending</option>
              <option value="Claim only">Claim only</option>
              <option value="Cancelled">Cancelled</option>
              <option value="Redo">Redo</option>
              <option value="OFTC">OFTC</option>
              <option value="Stop Work">Stop Work</option>
            </select>
          </div>

          <div className="viv-filter-group">
            <label className="viv-filter-label">Month</label>
            <select
              value={monthFilter}
              onChange={(e) => setMonthFilter(e.target.value)}
              className="viv-select"
            >
              <option value="">All Months</option>
              <option value="01">January</option>
              <option value="02">February</option>
              <option value="03">March</option>
              <option value="04">April</option>
              <option value="05">May</option>
              <option value="06">June</option>
              <option value="07">July</option>
              <option value="08">August</option>
              <option value="09">September</option>
              <option value="10">October</option>
              <option value="11">November</option>
              <option value="12">December</option>
            </select>
          </div>

          <div className="viv-filter-group">
            <label className="viv-filter-label">From</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="viv-date-input"
            />
          </div>

          <div className="viv-filter-group">
            <label className="viv-filter-label">To</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="viv-date-input"
            />
          </div>
        </div>

        {/* Actions Section */}
        <div className="viv-actions">
          <div className="viv-search-wrapper">
            <span className="viv-search-icon">🔍</span>
            <input
              type="text"
              placeholder="Search by name or invoice number..."
              className="viv-search-input"
              onChange={(e) => setSearchTerm(e.target.value)}
              value={searchTerm}
            />
          </div>

          <button onClick={handleDownload} className="viv-btn viv-btn-export">
            <span className="viv-btn-icon">📎</span>
            Export All
          </button>
        </div>
      </div>

      {/* Table Section */}
      <div className="viv-table-wrapper">
        <table className="viv-table">
          <thead>
            <tr>
              <th>Invoice #</th>
              <th>Phone</th>
              <th>Patient</th>
              <th>Date</th>
              <th>Status</th>
              <th>Frame</th>
              <th>Lens</th>
              <th>Add</th>
              <th>PD</th>
              <th>SEG</th>
              <th>Brand</th>
              <th>Right</th>
              <th>Left</th>
              <th>Payment</th>
              <th>Total</th>
              <th>Advance</th>
              <th>Balance</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredInvoices.length > 0 ? (
              filteredInvoices.map((invoice) => (
                <tr key={invoice.id} className="viv-table-row">
                  <td className="viv-cell-invoice">{invoice.invoiceNo}</td>
                  <td>{invoice.patientPhoneNo}</td>
                  <td className="viv-cell-patient">{invoice.to}</td>
                  <td>{invoice.date}</td>
                  <td>
                    <select
                      value={invoice.status || "Pending"}
                      onChange={(e) => handleInvoiceStatusChange(invoice.id, e.target.value)}
                      className={`viv-status-select viv-status-${invoice.status?.toLowerCase().replace(" ", "-")}`}
                    >
                      <option value="Sent">Sent</option>
                      <option value="Not Sent">Not Sent</option>
                      <option value="Done">Done</option>
                      <option value="Delivered">Delivered</option>
                      <option value="Pending">Pending</option>
                      <option value="Claim only">Claim only</option>
                      <option value="Cancelled">Cancelled</option>
                      <option value="Redo">Redo</option>
                      <option value="OFTC">OFTC</option>
                      <option value="Stop Work">Stop Work</option>
                    </select>
                  </td>
                  <td>{invoice.frame || '-'}</td>
                  <td>{invoice.lens || '-'}</td>
                  <td>{invoice.addPower || '-'}</td>
                  <td>{invoice.pd || '-'}</td>
                  <td>{invoice.seg || '-'}</td>
                  <td className="viv-cell-brand">{invoice.brand || '-'}</td>
                  <td>{invoice.rightLens || '-'}</td>
                  <td>{invoice.leftLens || '-'}</td>
                  <td>{invoice.paymentMethod}</td>
                  <td className="viv-cell-amount">LKR {invoice.amount}</td>
                  <td className="viv-cell-advance">LKR {invoice.deductAmount}</td>
                  <td className={`viv-cell-balance ${parseFloat(invoice.totalAmount) > 0 ? 'viv-balance-due' : 'viv-balance-paid'}`}>
                    LKR {invoice.totalAmount}
                  </td>
                  <td>
                    <div className="viv-action-buttons">
                      <button 
                        onClick={() => generatePDF(invoice)}
                        className="viv-btn viv-btn-pdf"
                        title="Download PDF"
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M5 20h14v-2H5v2zm7-18v10l4-4h-3V2h-2v6h-3l4 4V2z"/>
                        </svg>
                      </button>

                      <button 
                        onClick={() => handleDeleteInvoice(invoice.id)}
                        className="viv-btn viv-btn-delete"
                        title="Delete Invoice"
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="18" className="viv-empty-state">
                  <div className="viv-empty-icon">📭</div>
                  <p>No invoices found</p>
                  <span>Try adjusting your filters or create a new invoice</span>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  </div>
)}



{/************************************************* View All Patients ******************************************************************/}

              

{selectedOption === "viewPatients" && (
  <div className="vpt-wrapper">
    <div className="vpt-container">
      
      <div className="vpt-header">
        <div className="vpt-header-left">
          <h1 className="vpt-title">
            <span className="vpt-title-icon">👥</span>
            Patient Management
          </h1>
          <p className="vpt-subtitle">View and manage all patient records</p>
        </div>
        
        <div className="vpt-header-actions">
          <button onClick={handleDownloadPatients} className="vpt-btn vpt-btn-excel">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
            </svg>
            Export to Excel
          </button>
        </div>
      </div>

      {/* Search Bar */}
      <div className="vpt-search-section">
        <div className="vpt-search-wrapper">
          <span className="vpt-search-icon">🔍</span>
          <input
            type="text"
            placeholder="Search patients by name, phone, or email..."
            className="vpt-search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm && (
            <button 
              className="vpt-search-clear"
              onClick={() => setSearchTerm('')}
              title="Clear search"
            >
              ✕
            </button>
          )}
        </div>
        <span className="vpt-search-results">
          {filteredPatients.length} {filteredPatients.length === 1 ? 'patient' : 'patients'} found
        </span>
      </div>

      {loading ? (
        <div className="vpt-loading">
          <div className="vpt-spinner"></div>
          <p>Loading patient records...</p>
        </div>
      ) : filteredPatients.length === 0 ? (
        <div className="vpt-empty">
          <div className="vpt-empty-icon">📭</div>
          <h3>{searchTerm ? "No matching patients found" : "No patients in database"}</h3>
          <p>{searchTerm ? "Try adjusting your search terms" : "Add your first patient to get started"}</p>
        </div>
      ) : (
        <div className="vpt-table-wrapper">
          <table className="vpt-table">
            <thead>
              <tr>
                <th>Patient Name</th>
                <th>Date of Birth</th>
                <th>Gender</th>
                <th>Telephone</th>
                <th>Mobile</th>
                <th>Follow Up Date</th>
                <th>Follow Up Description</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredPatients.map(patient => (
                <tr key={patient.id} className="vpt-row">
                  <td className="vpt-cell-patient">
                    <strong>{patient.name}</strong>
                  </td>
                  <td>{patient.dateOfBirth || 'N/A'}</td>
                  <td>
                    <span className={`vpt-gender-badge vpt-gender-${patient.sex?.toLowerCase()}`}>
                      {patient.sex || 'N/A'}
                    </span>
                  </td>
                  <td>{patient.telephoneNo || 'N/A'}</td>
                  <td>{patient.mobileNo || 'N/A'}</td>
                  <td>
                    {patient.followUpDate ? (
                      <span className="vpt-followup-date">
                        📅 {new Date(patient.followUpDate).toLocaleDateString()}
                      </span>
                    ) : 'N/A'}
                  </td>
                  <td className="vpt-cell-description">
                    {patient.followUpDescription ? (
                      <span className="vpt-description" title={patient.followUpDescription}>
                        {patient.followUpDescription.substring(0, 30)}
                        {patient.followUpDescription.length > 30 ? '...' : ''}
                      </span>
                    ) : 'N/A'}
                  </td>
                  <td>
                    <div className="vpt-action-buttons">
                      <button 
                        onClick={() => setEditingPatient(patient)}
                        className="vpt-btn vpt-btn-edit"
                        title="Edit Patient"
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
                        </svg>
                        Edit
                      </button>
                      <button 
                        onClick={() => handleDeletePatient(patient.id)}
                        className="vpt-btn vpt-btn-delete"
                        title="Delete Patient"
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
                        </svg>
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>

    {/* Edit Patient Modal */}
    {editingPatient && (
      <div className="vpt-modal-overlay" onClick={() => setEditingPatient(null)}>
        <div className="vpt-modal" onClick={(e) => e.stopPropagation()}>
          <button
            className="vpt-modal-close"
            onClick={() => setEditingPatient(null)}
            aria-label="Close modal"
          >
            ×
          </button>

          <div className="vpt-modal-header">
            <h2 className="vpt-modal-title">
              <span className="vpt-modal-icon">✏️</span>
              Edit Patient Record
            </h2>
            <p className="vpt-modal-subtitle">Update patient information below</p>
          </div>

          <form onSubmit={handleUpdatePatient} className="vpt-modal-form">
            <div className="vpt-modal-content">
              <div className="vpt-form-group">
                <label className="vpt-form-label">
                  Full Name <span className="vpt-required">*</span>
                </label>
                <input
                  type="text"
                  className="vpt-form-input"
                  value={editingPatient.name || ""}
                  onChange={(e) =>
                    setEditingPatient({ ...editingPatient, name: e.target.value })
                  }
                  required
                  placeholder="Enter patient name"
                />
              </div>

              <div className="vpt-form-group">
                <label className="vpt-form-label">Follow Up Date</label>
                <input
                  type="date"
                  className="vpt-form-input vpt-date-input"
                  value={editingPatient.followUpDate || ""}
                  onChange={(e) =>
                    setEditingPatient({ ...editingPatient, followUpDate: e.target.value })
                  }
                />
              </div>

              <div className="vpt-form-group">
                <label className="vpt-form-label">Follow Up Description</label>
                <textarea
                  className="vpt-form-textarea"
                  value={editingPatient.followUpDescription || ""}
                  onChange={(e) =>
                    setEditingPatient({ ...editingPatient, followUpDescription: e.target.value })
                  }
                  rows="4"
                  placeholder="Enter follow up notes, instructions, or remarks"
                />
              </div>
            </div>

            <div className="vpt-modal-actions">
              <button
                type="button"
                className="vpt-btn vpt-btn-secondary"
                onClick={() => setEditingPatient(null)}
              >
                Cancel
              </button>
              <button type="submit" className="vpt-btn vpt-btn-primary">
                <span className="vpt-btn-icon">✓</span>
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
    )}
  </div>
)}




{/************************************************** create eye exam report **************************************************************/}





{selectedOption === "eyeExam" && (
  <div className="eer-wrapper">
    <div className="eer-container">
      
      <div className="eer-header">
        <h1 className="eer-title">
          <span className="eer-title-icon">👁️</span>
          Eye Examination Report
        </h1>
        <p className="eer-subtitle">Comprehensive eye examination form</p>
      </div>

      <form onSubmit={handleEyeExamSubmit} className="eer-form">
        
        {/* Patient Information */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">📋</span>
            Patient Information
          </h2>
          
          <div className="eer-form-row">
            <div className="eer-form-group">
              <label className="eer-label">Patient Name <span className="eer-required">*</span></label>
              <input 
                type="text" 
                className="eer-input"
                placeholder="Enter patient full name"
                value={patientName}
                onChange={(e) => setPatientName(e.target.value)}
                required
              />
            </div>
            
            <div className="eer-form-group">
              <label className="eer-label">Examination Date <span className="eer-required">*</span></label>
              <input 
                type="date" 
                className="eer-input eer-date-input"
                value={examDate}
                onChange={(e) => setExamDate(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="eer-form-row eer-grid-4">
            <div className="eer-form-group">
              <label className="eer-label">Date of Birth</label>
              <input 
                type="date" 
                className="eer-input eer-date-input"
                value={dob}
                onChange={(e) => setDob(e.target.value)}
              />
            </div>

            <div className="eer-form-group">
              <label className="eer-label">Age</label>
              <input 
                type="text" 
                className="eer-input"
                placeholder="Age"
                value={age}
                onChange={(e) => setAge(e.target.value)}
              />
            </div>

            <div className="eer-form-group">
              <label className="eer-label">Gender</label>
              <select 
                className="eer-select"
                value={gender}
                onChange={(e) => setGender(e.target.value)}
              >
                <option value="" disabled>Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </div>

            <div className="eer-form-group">
              <label className="eer-label">Contact No</label>
              <input 
                type="text" 
                className="eer-input"
                placeholder="Contact number"
                value={contactNo}
                onChange={(e) => setContactNo(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* History Taking */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">📜</span>
            History Taking
          </h2>
          
          <div className="eer-form-group">
            <label className="eer-label">Chief Complaint</label>
            <textarea 
              className="eer-textarea"
              value={chiefComplaint}
              onChange={(e) => setChiefComplaint(e.target.value)}
              rows="2"
              placeholder="Enter chief complaint"
            />
          </div>

          <div className="eer-form-group">
            <label className="eer-label">HPC (History of Present Complaint)</label>
            <textarea 
              className="eer-textarea"
              value={hpc}
              onChange={(e) => setHpc(e.target.value)}
              rows="2"
              placeholder="Enter history of present complaint"
            />
          </div>

          <div className="eer-form-group">
            <label className="eer-label">Past Ocular History</label>
            <textarea 
              className="eer-textarea"
              value={pastOcularHistory}
              onChange={(e) => setPastOcularHistory(e.target.value)}
              rows="2"
              placeholder="Enter past ocular history"
            />
          </div>

          <div className="eer-form-group">
            <label className="eer-label">Medical History</label>
            <textarea 
              className="eer-textarea"
              value={medicalHistory}
              onChange={(e) => setMedicalHistory(e.target.value)}
              rows="2"
              placeholder="Enter medical history"
            />
          </div>

          <div className="eer-form-group">
            <label className="eer-label">Family Ocular History</label>
            <textarea 
              className="eer-textarea"
              value={familyOcularHistory}
              onChange={(e) => setFamilyOcularHistory(e.target.value)}
              rows="2"
              placeholder="Enter family ocular history"
            />
          </div>

          <div className="eer-form-group">
            <label className="eer-label">Social History</label>
            <textarea 
              className="eer-textarea"
              value={socialHistory}
              onChange={(e) => setSocialHistory(e.target.value)}
              rows="2"
              placeholder="Enter social history"
            />
          </div>
        </div>

        {/* External Examination */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">🔬</span>
            External Examination
          </h2>

          {/* Lids */}
          <div className="eer-exam-group">
            <label className="eer-exam-label">Lids</label>
            <div className="eer-eye-inputs">
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Left Eye</span>
                <textarea
                  className="eer-textarea"
                  value={lidsLeft}
                  onChange={(e) => setLidsLeft(e.target.value)}
                  rows="2"
                  placeholder="Left eye lids condition"
                />
              </div>
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Right Eye</span>
                <textarea
                  className="eer-textarea"
                  value={lidsRight}
                  onChange={(e) => setLidsRight(e.target.value)}
                  rows="2"
                  placeholder="Right eye lids condition"
                />
              </div>
            </div>
          </div>

          {/* Conjunctiva */}
          <div className="eer-exam-group">
            <label className="eer-exam-label">Conjunctiva</label>
            <div className="eer-eye-inputs">
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Left Eye</span>
                <textarea
                  className="eer-textarea"
                  value={conjunctivaLeft}
                  onChange={(e) => setConjunctivaLeft(e.target.value)}
                  rows="2"
                  placeholder="Left eye conjunctiva"
                />
              </div>
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Right Eye</span>
                <textarea
                  className="eer-textarea"
                  value={conjunctivaRight}
                  onChange={(e) => setConjunctivaRight(e.target.value)}
                  rows="2"
                  placeholder="Right eye conjunctiva"
                />
              </div>
            </div>
          </div>

          {/* Cornea */}
          <div className="eer-exam-group">
            <label className="eer-exam-label">Cornea</label>
            <div className="eer-eye-inputs">
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Left Eye</span>
                <textarea
                  className="eer-textarea"
                  value={corneaLeft}
                  onChange={(e) => setCorneaLeft(e.target.value)}
                  rows="2"
                  placeholder="Left eye cornea"
                />
              </div>
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Right Eye</span>
                <textarea
                  className="eer-textarea"
                  value={corneaRight}
                  onChange={(e) => setCorneaRight(e.target.value)}
                  rows="2"
                  placeholder="Right eye cornea"
                />
              </div>
            </div>
          </div>

          {/* Sclera */}
          <div className="eer-exam-group">
            <label className="eer-exam-label">Sclera</label>
            <div className="eer-eye-inputs">
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Left Eye</span>
                <textarea
                  className="eer-textarea"
                  value={scleraLeft}
                  onChange={(e) => setScleraLeft(e.target.value)}
                  rows="2"
                  placeholder="Left eye sclera"
                />
              </div>
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Right Eye</span>
                <textarea
                  className="eer-textarea"
                  value={scleraRight}
                  onChange={(e) => setScleraRight(e.target.value)}
                  rows="2"
                  placeholder="Right eye sclera"
                />
              </div>
            </div>
          </div>

          {/* Anterior Chamber */}
          <div className="eer-exam-group">
            <label className="eer-exam-label">A/C (Anterior Chamber)</label>
            <div className="eer-eye-inputs">
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Left Eye</span>
                <textarea
                  className="eer-textarea"
                  value={acLeft}
                  onChange={(e) => setAcLeft(e.target.value)}
                  rows="2"
                  placeholder="Left eye A/C"
                />
              </div>
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Right Eye</span>
                <textarea
                  className="eer-textarea"
                  value={acRight}
                  onChange={(e) => setAcRight(e.target.value)}
                  rows="2"
                  placeholder="Right eye A/C"
                />
              </div>
            </div>
          </div>

          {/* Lens */}
          <div className="eer-exam-group">
            <label className="eer-exam-label">Lens</label>
            <div className="eer-eye-inputs">
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Left Eye</span>
                <textarea
                  className="eer-textarea"
                  value={lensLeft}
                  onChange={(e) => setLensLeft(e.target.value)}
                  rows="2"
                  placeholder="Left eye lens"
                />
              </div>
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Right Eye</span>
                <textarea
                  className="eer-textarea"
                  value={lensRight}
                  onChange={(e) => setLensRight(e.target.value)}
                  rows="2"
                  placeholder="Right eye lens"
                />
              </div>
            </div>
          </div>

          {/* Vitreous */}
          <div className="eer-exam-group">
            <label className="eer-exam-label">Vitreous</label>
            <div className="eer-eye-inputs">
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Left Eye</span>
                <textarea
                  className="eer-textarea"
                  value={vitreousLeft}
                  onChange={(e) => setVitreousLeft(e.target.value)}
                  rows="2"
                  placeholder="Left eye vitreous"
                />
              </div>
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Right Eye</span>
                <textarea
                  className="eer-textarea"
                  value={vitreousRight}
                  onChange={(e) => setVitreousRight(e.target.value)}
                  rows="2"
                  placeholder="Right eye vitreous"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Family History */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">👪</span>
            Family History
          </h2>
          
          <div className="eer-checkbox-group">
            <label className="eer-checkbox">
              <input 
                type="checkbox" 
                name="poag"
                checked={familyHistory.poag}
                onChange={handleFamilyHistoryChange}
              />
              <span>FHx POAG</span>
            </label>
            
            <label className="eer-checkbox">
              <input 
                type="checkbox" 
                name="amd"
                checked={familyHistory.amd}
                onChange={handleFamilyHistoryChange}
              />
              <span>FHx AMD</span>
            </label>
            
            <label className="eer-checkbox">
              <input 
                type="checkbox" 
                name="dm"
                checked={familyHistory.dm}
                onChange={handleFamilyHistoryChange}
              />
              <span>FHx DM</span>
            </label>
            
            <div className="eer-custom-condition">
              <input 
                type="text" 
                className="eer-input"
                name="other"
                value={familyHistory.other}
                onChange={handleFamilyHistoryChange}
                placeholder="Other family history"
              />
            </div>
          </div>
        </div>

        {/* Visual Acuity */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">👀</span>
            Visual Acuity
          </h2>
          
          <div className="eer-va-grid">
            <div className="eer-va-header">
              <div></div>
              <div>OD (Right)</div>
              <div>OS (Left)</div>
            </div>
            
            <div className="eer-va-row">
              <div className="eer-va-label">C∕C</div>
              <input 
                type="text" 
                className="eer-va-input"
                name="od_cg"
                value={visualAcuity.od_cg}
                onChange={handleVisualAcuityChange}
              />
              <input 
                type="text" 
                className="eer-va-input"
                name="os_cg"
                value={visualAcuity.os_cg}
                onChange={handleVisualAcuityChange}
              />
            </div>
            
            <div className="eer-va-row">
              <div className="eer-va-label">S∕C</div>
              <input 
                type="text" 
                className="eer-va-input"
                name="od_sg"
                value={visualAcuity.od_sg}
                onChange={handleVisualAcuityChange}
              />
              <input 
                type="text" 
                className="eer-va-input"
                name="os_sg"
                value={visualAcuity.os_sg}
                onChange={handleVisualAcuityChange}
              />
            </div>
            
            <div className="eer-va-row">
              <div className="eer-va-label">P∕H</div>
              <input 
                type="text" 
                className="eer-va-input"
                name="od_ph"
                value={visualAcuity.od_ph}
                onChange={handleVisualAcuityChange}
              />
              <input 
                type="text" 
                className="eer-va-input"
                name="os_ph"
                value={visualAcuity.os_ph}
                onChange={handleVisualAcuityChange}
              />
            </div>

            <div className="eer-va-row">
              <div className="eer-va-label">PD</div>
              <input 
                type="text" 
                className="eer-va-input"
                name="od_pd"
                value={visualAcuity.od_pd}
                onChange={handleVisualAcuityChange}
              />
              <input 
                type="text" 
                className="eer-va-input"
                name="os_pd"
                value={visualAcuity.os_pd}
                onChange={handleVisualAcuityChange}
              />
            </div>

            <div className="eer-va-row eer-va-single">
              <div className="eer-va-label">SEG</div>
              <input 
                type="text" 
                className="eer-va-input"
                name="seg_va"
                value={visualAcuity.seg_va}
                onChange={handleVisualAcuityChange}
              />
            </div>
          </div>

          <div className="eer-va-additional">
            <div className="eer-form-group">
              <label className="eer-label">CT</label>
              <input 
                type="text" 
                className="eer-input"
                name="ct"
                value={visualAcuity.ct}
                onChange={handleVisualAcuityChange}
              />
            </div>
            
            <div className="eer-form-group">
              <label className="eer-label">NPC</label>
              <input 
                type="text" 
                className="eer-input"
                name="npc"
                value={visualAcuity.npc}
                onChange={handleVisualAcuityChange}
              />
            </div>
            
            <div className="eer-form-group">
              <label className="eer-label">OM</label>
              <input 
                type="text" 
                className="eer-input"
                name="om"
                value={visualAcuity.om}
                onChange={handleVisualAcuityChange}
              />
            </div>
          </div>
        </div>

        {/* Fundi */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">🔍</span>
            Fundi
          </h2>
          
          <div className="eer-form-group">
            <label className="eer-label">Description</label>
            <input 
              type="text" 
              className="eer-input"
              value={fundi}
              onChange={(e) => setFundi(e.target.value)}
              placeholder="Enter fundi description"
            />
          </div>
        </div>

        {/* Hb Rx */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">📊</span>
            Hb Rx
          </h2>
          
          <div className="eer-refraction-grid">
            <div className="eer-refraction-header">
              <div></div>
              <div>Sph</div>
              <div>Cyl</div>
              <div>Axis</div>
              <div>Vision</div>
            </div>
            
            <div className="eer-refraction-row">
              <div className="eer-refraction-label">OD</div>
              <input type="text" className="eer-refraction-input" name="hb_od_sph" value={hbrx.hb_od_sph} onChange={handleHbrxChange} />
              <input type="text" className="eer-refraction-input" name="hb_od_cyl" value={hbrx.hb_od_cyl} onChange={handleHbrxChange} />
              <input type="text" className="eer-refraction-input" name="hb_od_axis" value={hbrx.hb_od_axis} onChange={handleHbrxChange} />
              <input type="text" className="eer-refraction-input" name="hb_od_vision" value={hbrx.hb_od_vision} onChange={handleHbrxChange} />
            </div>
            
            <div className="eer-refraction-row">
              <div className="eer-refraction-label">OS</div>
              <input type="text" className="eer-refraction-input" name="rx_os_sph" value={hbrx.rx_os_sph} onChange={handleHbrxChange} />
              <input type="text" className="eer-refraction-input" name="rx_os_cyl" value={hbrx.rx_os_cyl} onChange={handleHbrxChange} />
              <input type="text" className="eer-refraction-input" name="rx_os_axis" value={hbrx.rx_os_axis} onChange={handleHbrxChange} />
              <input type="text" className="eer-refraction-input" name="rx_os_vision" value={hbrx.rx_os_vision} onChange={handleHbrxChange} />
            </div>
          </div>
        </div>


              {/* Addition */}
          <div className="eer-form-group">
            <label className="eer-label">Near Vision (ADD - Hb Rx) </label>
            <textarea 
              className="eer-textarea"
              value={additionHbRx}
              onChange={(e) => setAdditionHbRx(e.target.value)}
              rows="2"
              placeholder="Enter Hb Rx addition"
            />
          </div>

        {/* Refraction */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">📐</span>
            Refraction
          </h2>
          
          <div className="eer-refraction-grid">
            <div className="eer-refraction-header">
              <div></div>
              <div>Sph</div>
              <div>Cyl</div>
              <div>Axis</div>
              <div>Vision</div>
            </div>
            
            <div className="eer-refraction-row">
              <div className="eer-refraction-label">OD</div>
              <input type="text" className="eer-refraction-input" name="od_sph" value={refraction.od_sph} onChange={handleRefractionChange} />
              <input type="text" className="eer-refraction-input" name="od_cyl" value={refraction.od_cyl} onChange={handleRefractionChange} />
              <input type="text" className="eer-refraction-input" name="od_axis" value={refraction.od_axis} onChange={handleRefractionChange} />
              <input type="text" className="eer-refraction-input" name="od_vision" value={refraction.od_vision} onChange={handleRefractionChange} />
            </div>
            
            <div className="eer-refraction-row">
              <div className="eer-refraction-label">OS</div>
              <input type="text" className="eer-refraction-input" name="os_sph" value={refraction.os_sph} onChange={handleRefractionChange} />
              <input type="text" className="eer-refraction-input" name="os_cyl" value={refraction.os_cyl} onChange={handleRefractionChange} />
              <input type="text" className="eer-refraction-input" name="os_axis" value={refraction.os_axis} onChange={handleRefractionChange} />
              <input type="text" className="eer-refraction-input" name="os_vision" value={refraction.os_vision} onChange={handleRefractionChange} />
            </div>
          </div>
        </div>


      {/* Addition */}
          <div className="eer-form-group">
            <label className="eer-label">Near Vision (ADD)</label>
            <textarea 
              className="eer-textarea"
              value={addition}
              onChange={(e) => setAddition(e.target.value)}
              rows="2"
              placeholder="Enter addition"
            />
          </div>





        {/* Follow Up */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">📅</span>
            Follow Up
          </h2>
          
          <div className="eer-form-row">
            <div className="eer-form-group eer-checkbox-group">
              <label className="eer-checkbox">
                <input 
                  type="checkbox" 
                  checked={needsFollowUp}
                  onChange={(e) => setNeedsFollowUp(e.target.checked)}
                />
                <span>Needs Follow Up</span>
              </label>
            </div>

            <div className="eer-form-group">
              <input 
                type="date" 
                className="eer-input eer-date-input"
                value={followUpDate}
                onChange={(e) => setFollowUpDate(e.target.value)}
                disabled={!needsFollowUp}
              />
            </div>
          </div>

          <div className="eer-form-group">
            <textarea 
              className="eer-textarea"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              rows={4}
              placeholder="Enter remarks"
            />
          </div>
        </div>

        <div className="eer-actions">
          <button type="submit" className="eer-btn eer-btn-primary">
            <span className="eer-btn-icon">📄</span>
            Generate Eye Exam Report
          </button>
          <button type="button" className="eer-btn eer-btn-secondary">
            <span className="eer-btn-icon">↺</span>
            Reset Form
          </button>
        </div>
      </form>
    </div>
  </div>
)}


{/************************************************ view eye exam*************************************************************/}


{selectedOption === "viewEyeExam" && (
  <div className="veer-wrapper">
    <div className="veer-container">
      
      <div className="veer-header">
        <h1 className="veer-title">
          <span className="veer-title-icon">👁️</span>
          Eye Examination Records
        </h1>
        <p className="veer-subtitle">View and manage all eye examination reports</p>
      </div>

      <div className="veer-controls">
        <div className="veer-search-wrapper">
          <span className="veer-search-icon">🔍</span>
          <input 
            type="text" 
            placeholder="Search by patient name or ID..." 
            className="veer-search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <select 
          className="veer-filter-select"
          onChange={(e) => setFilterOption(e.target.value)}
          value={filterOption}
        >
          <option value="all">📋 All Records</option>
          <option value="today">📅 Today</option>
          <option value="week">📊 This Week</option>
          <option value="month">📈 This Month</option>
        </select>
      </div>

      {filteredRecords.length === 0 ? (
        <div className="veer-empty-state">
          <div className="veer-empty-icon">📭</div>
          <h3>No examination records found</h3>
          <p>Try adjusting your search or filter criteria</p>
        </div>
      ) : (
        <div className="veer-table-wrapper">
          <table className="veer-table">
            <thead>
              <tr>
                <th>Patient Name</th>
                <th>Patient ID</th>
                <th>Date</th>
                <th>Age</th>
                <th>Chief Complaint</th>
                <th>VA (OD/OS)</th>
                <th>PD (OD/OS)</th>
                <th>SEG</th>
                <th>Refraction</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredRecords.map((record) => (
                <tr key={record.id} className="veer-row">
                  <td className="veer-cell-patient">
                    <strong>{record.patientInfo?.name}</strong>
                  </td>
                  <td className="veer-cell-id">{record.patientInfo?.id || 'N/A'}</td>
                  <td>{new Date(record.patientInfo?.date).toLocaleDateString()}</td>
                  <td>{record.patientInfo?.age || 'N/A'}</td>
                  <td className="veer-cell-complaint" title={record.history?.chiefComplaint}>
                    {record.history?.chiefComplaint?.substring(0, 30)}
                    {record.history?.chiefComplaint?.length > 30 ? '...' : ''}
                  </td>
                  <td className="veer-cell-va">
                    <span className="veer-badge-od">{record.visualAcuity?.od_cg || 'N/A'}</span>
                    <span className="veer-badge-sep">/</span>
                    <span className="veer-badge-os">{record.visualAcuity?.os_cg || 'N/A'}</span>
                  </td>
                  <td>
                    {record.visualAcuity?.od_pd || 'N/A'} / {record.visualAcuity?.os_pd || 'N/A'}
                  </td>
                  <td className="veer-cell-seg">{record.visualAcuity?.seg_va || 'N/A'}</td>
                  <td className="veer-cell-refraction">
                    {record.refraction?.od_sph || '0'} {record.refraction?.od_cyl || '0'} x {record.refraction?.od_axis || '0'}
                  </td>
                  <td>
                    <div className="veer-action-buttons">
                      <button 
                        className="veer-btn veer-btn-pdf"
                        onClick={() => generateEyeExamPDF(record)}
                        title="Download PDF Report"
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M5 20h14v-2H5v2zm7-18v10l4-4h-3V2h-2v6h-3l4 4V2z"/>
                        </svg>
                        <span>PDF</span>
                      </button>
                      <button 
                        className="veer-btn veer-btn-view"
                        onClick={() => setSelectedRecord(record)}
                        title="View Details"
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Record Detail Modal */}
      {selectedRecord && (
        <div className="veer-modal-overlay" onClick={() => setSelectedRecord(null)}>
          <div className="veer-modal" onClick={(e) => e.stopPropagation()}>
            <button className="veer-modal-close" onClick={() => setSelectedRecord(null)}>×</button>
            
            <div className="veer-modal-header">
              <h2>Eye Examination Details</h2>
              <p>Complete examination report</p>
            </div>

            <div className="veer-modal-content">
              {/* Patient Info Card */}
              <div className="veer-info-card">
                <h3>
                  <span className="veer-info-icon">👤</span>
                  Patient Information
                </h3>
                <div className="veer-info-grid">
                  <div className="veer-info-item">
                    <label>Patient Name</label>
                    <span>{selectedRecord.patientInfo?.name}</span>
                  </div>
                  <div className="veer-info-item">
                    <label>Patient ID</label>
                    <span>{selectedRecord.patientInfo?.id}</span>
                  </div>
                  <div className="veer-info-item">
                    <label>Age / Gender</label>
                    <span>{selectedRecord.patientInfo?.age} / {selectedRecord.patientInfo?.gender}</span>
                  </div>
                  <div className="veer-info-item">
                    <label>Examination Date</label>
                    <span>{new Date(selectedRecord.patientInfo?.date).toLocaleDateString()}</span>
                  </div>
                </div>
              </div>

              {/* History Card */}
              <div className="veer-info-card">
                <h3>
                  <span className="veer-info-icon">📜</span>
                  Medical History
                </h3>
                <div className="veer-history-content">
                  <div className="veer-history-item">
                    <label>Chief Complaint</label>
                    <p>{selectedRecord.history?.chiefComplaint || 'N/A'}</p>
                  </div>
                  <div className="veer-history-item">
                    <label>HPC</label>
                    <p>{selectedRecord.history?.hpc || 'N/A'}</p>
                  </div>
                  <div className="veer-history-item">
                    <label>Past Ocular History</label>
                    <p>{selectedRecord.history?.pastOcularHistory || 'N/A'}</p>
                  </div>
                  <div className="veer-history-item">
                    <label>Medical History</label>
                    <p>{selectedRecord.history?.medicalHistory || 'N/A'}</p>
                  </div>
                </div>
              </div>

              {/* Examination Card */}
              <div className="veer-info-card">
                <h3>
                  <span className="veer-info-icon">🔬</span>
                  Examination Results
                </h3>
                
                <div className="veer-exam-section">
                  <h4>Visual Acuity</h4>
                  <div className="veer-exam-grid">
                    <div className="veer-exam-item">
                      <label>OD (Right)</label>
                      <span>C/C: {selectedRecord.visualAcuity?.od_cg || 'N/A'}</span>
                      <span>S/C: {selectedRecord.visualAcuity?.od_sg || 'N/A'}</span>
                      <span>P/H: {selectedRecord.visualAcuity?.od_ph || 'N/A'}</span>
                      <span>PD: {selectedRecord.visualAcuity?.od_pd || 'N/A'}</span>
                    </div>
                    <div className="veer-exam-item">
                      <label>OS (Left)</label>
                      <span>C/C: {selectedRecord.visualAcuity?.os_cg || 'N/A'}</span>
                      <span>S/C: {selectedRecord.visualAcuity?.os_sg || 'N/A'}</span>
                      <span>P/H: {selectedRecord.visualAcuity?.os_ph || 'N/A'}</span>
                      <span>PD: {selectedRecord.visualAcuity?.os_pd || 'N/A'}</span>
                    </div>
                  </div>
                  <div className="veer-exam-item veer-full-width">
                    <label>SEG</label>
                    <span>{selectedRecord.visualAcuity?.seg_va || 'N/A'}</span>
                  </div>
                </div>

                <div className="veer-exam-section">
                  <h4>Refraction</h4>
                  <div className="veer-exam-grid">
                    <div className="veer-exam-item">
                      <label>OD (Right)</label>
                      <span>Sph: {selectedRecord.refraction?.od_sph || '0'}</span>
                      <span>Cyl: {selectedRecord.refraction?.od_cyl || '0'}</span>
                      <span>Axis: {selectedRecord.refraction?.od_axis || '0'}</span>
                      <span>Vision: {selectedRecord.refraction?.od_vision || 'N/A'}</span>
                    </div>
                    <div className="veer-exam-item">
                      <label>OS (Left)</label>
                      <span>Sph: {selectedRecord.refraction?.os_sph || '0'}</span>
                      <span>Cyl: {selectedRecord.refraction?.os_cyl || '0'}</span>
                      <span>Axis: {selectedRecord.refraction?.os_axis || '0'}</span>
                      <span>Vision: {selectedRecord.refraction?.os_vision || 'N/A'}</span>
                    </div>
                  </div>
                </div>

                {/* External Examination */}
                {selectedRecord.externalExam && (
                  <div className="veer-exam-section">
                    <h4>External Examination</h4>
                    <div className="veer-exam-grid">
                      <div className="veer-exam-item">
                        <label>Left Eye</label>
                        {selectedRecord.externalExam.lidsLeft && <span>Lids: {selectedRecord.externalExam.lidsLeft}</span>}
                        {selectedRecord.externalExam.conjunctivaLeft && <span>Conjunctiva: {selectedRecord.externalExam.conjunctivaLeft}</span>}
                        {selectedRecord.externalExam.corneaLeft && <span>Cornea: {selectedRecord.externalExam.corneaLeft}</span>}
                      </div>
                      <div className="veer-exam-item">
                        <label>Right Eye</label>
                        {selectedRecord.externalExam.lidsRight && <span>Lids: {selectedRecord.externalExam.lidsRight}</span>}
                        {selectedRecord.externalExam.conjunctivaRight && <span>Conjunctiva: {selectedRecord.externalExam.conjunctivaRight}</span>}
                        {selectedRecord.externalExam.corneaRight && <span>Cornea: {selectedRecord.externalExam.corneaRight}</span>}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <button 
                className="veer-btn veer-btn-full"
                onClick={() => generateEyeExamPDF(selectedRecord)}
              >
                <span className="veer-btn-icon">📄</span>
                Generate Complete Report
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  </div>
)}

{selectedOption === "patienteyeExam" && (
  <div className="peer-wrapper">
    <div className="peer-container">
      
      <div className="peer-header">
        <h1 className="peer-title">
          <span className="peer-title-icon">👤</span>
          Patient Eye Examination History
        </h1>
        <p className="peer-subtitle">View examination records for specific patient</p>
      </div>

      <div className="peer-controls">
        <div className="peer-search-wrapper">
          <span className="peer-search-icon">🔍</span>
          <input 
            type="text" 
            placeholder="Search patient records..." 
            className="peer-search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <select 
          className="peer-filter-select"
          onChange={(e) => setFilterOption(e.target.value)}
          value={filterOption}
        >
          <option value="all">📋 All Records</option>
          <option value="today">📅 Today</option>
          <option value="week">📊 This Week</option>
          <option value="month">📈 This Month</option>
        </select>
      </div>

      {filteredRecords.length === 0 ? (
        <div className="peer-empty-state">
          <div className="peer-empty-icon">📭</div>
          <h3>No examination records found</h3>
          <p>No eye exams have been recorded for this patient yet</p>
        </div>
      ) : (
        <div className="peer-table-wrapper">
          <table className="peer-table">
            <thead>
              <tr>
                <th>Patient Name</th>
                <th>Patient ID</th>
                <th>Date</th>
                <th>Age</th>
                <th>Chief Complaint</th>
                <th>VA (OD/OS)</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredRecords.map((record) => (
                <tr key={record.id} className="peer-row">
                  <td className="peer-cell-patient">
                    <strong>{record.patientInfo?.name}</strong>
                  </td>
                  <td className="peer-cell-id">{record.patientInfo?.id || 'N/A'}</td>
                  <td>{new Date(record.patientInfo?.date).toLocaleDateString()}</td>
                  <td>{record.patientInfo?.age || 'N/A'}</td>
                  <td className="peer-cell-complaint" title={record.history?.chiefComplaint}>
                    {record.history?.chiefComplaint?.substring(0, 40)}
                    {record.history?.chiefComplaint?.length > 40 ? '...' : ''}
                  </td>
                  <td className="peer-cell-va">
                    <span className="peer-badge-od">{record.visualAcuity?.od_cg || 'N/A'}</span>
                    <span className="peer-badge-sep">/</span>
                    <span className="peer-badge-os">{record.visualAcuity?.os_cg || 'N/A'}</span>
                  </td>
                  <td>
                    <div className="peer-action-buttons">
                      <button 
                        className="peer-btn peer-btn-pdf"
                        onClick={() => generatePatientEyeExam(record)}
                        title="Download PDF Report"
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M5 20h14v-2H5v2zm7-18v10l4-4h-3V2h-2v6h-3l4 4V2z"/>
                        </svg>
                        <span>PDF</span>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  </div>
)}

{/********************************************** Patient Follow-ups ******************************************************************/}


{/* Notification Panel */}
{selectedOption === "notification" && (
  <div className="notif-wrapper">
    <div className="notif-container">
      
      {/* Header with Filter */}
      <div className="notif-header">
        <div className="notif-header-left">
          <h2 className="notif-title">
            <span className="notif-title-icon">🔔</span>
            Patient Follow-ups
          </h2>
          <p className="notif-subtitle">Track and manage patient follow-up appointments</p>
        </div>
        
        <div className="notif-filter">
          <label className="notif-filter-label">Filter by:</label>
          <select
            value={visitFilter}
            onChange={(e) => setVisitFilter(e.target.value)}
            className="notif-filter-select"
          >
            <option value="all">All Patients</option>
            <option value="Visited">Visited</option>
            <option value="notVisited">Not Visited</option>
          </select>
        </div>
      </div>

      {error && (
        <div className="notif-error">
          <span className="notif-error-icon">⚠️</span>
          <p>{error}</p>
        </div>
      )}

      {loading ? (
        <div className="notif-loading">
          <div className="notif-spinner"></div>
          <p>Loading follow-ups...</p>
        </div>
      ) : (
        <>
          {/* OVERDUE FOLLOW-UPS */}
         <div className="notif-section notif-overdue">
  <div className="notif-section-header">
    <h3 className="notif-section-title">
      <span className="notif-section-icon">⚠️</span>
      Overdue Follow-ups
    </h3>
    <span className="notif-badge notif-badge-overdue">
      {notifications.filter(p => {
        if (!p.followUpDate) return false;
        const followUpDate = new Date(p.followUpDate);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        followUpDate.setHours(0, 0, 0, 0);
        return followUpDate < today;
      }).length}
    </span>
  </div>

  {notifications
    .filter((p) => {
      if (!p.followUpDate) return false;
      
      // Create date objects with time set to midnight
      const followUpDate = new Date(p.followUpDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      followUpDate.setHours(0, 0, 0, 0);

      // Only include if date is in the past (overdue)
      if (followUpDate >= today) return false;

      // Check status filter - make sure to use the correct field name
      const statuses = p.followupStatus || p.followUpStatus || p.status || [];
      const visited = statuses.some(
        (s) => s && (s.text === "Visited" || s.text === "Made Appointment")
      );

      if (visitFilter === "Visited") return visited;
      if (visitFilter === "notVisited") return !visited;

      return true;
    })
    .map((patient) => (
                <div key={patient.id} className="notif-card notif-card-overdue">
                  <div className="notif-card-header">
                    <div className="notif-patient-info">
                      <h4 className="notif-patient-name">{patient.name}</h4>
                      <div className="notif-patient-contacts">
                        <span className="notif-contact">
                          <span className="notif-icon">📞</span>
                          {patient.contact || patient.telephoneNo || patient.mobileNo || 'N/A'}
                        </span>
                        {patient.email && (
                          <span className="notif-contact">
                            <span className="notif-icon">📧</span>
                            {patient.email}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="notif-date-info">
                      <div className="notif-date">
                        <span className="notif-icon">📅</span>
                        {new Date(patient.followUpDate).toLocaleDateString("en-US", {
                          weekday: "short",
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })}
                      </div>
                      <div className="notif-days-overdue">
                        {Math.abs(Math.ceil((new Date() - new Date(patient.followUpDate)) / (1000 * 60 * 60 * 24)))} days overdue
                      </div>
                    </div>
                  </div>

                  {/* Notes/Description */}
                  {patient.followUpDescription && (
                    <div className="notif-notes">
                      <span className="notif-icon">📝</span>
                      {patient.followUpDescription}
                    </div>
                  )}

                  {/* STATUS SELECT */}
                  <div className="notif-status-section">
                    <div className="notif-status-selector">
                      <select
                        value={statusInput[patient.id] || ""}
                        onChange={(e) =>
                          setStatusInput({
                            ...statusInput,
                            [patient.id]: e.target.value,
                          })
                        }
                        className="notif-select"
                      >
                        <option value="">Select Status</option>
                        <option value="Not Answered">❌ Not Answered</option>
                        <option value="Made Appointment">📅 Made Appointment</option>
                        <option value="Visited">✅ Visited Clinic</option>
                        <option value="Rescheduled">🔄 Rescheduled</option>
                        <option value="Cancelled">❎ Cancelled</option>
                      </select>

                      <button
                        className="notif-btn notif-btn-add"
                        onClick={async () => {
                          if (!statusInput[patient.id]) {
                            alert("Please select a status");
                            return;
                          }

                          const newStatus = {
                            text: statusInput[patient.id],
                            date: new Date().toLocaleString(),
                          };

                          const updatedStatuses = [
                            ...(patient.followupStatus || []),
                            newStatus,
                          ];

                          try {
                            const patientRef = doc(db, "patients", patient.id);
                            await updateDoc(patientRef, {
                              followupStatus: updatedStatuses,
                            });

                            // Update local state
                            setNotifications(prevNotifications => 
                              prevNotifications.map(n => 
                                n.id === patient.id 
                                  ? { ...n, followupStatus: updatedStatuses }
                                  : n
                              )
                            );

                            setStatusInput({
                              ...statusInput,
                              [patient.id]: "",
                            });

                          } catch (error) {
                            console.error("Error saving status:", error);
                            alert("Failed to save status");
                          }
                        }}
                      >
                        <span className="notif-btn-icon">+</span>
                        Add Status
                      </button>
                    </div>

                    {/* STATUS HISTORY */}
                    {(patient.followupStatus || []).length > 0 && (
                      <div className="notif-status-history">
                        <p className="notif-history-title">Status History:</p>
                        <div className="notif-history-list">
                          {(patient.followupStatus || []).map((s, index) => (
                            <div key={index} className="notif-history-item">
                              <div className="notif-history-content">
                                <span className={`notif-status-badge notif-status-${s.text.toLowerCase().replace(/\s+/g, '-')}`}>
                                  {s.text}
                                </span>
                                <span className="notif-history-date">{s.date}</span>
                              </div>

                              <div className="notif-history-actions">
                                <button
                                  className="notif-icon-btn notif-icon-btn-edit"
                                  onClick={async () => {
                                    const newText = prompt("Edit Status", s.text);
                                    if (!newText) return;

                                    const updated = [...(patient.followupStatus || [])];
                                    updated[index].text = newText;

                                    try {
                                      const patientRef = doc(db, "patients", patient.id);
                                      await updateDoc(patientRef, {
                                        followupStatus: updated,
                                      });

                                      // Update local state
                                      setNotifications(prevNotifications => 
                                        prevNotifications.map(n => 
                                          n.id === patient.id 
                                            ? { ...n, followupStatus: updated }
                                            : n
                                        )
                                      );

                                    } catch (error) {
                                      console.error("Error updating status:", error);
                                      alert("Failed to update status");
                                    }
                                  }}
                                  title="Edit"
                                >
                                  ✏️
                                </button>

                                <button
                                  className="notif-icon-btn notif-icon-btn-delete"
                                  onClick={async () => {
                                    if (!window.confirm("Delete this status entry?")) return;

                                    const updated = (patient.followupStatus || []).filter(
                                      (_, i) => i !== index
                                    );

                                    try {
                                      const patientRef = doc(db, "patients", patient.id);
                                      await updateDoc(patientRef, {
                                        followupStatus: updated,
                                      });

                                      // Update local state
                                      setNotifications(prevNotifications => 
                                        prevNotifications.map(n => 
                                          n.id === patient.id 
                                            ? { ...n, followupStatus: updated }
                                            : n
                                        )
                                      );

                                    } catch (error) {
                                      console.error("Error deleting status:", error);
                                      alert("Failed to delete status");
                                    }
                                  }}
                                  title="Delete"
                                >
                                  🗑️
                                </button>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}

            {notifications.filter(p => {
              if (!p.followUpDate) return false;
              const followUpDate = new Date(p.followUpDate);
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              followUpDate.setHours(0, 0, 0, 0);
              return followUpDate < today;
            }).length === 0 && (
              <div className="notif-empty">
                <div className="notif-empty-icon">✨</div>
                <p>No overdue follow-ups</p>
              </div>
            )}
          </div>

          {/* TODAY'S FOLLOW-UPS */}
          <div className="notif-section notif-today">
            <div className="notif-section-header">
              <h3 className="notif-section-title">
                <span className="notif-section-icon">📌</span>
                Today's Follow-ups
              </h3>
              <span className="notif-badge notif-badge-today">
                {notifications.filter(p => {
                  if (!p.followUpDate) return false;
                  const followUpDate = new Date(p.followUpDate);
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);
                  followUpDate.setHours(0, 0, 0, 0);
                  return followUpDate.getTime() === today.getTime();
                }).length}
              </span>
            </div>

            {notifications
              .filter((p) => {
                if (!p.followUpDate) return false;
                const followUpDate = new Date(p.followUpDate);
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                followUpDate.setHours(0, 0, 0, 0);
                return followUpDate.getTime() === today.getTime();
              })
              .map((patient) => (
                <div key={patient.id} className="notif-card notif-card-today">
                  <div className="notif-card-header">
                    <div className="notif-patient-info">
                      <h4 className="notif-patient-name">{patient.name}</h4>
                      <div className="notif-patient-contacts">
                        <span className="notif-contact">
                          <span className="notif-icon">📞</span>
                          {patient.contact || patient.telephoneNo || patient.mobileNo || 'N/A'}
                        </span>
                      </div>
                    </div>
                    <div className="notif-today-badge">TODAY</div>
                  </div>
                  
                  {patient.followUpDescription && (
                    <div className="notif-notes">
                      <span className="notif-icon">📝</span>
                      {patient.followUpDescription}
                    </div>
                  )}
                  
                  {/* <button 
                    className="notif-btn notif-btn-mark"
                    onClick={async () => {
                      const newStatus = {
                        text: "Visited",
                        date: new Date().toLocaleString(),
                      };

                      const updatedStatuses = [
                        ...(patient.followupStatus || []),
                        newStatus,
                      ];

                      try {
                        const patientRef = doc(db, "patients", patient.id);
                        await updateDoc(patientRef, {
                          followupStatus: updatedStatuses,
                        });

                        // Update local state
                        setNotifications(prevNotifications => 
                          prevNotifications.map(n => 
                            n.id === patient.id 
                              ? { ...n, followupStatus: updatedStatuses }
                              : n
                          )
                        );

                      } catch (error) {
                        console.error("Error marking as visited:", error);
                      }
                    }}
                  >
                    <span className="notif-btn-icon">✓</span>
                    Mark as Visited
                  </button> */}
                </div>
              ))}

            {notifications.filter(p => {
              if (!p.followUpDate) return false;
              const followUpDate = new Date(p.followUpDate);
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              followUpDate.setHours(0, 0, 0, 0);
              return followUpDate.getTime() === today.getTime();
            }).length === 0 && (
              <div className="notif-empty">
                <div className="notif-empty-icon">📅</div>
                <p>No follow-ups scheduled for today</p>
              </div>
            )}
          </div>

          {/* UPCOMING FOLLOW-UPS */}
          <div className="notif-section notif-upcoming">
            <div className="notif-section-header">
              <h3 className="notif-section-title">
                <span className="notif-section-icon">📅</span>
                Upcoming Follow-ups
              </h3>
              <span className="notif-badge notif-badge-upcoming">
                {notifications.filter(p => {
                  if (!p.followUpDate) return false;
                  const followUpDate = new Date(p.followUpDate);
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);
                  followUpDate.setHours(0, 0, 0, 0);
                  return followUpDate > today;
                }).length}
              </span>
            </div>

            <div className="notif-upcoming-list">
              {notifications
                .filter((p) => {
                  if (!p.followUpDate) return false;
                  const followUpDate = new Date(p.followUpDate);
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);
                  followUpDate.setHours(0, 0, 0, 0);
                  return followUpDate > today;
                })
                .map((p) => {
                  const followUpDate = new Date(p.followUpDate);
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);
                  followUpDate.setHours(0, 0, 0, 0);
                  const daysRemaining = Math.ceil(
                    (followUpDate - today) / (1000 * 60 * 60 * 24)
                  );

                  return { ...p, followUpDate, daysRemaining };
                })
                .sort((a, b) => a.daysRemaining - b.daysRemaining)
                .map((patient) => {
                  const formattedDate = patient.followUpDate.toLocaleDateString(
                    "en-US",
                    {
                      weekday: "long",
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    }
                  );

                  return (
                    <div key={patient.id} className="notif-upcoming-item">
                      <div className="notif-upcoming-left">
                        <h4 className="notif-upcoming-name">{patient.name}</h4>
                        <div className="notif-upcoming-contact">
                          <span className="notif-icon">📞</span>
                          {patient.contact || patient.telephoneNo || patient.mobileNo || 'N/A'}
                        </div>
                        {patient.followUpDescription && (
                          <div className="notif-upcoming-desc">
                            <span className="notif-icon">📝</span>
                            {patient.followUpDescription}
                          </div>
                        )}
                      </div>

                      <div className="notif-upcoming-right">
                        <div className="notif-upcoming-date">
                          <span className="notif-icon">📅</span>
                          {formattedDate}
                        </div>
                        <span className={`notif-days-badge ${patient.daysRemaining <= 3 ? 'notif-days-urgent' : ''}`}>
                          {patient.daysRemaining === 0
                            ? "Today"
                            : `${patient.daysRemaining} days`}
                        </span>
                      </div>
                    </div>
                  );
                })}

              {notifications.filter(p => {
                if (!p.followUpDate) return false;
                const followUpDate = new Date(p.followUpDate);
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                followUpDate.setHours(0, 0, 0, 0);
                return followUpDate > today;
              }).length === 0 && (
                <div className="notif-empty">
                  <div className="notif-empty-icon">📆</div>
                  <p>No upcoming follow-ups scheduled</p>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  </div>
)}

             
           

      </div>
    </div>
  );
};

export default Body;
